export const ORTHO_ICD10 = [
  // ── General Orthopedic ──────────────────────────────────────────────────────
  { code: "M17.11", desc: "Primary osteoarthritis, right knee" },
  { code: "M17.12", desc: "Primary osteoarthritis, left knee" },
  { code: "M16.11", desc: "Primary osteoarthritis, right hip" },
  { code: "M16.12", desc: "Primary osteoarthritis, left hip" },
  { code: "M75.100", desc: "Unspecified rotator cuff tear, right shoulder" },
  { code: "M75.101", desc: "Unspecified rotator cuff tear, left shoulder" },
  { code: "M51.16", desc: "Intervertebral disc degeneration, lumbar region" },
  { code: "M54.5", desc: "Low back pain" },
  { code: "S82.201A", desc: "Unspecified fracture of shaft of right tibia" },
  { code: "M23.200", desc: "Derangement of unspecified meniscus due to old tear" },
  { code: "M79.621", desc: "Pain in right upper arm" },
  { code: "M25.511", desc: "Pain in right shoulder" },
  { code: "M25.561", desc: "Pain in right knee" },
  { code: "M47.816", desc: "Spondylosis without myelopathy, lumbar region" },
  { code: "M54.2", desc: "Cervicalgia" },
  { code: "S72.001A", desc: "Fracture of unspecified part of neck of right femur" },
  { code: "M84.352A", desc: "Stress fracture, left femur" },
  { code: "M62.81", desc: "Muscle weakness, shoulder region" },
  { code: "T84.01XA", desc: "Broken internal right hip prosthesis, initial" },
  { code: "Z96.641", desc: "Presence of right artificial knee joint" },

  // ── Hand & Wrist — Fractures ────────────────────────────────────────────────
  { code: "S62.001A", desc: "Fracture of navicular (scaphoid) bone, right wrist, initial" },
  { code: "S62.002A", desc: "Fracture of navicular (scaphoid) bone, left wrist, initial" },
  { code: "S62.101A", desc: "Fracture of triquetrum, right wrist, initial" },
  { code: "S62.102A", desc: "Fracture of triquetrum, left wrist, initial" },
  { code: "S62.201A", desc: "Fracture of first metacarpal, right hand, initial" },
  { code: "S62.202A", desc: "Fracture of first metacarpal, left hand, initial" },
  { code: "S62.301A", desc: "Fracture of other metacarpal, right hand, initial" },
  { code: "S62.302A", desc: "Fracture of other metacarpal, left hand, initial" },
  { code: "S62.501A", desc: "Fracture of thumb, right, initial" },
  { code: "S62.502A", desc: "Fracture of thumb, left, initial" },
  { code: "S62.601A", desc: "Fracture of proximal phalanx, right index finger, initial" },
  { code: "S62.602A", desc: "Fracture of proximal phalanx, left index finger, initial" },
  { code: "S62.611A", desc: "Fracture of middle phalanx, right index finger, initial" },
  { code: "S62.612A", desc: "Fracture of middle phalanx, left index finger, initial" },
  { code: "S62.621A", desc: "Fracture of distal phalanx, right index finger, initial" },
  { code: "S62.622A", desc: "Fracture of distal phalanx, left index finger, initial" },
  { code: "S52.501A", desc: "Fracture of distal radius, right, initial" },
  { code: "S52.502A", desc: "Fracture of distal radius, left, initial" },
  { code: "S52.001A", desc: "Fracture of olecranon process, right ulna, initial" },
  { code: "S52.002A", desc: "Fracture of olecranon process, left ulna, initial" },
  { code: "S52.101A", desc: "Fracture of proximal radius, right, initial" },
  { code: "S52.102A", desc: "Fracture of proximal radius, left, initial" },

  // ── Hand & Wrist — Arthritis & Degenerative ─────────────────────────────────
  { code: "M18.11", desc: "Primary osteoarthritis, right first carpometacarpal joint" },
  { code: "M18.12", desc: "Primary osteoarthritis, left first carpometacarpal joint" },
  { code: "M19.041", desc: "Primary osteoarthritis, right hand" },
  { code: "M19.042", desc: "Primary osteoarthritis, left hand" },
  { code: "M19.021", desc: "Primary osteoarthritis, right elbow" },
  { code: "M19.022", desc: "Primary osteoarthritis, left elbow" },
  { code: "M19.011", desc: "Primary osteoarthritis, right shoulder" },
  { code: "M19.012", desc: "Primary osteoarthritis, left shoulder" },
  { code: "M19.031", desc: "Primary osteoarthritis, right wrist" },
  { code: "M19.032", desc: "Primary osteoarthritis, left wrist" },
  { code: "M12.231", desc: "Villonodular synovitis, right wrist" },
  { code: "M12.232", desc: "Villonodular synovitis, left wrist" },

  // ── Hand & Wrist — Tendons & Ligaments ─────────────────────────────────────
  { code: "M65.311", desc: "Trigger thumb, right" },
  { code: "M65.312", desc: "Trigger thumb, left" },
  { code: "M65.321", desc: "Trigger finger, right index finger" },
  { code: "M65.322", desc: "Trigger finger, left index finger" },
  { code: "M65.331", desc: "Trigger finger, right middle finger" },
  { code: "M65.332", desc: "Trigger finger, left middle finger" },
  { code: "M65.341", desc: "Trigger finger, right ring finger" },
  { code: "M65.342", desc: "Trigger finger, left ring finger" },
  { code: "M65.351", desc: "Trigger finger, right little finger" },
  { code: "M65.352", desc: "Trigger finger, left little finger" },
  { code: "M65.41", desc: "Radial styloid tenosynovitis (de Quervain), right" },
  { code: "M65.42", desc: "Radial styloid tenosynovitis (de Quervain), left" },
  { code: "M66.241", desc: "Spontaneous rupture of extensor tendons, right hand" },
  { code: "M66.242", desc: "Spontaneous rupture of extensor tendons, left hand" },
  { code: "M66.341", desc: "Spontaneous rupture of flexor tendons, right hand" },
  { code: "M66.342", desc: "Spontaneous rupture of flexor tendons, left hand" },
  { code: "S63.401A", desc: "Traumatic rupture of ulnar collateral ligament of thumb, right, initial" },
  { code: "S63.402A", desc: "Traumatic rupture of ulnar collateral ligament of thumb, left, initial" },
  { code: "M72.0", desc: "Palmar fascial fibromatosis (Dupuytren)" },

  // ── Hand & Wrist — Nerve ────────────────────────────────────────────────────
  { code: "G56.00", desc: "Carpal tunnel syndrome, unspecified upper limb" },
  { code: "G56.01", desc: "Carpal tunnel syndrome, right upper limb" },
  { code: "G56.02", desc: "Carpal tunnel syndrome, left upper limb" },
  { code: "G56.21", desc: "Lesion of ulnar nerve, right upper limb" },
  { code: "G56.22", desc: "Lesion of ulnar nerve, left upper limb" },
  { code: "G56.31", desc: "Lesion of radial nerve, right upper limb" },
  { code: "G56.32", desc: "Lesion of radial nerve, left upper limb" },
  { code: "G54.2", desc: "Cervical root disorders (radiculopathy)" },
  { code: "G56.11", desc: "Other lesions of median nerve, right upper limb" },
  { code: "G56.12", desc: "Other lesions of median nerve, left upper limb" },
  { code: "G57.21", desc: "Lesion of femoral nerve, right lower limb" },

  // ── Elbow ───────────────────────────────────────────────────────────────────
  { code: "M77.11", desc: "Lateral epicondylitis, right elbow" },
  { code: "M77.12", desc: "Lateral epicondylitis, left elbow" },
  { code: "M77.01", desc: "Medial epicondylitis, right elbow" },
  { code: "M77.02", desc: "Medial epicondylitis, left elbow" },
  { code: "M25.421", desc: "Effusion of right elbow" },
  { code: "M25.422", desc: "Effusion of left elbow" },
  { code: "M25.321", desc: "Other instability of right elbow" },
  { code: "M25.322", desc: "Other instability of left elbow" },
  { code: "S53.001A", desc: "Unspecified dislocation of right radial head, initial" },
  { code: "S53.002A", desc: "Unspecified dislocation of left radial head, initial" },
  { code: "M70.21", desc: "Olecranon bursitis, right elbow" },
  { code: "M70.22", desc: "Olecranon bursitis, left elbow" },

  // ── Forearm ─────────────────────────────────────────────────────────────────
  { code: "S52.301A", desc: "Fracture of shaft of radius, right, initial" },
  { code: "S52.302A", desc: "Fracture of shaft of radius, left, initial" },
  { code: "S52.201A", desc: "Fracture of shaft of ulna, right, initial" },
  { code: "S52.202A", desc: "Fracture of shaft of ulna, left, initial" },

  // ── Masses & Tumors ─────────────────────────────────────────────────────────
  { code: "M71.331", desc: "Ganglion cyst, right wrist" },
  { code: "M71.332", desc: "Ganglion cyst, left wrist" },
  { code: "M71.341", desc: "Ganglion cyst, right hand" },
  { code: "M71.342", desc: "Ganglion cyst, left hand" },
  { code: "M71.351", desc: "Ganglion cyst, right hip" },
  { code: "M71.371", desc: "Ganglion cyst, right ankle and foot" },
  { code: "D21.11", desc: "Benign neoplasm of connective tissue, right upper limb" },
  { code: "D21.12", desc: "Benign neoplasm of connective tissue, left upper limb" },
  { code: "D21.9", desc: "Benign neoplasm of connective and other soft tissue, unspecified" },
  { code: "D16.141", desc: "Benign neoplasm of bones of right hand" },
  { code: "D16.142", desc: "Benign neoplasm of bones of left hand" },
  { code: "D16.121", desc: "Benign neoplasm of short bones of right upper limb" },
  { code: "D16.122", desc: "Benign neoplasm of short bones of left upper limb" },
  { code: "D16.021", desc: "Benign neoplasm of right scapula and long bones of right upper limb" },
  { code: "D16.022", desc: "Benign neoplasm of left scapula and long bones of left upper limb" },
  { code: "M79.81", desc: "Nontraumatic hematoma of soft tissue" },
  { code: "R22.31", desc: "Localized swelling, mass and lump, right upper limb" },
  { code: "R22.32", desc: "Localized swelling, mass and lump, left upper limb" },
  { code: "R22.41", desc: "Localized swelling, mass and lump, right lower limb" },
  { code: "R22.42", desc: "Localized swelling, mass and lump, left lower limb" },
  { code: "D48.11", desc: "Neoplasm of uncertain behavior, connective tissue, right upper limb" },
  { code: "D48.12", desc: "Neoplasm of uncertain behavior, connective tissue, left upper limb" },
  { code: "C49.11", desc: "Malignant neoplasm of connective tissue, right upper limb" },
  { code: "C49.12", desc: "Malignant neoplasm of connective tissue, left upper limb" },
  { code: "D17.21", desc: "Benign lipomatous neoplasm of skin, right arm" },
  { code: "D17.22", desc: "Benign lipomatous neoplasm of skin, left arm" },
  { code: "D17.71", desc: "Benign lipomatous neoplasm of other sites" },
  { code: "M67.341", desc: "Transient synovitis, right hand" },
  { code: "M67.342", desc: "Transient synovitis, left hand" },
  { code: "M89.841", desc: "Other specified disorders of bone, right hand" },
  { code: "M89.842", desc: "Other specified disorders of bone, left hand" },
  { code: "M85.441", desc: "Solitary bone cyst, right hand" },
  { code: "M85.442", desc: "Solitary bone cyst, left hand" },
  { code: "M85.421", desc: "Solitary bone cyst, right humerus" },
  { code: "M85.422", desc: "Solitary bone cyst, left humerus" },
  { code: "M85.321", desc: "Fibrous dysplasia, right upper arm" },
  { code: "M85.322", desc: "Fibrous dysplasia, left upper arm" },
  { code: "M85.341", desc: "Fibrous dysplasia, right hand" },
  { code: "M85.342", desc: "Fibrous dysplasia, left hand" },
  { code: "D18.01", desc: "Hemangioma of skin" },
  { code: "D18.09", desc: "Hemangioma of other sites" },
  { code: "Q82.5", desc: "Congenital non-neoplastic nevus" },

  // ── Infection ───────────────────────────────────────────────────────────────
  { code: "M86.141", desc: "Other acute osteomyelitis, right hand" },
  { code: "M86.142", desc: "Other acute osteomyelitis, left hand" },
  { code: "L03.011", desc: "Cellulitis of right finger" },
  { code: "L03.012", desc: "Cellulitis of left finger" },
  { code: "L03.111", desc: "Cellulitis of right hand" },
  { code: "L03.112", desc: "Cellulitis of left hand" },

  // ── MCP Joint — Arthritis & Arthroplasty ────────────────────────────────────
  { code: "M19.041", desc: "Primary osteoarthritis, right hand (MCP/IP joints)" },
  { code: "M19.042", desc: "Primary osteoarthritis, left hand (MCP/IP joints)" },
  { code: "M05.741", desc: "Rheumatoid arthritis with rheumatoid factor, right hand" },
  { code: "M05.742", desc: "Rheumatoid arthritis with rheumatoid factor, left hand" },
  { code: "M06.041", desc: "Rheumatoid arthritis without rheumatoid factor, right hand" },
  { code: "M06.042", desc: "Rheumatoid arthritis without rheumatoid factor, left hand" },
  { code: "M05.731", desc: "Rheumatoid arthritis with rheumatoid factor, right wrist" },
  { code: "M05.732", desc: "Rheumatoid arthritis with rheumatoid factor, left wrist" },
  { code: "M06.031", desc: "Rheumatoid arthritis without rheumatoid factor, right wrist" },
  { code: "M06.032", desc: "Rheumatoid arthritis without rheumatoid factor, left wrist" },
  { code: "M12.041", desc: "Chronic postrheumtic arthropathy, right hand" },
  { code: "M12.042", desc: "Chronic postrheumtic arthropathy, left hand" },
  { code: "M15.0", desc: "Primary generalized osteoarthritis" },
  { code: "M15.1", desc: "Heberden nodes with arthropathy" },
  { code: "M15.2", desc: "Bouchard nodes with arthropathy" },
  { code: "M15.3", desc: "Secondary multiple arthritis" },
  { code: "M15.9", desc: "Polyosteoarthritis, unspecified" },
  { code: "M13.141", desc: "Monoarthritis, NEC, right hand" },
  { code: "M13.142", desc: "Monoarthritis, NEC, left hand" },
  { code: "M13.121", desc: "Monoarthritis, NEC, right elbow" },
  { code: "M13.122", desc: "Monoarthritis, NEC, left elbow" },
  { code: "M13.131", desc: "Monoarthritis, NEC, right wrist" },
  { code: "M13.132", desc: "Monoarthritis, NEC, left wrist" },
  { code: "Z96.691", desc: "Presence of other orthopedic joint implant, right hand" },
  { code: "Z96.692", desc: "Presence of other orthopedic joint implant, left hand" },
  { code: "Z96.651", desc: "Presence of right artificial shoulder joint" },
  { code: "Z96.652", desc: "Presence of left artificial shoulder joint" },
  { code: "Z96.661", desc: "Presence of right artificial elbow joint" },
  { code: "Z96.662", desc: "Presence of left artificial elbow joint" },
  { code: "Z96.671", desc: "Presence of right artificial wrist joint" },
  { code: "Z96.672", desc: "Presence of left artificial wrist joint" },
  { code: "T84.091A", desc: "Other complication of internal right finger joint prosthesis, initial" },
  { code: "T84.092A", desc: "Other complication of internal left finger joint prosthesis, initial" },

  // ── Congenital & Other ──────────────────────────────────────────────────────
  { code: "Q70.00", desc: "Fused fingers, unspecified (syndactyly)" },
  { code: "Q69.0", desc: "Accessory fingers (polydactyly)" },
  { code: "M20.011", desc: "Mallet finger deformity, right finger" },
  { code: "M20.012", desc: "Mallet finger deformity, left finger" },
  { code: "M20.001", desc: "Unspecified deformity of right finger" },
  { code: "M20.002", desc: "Unspecified deformity of left finger" },
  { code: "M25.631", desc: "Stiffness of right wrist, NEC" },
  { code: "M25.632", desc: "Stiffness of left wrist, NEC" },
  { code: "M25.641", desc: "Stiffness of right hand, NEC" },
  { code: "M25.642", desc: "Stiffness of left hand, NEC" },
  { code: "M25.531", desc: "Pain in right wrist" },
  { code: "M25.532", desc: "Pain in left wrist" },
  { code: "M25.541", desc: "Pain in right hand" },
  { code: "M25.542", desc: "Pain in left hand" },
  { code: "M25.521", desc: "Pain in right elbow" },
  { code: "M25.522", desc: "Pain in left elbow" },
  { code: "M79.641", desc: "Pain in right hand" },
  { code: "M79.642", desc: "Pain in left hand" },
  { code: "M79.622", desc: "Pain in left upper arm" },
  { code: "M79.631", desc: "Pain in right forearm" },
  { code: "M79.632", desc: "Pain in left forearm" },

  // ── Shoulder — Fractures ──────────────────────────────────────────────────
  { code: "S42.001A", desc: "Fracture of clavicle, right, initial" },
  { code: "S42.002A", desc: "Fracture of clavicle, left, initial" },
  { code: "S42.201A", desc: "Fracture of upper end of humerus, right, initial" },
  { code: "S42.202A", desc: "Fracture of upper end of humerus, left, initial" },
  { code: "S42.301A", desc: "Fracture of shaft of humerus, right, initial" },
  { code: "S42.302A", desc: "Fracture of shaft of humerus, left, initial" },
  { code: "S42.401A", desc: "Fracture of lower end of humerus, right, initial" },
  { code: "S42.402A", desc: "Fracture of lower end of humerus, left, initial" },
  { code: "S42.101A", desc: "Fracture of scapula, right, initial" },
  { code: "S42.102A", desc: "Fracture of scapula, left, initial" },

  // ── Shoulder — Soft Tissue & Instability ──────────────────────────────────
  { code: "M75.00", desc: "Adhesive capsulitis of shoulder, unspecified" },
  { code: "M75.01", desc: "Adhesive capsulitis of right shoulder" },
  { code: "M75.02", desc: "Adhesive capsulitis of left shoulder" },
  { code: "M75.30", desc: "Calcific tendinitis of shoulder, unspecified" },
  { code: "M75.31", desc: "Calcific tendinitis of right shoulder" },
  { code: "M75.32", desc: "Calcific tendinitis of left shoulder" },
  { code: "M75.51", desc: "Bursitis of right shoulder" },
  { code: "M75.52", desc: "Bursitis of left shoulder" },
  { code: "M75.81", desc: "Other shoulder lesions, right" },
  { code: "M75.82", desc: "Other shoulder lesions, left" },
  { code: "S43.001A", desc: "Anterior dislocation of right shoulder, initial" },
  { code: "S43.002A", desc: "Anterior dislocation of left shoulder, initial" },
  { code: "S43.011A", desc: "Posterior dislocation of right shoulder, initial" },
  { code: "S43.012A", desc: "Posterior dislocation of left shoulder, initial" },
  { code: "S43.101A", desc: "Sprain of AC joint, right, initial" },
  { code: "S43.102A", desc: "Sprain of AC joint, left, initial" },
  { code: "M75.111", desc: "Incomplete rotator cuff tear, right shoulder" },
  { code: "M75.112", desc: "Incomplete rotator cuff tear, left shoulder" },
  { code: "M75.121", desc: "Complete rotator cuff tear, right shoulder" },
  { code: "M75.122", desc: "Complete rotator cuff tear, left shoulder" },
  { code: "M75.21", desc: "Bicipital tendinitis, right shoulder" },
  { code: "M75.22", desc: "Bicipital tendinitis, left shoulder" },
  { code: "M24.211", desc: "Disorder of ligament, right shoulder" },
  { code: "M24.212", desc: "Disorder of ligament, left shoulder" },
  { code: "M24.411", desc: "Recurrent dislocation, right shoulder" },
  { code: "M24.412", desc: "Recurrent dislocation, left shoulder" },
  { code: "M24.311", desc: "Pathological dislocation, right shoulder, NEC" },
  { code: "M24.312", desc: "Pathological dislocation, left shoulder, NEC" },

  // ── Shoulder — Arthritis & Arthroplasty ───────────────────────────────────
  { code: "M19.011", desc: "Primary osteoarthritis, right shoulder" },
  { code: "M19.012", desc: "Primary osteoarthritis, left shoulder" },
  { code: "M05.711", desc: "Rheumatoid arthritis with RF, right shoulder" },
  { code: "M05.712", desc: "Rheumatoid arthritis with RF, left shoulder" },
  { code: "Z96.611", desc: "Presence of right artificial shoulder joint" },
  { code: "Z96.612", desc: "Presence of left artificial shoulder joint" },
  { code: "T84.021A", desc: "Dislocation of internal right shoulder prosthesis, initial" },
  { code: "T84.022A", desc: "Dislocation of internal left shoulder prosthesis, initial" },

  // ── Hip — Fractures ───────────────────────────────────────────────────────
  { code: "S72.001A", desc: "Fracture of femoral neck, right, initial" },
  { code: "S72.002A", desc: "Fracture of femoral neck, left, initial" },
  { code: "S72.101A", desc: "Intertrochanteric fracture, right femur, initial" },
  { code: "S72.102A", desc: "Intertrochanteric fracture, left femur, initial" },
  { code: "S72.141A", desc: "Nondisplaced intertrochanteric fracture, right, initial" },
  { code: "S72.142A", desc: "Nondisplaced intertrochanteric fracture, left, initial" },
  { code: "S72.301A", desc: "Fracture of shaft of right femur, initial" },
  { code: "S72.302A", desc: "Fracture of shaft of left femur, initial" },
  { code: "S72.401A", desc: "Fracture of lower end of right femur, initial" },
  { code: "S72.402A", desc: "Fracture of lower end of left femur, initial" },
  { code: "M84.351A", desc: "Stress fracture, right femur, initial" },
  { code: "M84.352A", desc: "Stress fracture, left femur, initial" },
  { code: "M84.361A", desc: "Stress fracture, right tibia, initial" },
  { code: "M84.362A", desc: "Stress fracture, left tibia, initial" },

  // ── Hip — Soft Tissue & Arthritis ─────────────────────────────────────────
  { code: "M70.61", desc: "Trochanteric bursitis, right hip" },
  { code: "M70.62", desc: "Trochanteric bursitis, left hip" },
  { code: "M25.551", desc: "Pain in right hip" },
  { code: "M25.552", desc: "Pain in left hip" },
  { code: "M24.151", desc: "Contracture of right hip" },
  { code: "M24.152", desc: "Contracture of left hip" },
  { code: "M24.451", desc: "Recurrent dislocation, right hip" },
  { code: "M24.452", desc: "Recurrent dislocation, left hip" },
  { code: "Q65.01", desc: "Congenital dislocation of right hip, unilateral" },
  { code: "Q65.02", desc: "Congenital dislocation of left hip, unilateral" },
  { code: "M93.011", desc: "Acute slipped capital femoral epiphysis, right hip" },
  { code: "M93.012", desc: "Acute slipped capital femoral epiphysis, left hip" },
  { code: "M91.11", desc: "Juvenile osteochondrosis of head of femur (Legg-Calve-Perthes), right" },
  { code: "M91.12", desc: "Juvenile osteochondrosis of head of femur (Legg-Calve-Perthes), left" },
  { code: "M16.0", desc: "Bilateral primary osteoarthritis of hip" },
  { code: "M16.31", desc: "Unilateral osteoarthritis, right hip, post-traumatic" },
  { code: "M16.32", desc: "Unilateral osteoarthritis, left hip, post-traumatic" },
  { code: "M16.51", desc: "Unilateral post-traumatic osteoarthritis, right hip" },
  { code: "M16.52", desc: "Unilateral post-traumatic osteoarthritis, left hip" },
  { code: "Z96.641", desc: "Presence of right artificial hip joint" },
  { code: "Z96.642", desc: "Presence of left artificial hip joint" },
  { code: "T84.011A", desc: "Broken internal right hip prosthesis, initial" },
  { code: "T84.012A", desc: "Broken internal left hip prosthesis, initial" },
  { code: "T84.051A", desc: "Periprosthetic osteolysis, right hip, initial" },
  { code: "T84.052A", desc: "Periprosthetic osteolysis, left hip, initial" },

  // ── Knee — Fractures ──────────────────────────────────────────────────────
  { code: "S82.001A", desc: "Fracture of patella, right, initial" },
  { code: "S82.002A", desc: "Fracture of patella, left, initial" },
  { code: "S82.101A", desc: "Fracture of proximal tibia, right, initial" },
  { code: "S82.102A", desc: "Fracture of proximal tibia, left, initial" },
  { code: "S82.111A", desc: "Displaced fracture of medial tibial condyle, right, initial" },
  { code: "S82.112A", desc: "Displaced fracture of medial tibial condyle, left, initial" },
  { code: "S82.131A", desc: "Displaced fracture of lateral tibial condyle, right, initial" },
  { code: "S82.132A", desc: "Displaced fracture of lateral tibial condyle, left, initial" },
  { code: "S82.201A", desc: "Fracture of shaft of tibia, right, initial" },
  { code: "S82.202A", desc: "Fracture of shaft of tibia, left, initial" },
  { code: "S82.401A", desc: "Fracture of lower end of fibula, right, initial" },
  { code: "S82.402A", desc: "Fracture of lower end of fibula, left, initial" },

  // ── Knee — Soft Tissue ────────────────────────────────────────────────────
  { code: "M23.201", desc: "Derangement of medial meniscus, right knee, due to old tear" },
  { code: "M23.202", desc: "Derangement of medial meniscus, left knee, due to old tear" },
  { code: "M23.211", desc: "Derangement of lateral meniscus, right knee, due to old tear" },
  { code: "M23.212", desc: "Derangement of lateral meniscus, left knee, due to old tear" },
  { code: "S83.201A", desc: "Tear of medial meniscus, current injury, right knee, initial" },
  { code: "S83.202A", desc: "Tear of medial meniscus, current injury, left knee, initial" },
  { code: "M23.611", desc: "Other spontaneous disruption of ACL, right knee" },
  { code: "M23.612", desc: "Other spontaneous disruption of ACL, left knee" },
  { code: "S83.511A", desc: "Sprain of ACL, right knee, initial" },
  { code: "S83.512A", desc: "Sprain of ACL, left knee, initial" },
  { code: "S83.421A", desc: "Sprain of MCL, right knee, initial" },
  { code: "S83.422A", desc: "Sprain of MCL, left knee, initial" },
  { code: "M23.621", desc: "Other spontaneous disruption of PCL, right knee" },
  { code: "M23.622", desc: "Other spontaneous disruption of PCL, left knee" },
  { code: "M22.41", desc: "Chondromalacia patellae, right knee" },
  { code: "M22.42", desc: "Chondromalacia patellae, left knee" },
  { code: "M22.11", desc: "Recurrent dislocation of patella, right knee" },
  { code: "M22.12", desc: "Recurrent dislocation of patella, left knee" },
  { code: "M22.21", desc: "Patellofemoral syndrome, right knee" },
  { code: "M22.22", desc: "Patellofemoral syndrome, left knee" },
  { code: "M70.41", desc: "Prepatellar bursitis, right knee" },
  { code: "M70.42", desc: "Prepatellar bursitis, left knee" },
  { code: "M71.21", desc: "Synovial cyst of popliteal space (Baker cyst), right knee" },
  { code: "M71.22", desc: "Synovial cyst of popliteal space (Baker cyst), left knee" },
  { code: "M25.361", desc: "Stiffness of right knee, NEC" },
  { code: "M25.362", desc: "Stiffness of left knee, NEC" },
  { code: "M76.51", desc: "Patellar tendinitis, right knee" },
  { code: "M76.52", desc: "Patellar tendinitis, left knee" },
  { code: "M92.41", desc: "Juvenile osteochondrosis of patella, right knee" },
  { code: "M92.42", desc: "Juvenile osteochondrosis of patella, left knee" },
  { code: "M93.211", desc: "Osteochondritis dissecans, right knee" },
  { code: "M93.212", desc: "Osteochondritis dissecans, left knee" },

  // ── Knee — Arthritis & Arthroplasty ───────────────────────────────────────
  { code: "M17.0", desc: "Bilateral primary osteoarthritis of knee" },
  { code: "M17.31", desc: "Post-traumatic osteoarthritis, right knee" },
  { code: "M17.32", desc: "Post-traumatic osteoarthritis, left knee" },
  { code: "Z96.651", desc: "Presence of right artificial knee joint" },
  { code: "Z96.652", desc: "Presence of left artificial knee joint" },
  { code: "T84.031A", desc: "Mechanical loosening of internal right knee prosthetic joint, initial" },
  { code: "T84.032A", desc: "Mechanical loosening of internal left knee prosthetic joint, initial" },

  // ── Foot & Ankle — Fractures ──────────────────────────────────────────────
  { code: "S82.811A", desc: "Fracture of upper fibula, right, initial" },
  { code: "S82.812A", desc: "Fracture of upper fibula, left, initial" },
  { code: "S82.831A", desc: "Other fracture of lower leg, right, initial" },
  { code: "S82.832A", desc: "Other fracture of lower leg, left, initial" },
  { code: "S82.851A", desc: "Displaced trimalleolar fracture, right ankle, initial" },
  { code: "S82.852A", desc: "Displaced trimalleolar fracture, left ankle, initial" },
  { code: "S82.861A", desc: "Displaced Maisonneuve fracture, right, initial" },
  { code: "S82.862A", desc: "Displaced Maisonneuve fracture, left, initial" },
  { code: "S92.001A", desc: "Fracture of calcaneus, right, initial" },
  { code: "S92.002A", desc: "Fracture of calcaneus, left, initial" },
  { code: "S92.101A", desc: "Fracture of talus, right, initial" },
  { code: "S92.102A", desc: "Fracture of talus, left, initial" },
  { code: "S92.201A", desc: "Fracture of navicular, right foot, initial" },
  { code: "S92.202A", desc: "Fracture of navicular, left foot, initial" },
  { code: "S92.301A", desc: "Fracture of cuboid, right foot, initial" },
  { code: "S92.302A", desc: "Fracture of cuboid, left foot, initial" },
  { code: "S92.501A", desc: "Fracture of proximal phalanx of right great toe, initial" },
  { code: "S92.502A", desc: "Fracture of proximal phalanx of left great toe, initial" },
  { code: "S96.001A", desc: "Fracture of 5th metatarsal, right, initial (Jones fracture)" },
  { code: "S96.002A", desc: "Fracture of 5th metatarsal, left, initial (Jones fracture)" },
  { code: "M84.371A", desc: "Stress fracture, right ankle, initial" },
  { code: "M84.372A", desc: "Stress fracture, left ankle, initial" },
  { code: "M84.374A", desc: "Stress fracture, right fibula, initial" },
  { code: "M84.375A", desc: "Stress fracture, left fibula, initial" },

  // ── Foot & Ankle — Soft Tissue ────────────────────────────────────────────
  { code: "M79.671", desc: "Pain in right foot" },
  { code: "M79.672", desc: "Pain in left foot" },
  { code: "M25.371", desc: "Stiffness of right ankle, NEC" },
  { code: "M25.372", desc: "Stiffness of left ankle, NEC" },
  { code: "M25.571", desc: "Pain in right ankle" },
  { code: "M25.572", desc: "Pain in left ankle" },
  { code: "M77.31", desc: "Calcaneal spur, right foot" },
  { code: "M77.32", desc: "Calcaneal spur, left foot" },
  { code: "M72.2", desc: "Plantar fascial fibromatosis (plantar fasciitis)" },
  { code: "M77.41", desc: "Metatarsalgia, right foot" },
  { code: "M77.42", desc: "Metatarsalgia, left foot" },
  { code: "G57.61", desc: "Lesion of plantar nerve, right lower limb (Morton neuroma)" },
  { code: "G57.62", desc: "Lesion of plantar nerve, left lower limb (Morton neuroma)" },
  { code: "M20.11", desc: "Hallux valgus (bunion), right foot" },
  { code: "M20.12", desc: "Hallux valgus (bunion), left foot" },
  { code: "M20.31", desc: "Hallux varus deformity, right foot" },
  { code: "M20.32", desc: "Hallux varus deformity, left foot" },
  { code: "M20.41", desc: "Other hammer toe deformity, right foot" },
  { code: "M20.42", desc: "Other hammer toe deformity, left foot" },
  { code: "M20.51", desc: "Acquired clawfoot, right foot" },
  { code: "M20.52", desc: "Acquired clawfoot, left foot" },
  { code: "M76.61", desc: "Achilles tendinitis, right leg" },
  { code: "M76.62", desc: "Achilles tendinitis, left leg" },
  { code: "M66.361", desc: "Spontaneous rupture of Achilles tendon, right" },
  { code: "M66.362", desc: "Spontaneous rupture of Achilles tendon, left" },
  { code: "S86.011A", desc: "Complete rupture of Achilles tendon, right, initial" },
  { code: "S86.012A", desc: "Complete rupture of Achilles tendon, left, initial" },
  { code: "S93.401A", desc: "Sprain of deltoid ligament, right ankle, initial" },
  { code: "S93.402A", desc: "Sprain of deltoid ligament, left ankle, initial" },
  { code: "S93.411A", desc: "Sprain of calcaneofibular ligament, right ankle, initial" },
  { code: "S93.412A", desc: "Sprain of calcaneofibular ligament, left ankle, initial" },
  { code: "M19.071", desc: "Primary osteoarthritis, right ankle and foot" },
  { code: "M19.072", desc: "Primary osteoarthritis, left ankle and foot" },
  { code: "M65.871", desc: "Other synovitis/tenosynovitis, right ankle and foot" },
  { code: "M65.872", desc: "Other synovitis/tenosynovitis, left ankle and foot" },
  { code: "M76.71", desc: "Peroneal tendinitis, right leg" },
  { code: "M76.72", desc: "Peroneal tendinitis, left leg" },
  { code: "M76.891", desc: "Other enthesopathies, right lower limb" },
  { code: "M76.892", desc: "Other enthesopathies, left lower limb" },

  // ── Spine — Cervical ──────────────────────────────────────────────────────
  { code: "M50.00", desc: "Cervical disc disorder with myelopathy, unspecified level" },
  { code: "M50.10", desc: "Cervical disc degeneration, unspecified level" },
  { code: "M50.11", desc: "Cervical disc degeneration, high cervical region" },
  { code: "M50.12", desc: "Cervical disc degeneration, mid-cervical region" },
  { code: "M50.13", desc: "Cervical disc degeneration, cervicothoracic region" },
  { code: "M50.20", desc: "Other cervical disc displacement, unspecified level" },
  { code: "M50.21", desc: "Other cervical disc displacement, high cervical region" },
  { code: "M50.22", desc: "Other cervical disc displacement, mid-cervical region" },
  { code: "M50.30", desc: "Other cervical disc degeneration, unspecified level" },
  { code: "M47.812", desc: "Spondylosis without myelopathy, cervical region" },
  { code: "M47.22", desc: "Anterior spinal artery compression syndromes, cervical region" },
  { code: "M48.02", desc: "Spinal stenosis, cervical region" },
  { code: "M43.12", desc: "Spondylolisthesis, cervical region" },
  { code: "M54.12", desc: "Radiculopathy, cervical region" },
  { code: "S14.101A", desc: "Injury of cervical spinal cord, C1 level, initial" },
  { code: "S12.000A", desc: "Fracture of first cervical vertebra, initial" },
  { code: "S12.100A", desc: "Fracture of second cervical vertebra, initial" },
  { code: "S12.200A", desc: "Fracture of third cervical vertebra, initial" },
  { code: "S12.300A", desc: "Fracture of fourth cervical vertebra, initial" },

  // ── Spine — Thoracic & Lumbar ─────────────────────────────────────────────
  { code: "M51.14", desc: "Disc degeneration with radiculopathy, thoracic region" },
  { code: "M51.15", desc: "Disc degeneration with radiculopathy, thoracolumbar region" },
  { code: "M51.16", desc: "Disc degeneration with radiculopathy, lumbar region" },
  { code: "M51.17", desc: "Disc degeneration with radiculopathy, lumbosacral region" },
  { code: "M51.06", desc: "Disc disorder with myelopathy, lumbar region" },
  { code: "M48.06", desc: "Spinal stenosis, lumbar region" },
  { code: "M48.07", desc: "Spinal stenosis, lumbosacral region" },
  { code: "M43.16", desc: "Spondylolisthesis, lumbar region" },
  { code: "M43.17", desc: "Spondylolisthesis, lumbosacral region" },
  { code: "M54.16", desc: "Radiculopathy, lumbar region" },
  { code: "M54.17", desc: "Radiculopathy, lumbosacral region" },
  { code: "M54.4", desc: "Lumbago with sciatica" },
  { code: "M54.41", desc: "Lumbago with sciatica, right side" },
  { code: "M54.42", desc: "Lumbago with sciatica, left side" },
  { code: "M54.51", desc: "Vertebrogenic low back pain" },
  { code: "M54.59", desc: "Other low back pain" },
  { code: "M47.816", desc: "Spondylosis without myelopathy, lumbar region" },
  { code: "M47.817", desc: "Spondylosis without myelopathy, lumbosacral region" },
  { code: "M47.818", desc: "Spondylosis without myelopathy, sacral region" },
  { code: "S32.001A", desc: "Fracture of L1 vertebra, initial" },
  { code: "S32.011A", desc: "Fracture of L2 vertebra, initial" },
  { code: "S32.021A", desc: "Fracture of L3 vertebra, initial" },
  { code: "S32.031A", desc: "Fracture of L4 vertebra, initial" },
  { code: "S32.041A", desc: "Fracture of L5 vertebra, initial" },
  { code: "S22.001A", desc: "Fracture of T1 vertebra, initial" },
  { code: "S22.021A", desc: "Fracture of T3 vertebra, initial" },
  { code: "M48.51XA", desc: "Vertebral fracture, not elsewhere classified, C1, initial" },
  { code: "M48.56XA", desc: "Vertebral fracture, NEC, lumbar region, initial" },
  { code: "M80.071A", desc: "Age-related osteoporosis with vertebral fracture, right, initial" },
  { code: "M80.072A", desc: "Age-related osteoporosis with vertebral fracture, left, initial" },
  { code: "M41.00", desc: "Infantile idiopathic scoliosis, site unspecified" },
  { code: "M41.20", desc: "Other idiopathic scoliosis, site unspecified" },
  { code: "M41.26", desc: "Other idiopathic scoliosis, lumbar region" },
  { code: "M40.00", desc: "Postural kyphosis, site unspecified" },
  { code: "M40.10", desc: "Other secondary kyphosis, site unspecified" },
  { code: "M40.56", desc: "Lordosis, lumbar region" },
  { code: "M43.00", desc: "Spondylolysis, site unspecified" },
  { code: "M43.06", desc: "Spondylolysis, lumbar region" },
  { code: "M96.1", desc: "Postlaminectomy syndrome, NEC" },

  // ── Pediatric Orthopedics ─────────────────────────────────────────────────
  { code: "M92.00", desc: "Juvenile osteochondrosis of humerus, unspecified arm" },
  { code: "M92.10", desc: "Juvenile osteochondrosis of radius and ulna" },
  { code: "M92.21", desc: "Juvenile osteochondrosis of hand, right" },
  { code: "M92.22", desc: "Juvenile osteochondrosis of hand, left" },
  { code: "M92.31", desc: "Juvenile osteochondrosis of lower leg, right" },
  { code: "M92.32", desc: "Juvenile osteochondrosis of lower leg, left" },
  { code: "M92.51", desc: "Juvenile osteochondrosis of tibia and fibula, right" },
  { code: "M92.52", desc: "Juvenile osteochondrosis of tibia and fibula, left" },
  { code: "M92.61", desc: "Juvenile osteochondrosis of tarsus, right" },
  { code: "M92.62", desc: "Juvenile osteochondrosis of tarsus, left" },
  { code: "M92.71", desc: "Juvenile osteochondrosis of metatarsus, right" },
  { code: "M92.72", desc: "Juvenile osteochondrosis of metatarsus, left" },
  { code: "M93.001", desc: "Unspecified slipped upper femoral epiphysis, right hip" },
  { code: "M93.002", desc: "Unspecified slipped upper femoral epiphysis, left hip" },
  { code: "Q65.81", desc: "Congenital coxa valga" },
  { code: "Q65.82", desc: "Congenital coxa vara" },
  { code: "Q66.00", desc: "Congenital talipes equinovarus, unspecified foot" },
  { code: "Q66.01", desc: "Congenital talipes equinovarus, right foot" },
  { code: "Q66.02", desc: "Congenital talipes equinovarus, left foot" },
  { code: "Q66.10", desc: "Congenital talipes calcaneovarus, unspecified foot" },
  { code: "Q66.40", desc: "Congenital talipes calcaneovalgus, unspecified foot" },
  { code: "Q66.70", desc: "Congenital pes cavus, unspecified foot" },
  { code: "Q66.89", desc: "Other specified congenital deformities of feet" },
  { code: "M21.011", desc: "Valgus deformity, right hip" },
  { code: "M21.012", desc: "Valgus deformity, left hip" },
  { code: "M21.061", desc: "Valgus deformity, right knee" },
  { code: "M21.062", desc: "Valgus deformity, left knee" },
  { code: "M21.161", desc: "Varus deformity, right knee" },
  { code: "M21.162", desc: "Varus deformity, left knee" },

  // ── Metabolic Bone Disease & Osteoporosis ─────────────────────────────────
  { code: "M81.0", desc: "Age-related osteoporosis without current pathological fracture" },
  { code: "M81.6", desc: "Localized osteoporosis (Lequesne)" },
  { code: "M80.00XA", desc: "Age-related osteoporosis with current pathological fracture, initial" },
  { code: "M80.80XA", desc: "Other osteoporosis with current pathological fracture, initial" },
  { code: "M82.80", desc: "Osteoporosis in other diseases classified elsewhere" },
  { code: "E55.9", desc: "Vitamin D deficiency, unspecified" },
  { code: "M83.9", desc: "Adult osteomalacia, unspecified" },
  { code: "M85.80", desc: "Other specified disorders of bone density and structure" },
  { code: "M88.9", desc: "Osteitis deformans (Paget disease) of bone, unspecified" },
  { code: "M87.011", desc: "Idiopathic aseptic necrosis of right shoulder" },
  { code: "M87.012", desc: "Idiopathic aseptic necrosis of left shoulder" },
  { code: "M87.021", desc: "Idiopathic aseptic necrosis of right humerus" },
  { code: "M87.022", desc: "Idiopathic aseptic necrosis of left humerus" },
  { code: "M87.031", desc: "Idiopathic aseptic necrosis of right radius" },
  { code: "M87.032", desc: "Idiopathic aseptic necrosis of left radius" },
  { code: "M87.041", desc: "Idiopathic aseptic necrosis of right hand" },
  { code: "M87.042", desc: "Idiopathic aseptic necrosis of left hand" },
  { code: "M87.051", desc: "Idiopathic aseptic necrosis of right hip" },
  { code: "M87.052", desc: "Idiopathic aseptic necrosis of left hip" },
  { code: "M87.061", desc: "Idiopathic aseptic necrosis of right knee" },
  { code: "M87.062", desc: "Idiopathic aseptic necrosis of left knee" },
  { code: "M87.071", desc: "Idiopathic aseptic necrosis of right ankle and foot" },
  { code: "M87.072", desc: "Idiopathic aseptic necrosis of left ankle and foot" },

  // ── Infection & Septic Arthritis ──────────────────────────────────────────
  { code: "M00.011", desc: "Staphylococcal arthritis, right shoulder" },
  { code: "M00.012", desc: "Staphylococcal arthritis, left shoulder" },
  { code: "M00.041", desc: "Staphylococcal arthritis, right hand" },
  { code: "M00.042", desc: "Staphylococcal arthritis, left hand" },
  { code: "M00.051", desc: "Staphylococcal arthritis, right hip" },
  { code: "M00.052", desc: "Staphylococcal arthritis, left hip" },
  { code: "M00.061", desc: "Staphylococcal arthritis, right knee" },
  { code: "M00.062", desc: "Staphylococcal arthritis, left knee" },
  { code: "M86.011", desc: "Acute hematogenous osteomyelitis, right shoulder" },
  { code: "M86.012", desc: "Acute hematogenous osteomyelitis, left shoulder" },
  { code: "M86.051", desc: "Acute hematogenous osteomyelitis, right femur" },
  { code: "M86.052", desc: "Acute hematogenous osteomyelitis, left femur" },
  { code: "M86.061", desc: "Acute hematogenous osteomyelitis, right tibia" },
  { code: "M86.062", desc: "Acute hematogenous osteomyelitis, left tibia" },
  { code: "T84.50XA", desc: "Infection due to unspecified internal joint prosthesis, initial" },
  { code: "T84.51XA", desc: "Infection due to internal right hip prosthesis, initial" },
  { code: "T84.52XA", desc: "Infection due to internal left hip prosthesis, initial" },
  { code: "T84.53XA", desc: "Infection due to internal right knee prosthesis, initial" },
  { code: "T84.54XA", desc: "Infection due to internal left knee prosthesis, initial" },
  { code: "T84.59XA", desc: "Infection due to other internal joint prosthesis, initial" },

  // ── Inflammatory Arthritis & Systemic ─────────────────────────────────────
  { code: "M05.70", desc: "Rheumatoid arthritis with rheumatoid factor, unspecified site" },
  { code: "M06.00", desc: "Rheumatoid arthritis without rheumatoid factor, unspecified" },
  { code: "M08.00", desc: "Unspecified juvenile rheumatoid arthritis, unspecified site" },
  { code: "M10.00", desc: "Idiopathic gout, unspecified site" },
  { code: "M10.011", desc: "Idiopathic gout, right shoulder" },
  { code: "M10.041", desc: "Idiopathic gout, right hand" },
  { code: "M10.042", desc: "Idiopathic gout, left hand" },
  { code: "M10.061", desc: "Idiopathic gout, right knee" },
  { code: "M10.062", desc: "Idiopathic gout, left knee" },
  { code: "M11.011", desc: "Hydroxyapatite deposition disease, right shoulder" },
  { code: "M11.041", desc: "Hydroxyapatite deposition disease, right hand" },
  { code: "M11.061", desc: "Hydroxyapatite deposition disease, right knee" },
  { code: "M11.211", desc: "Other chondrocalcinosis, right shoulder" },
  { code: "M11.241", desc: "Other chondrocalcinosis, right hand" },
  { code: "M45.0", desc: "Ankylosing spondylitis of multiple sites in spine" },
  { code: "M45.6", desc: "Ankylosing spondylitis, lumbar region" },
  { code: "L40.50", desc: "Arthropathic psoriasis, unspecified" },
  { code: "L40.51", desc: "Distal interphalangeal psoriatic arthropathy" },
  { code: "L40.52", desc: "Psoriatic arthritis mutilans" },
  { code: "M35.00", desc: "Sicca syndrome (Sjogren), unspecified" },
  { code: "M34.9", desc: "Systemic sclerosis, unspecified" },
  { code: "M32.9", desc: "Systemic lupus erythematosus, unspecified" },

  // ── Soft Tissue & Miscellaneous ───────────────────────────────────────────
  { code: "M79.1", desc: "Myalgia" },
  { code: "M79.3", desc: "Panniculitis, unspecified" },
  { code: "M79.7", desc: "Fibromyalgia" },
  { code: "M60.001", desc: "Infective myositis, right shoulder" },
  { code: "M60.002", desc: "Infective myositis, left shoulder" },
  { code: "M61.011", desc: "Myositis ossificans traumatica, right shoulder" },
  { code: "M61.012", desc: "Myositis ossificans traumatica, left shoulder" },
  { code: "M61.041", desc: "Myositis ossificans traumatica, right hand" },
  { code: "M61.042", desc: "Myositis ossificans traumatica, left hand" },
  { code: "M70.00", desc: "Crepitant synovitis, unspecified hand and wrist" },
  { code: "M70.01", desc: "Crepitant synovitis, right hand and wrist" },
  { code: "M70.02", desc: "Crepitant synovitis, left hand and wrist" },
  { code: "M79.A11", desc: "Nontraumatic compartment syndrome, right upper extremity" },
  { code: "M79.A12", desc: "Nontraumatic compartment syndrome, left upper extremity" },
  { code: "M79.A21", desc: "Nontraumatic compartment syndrome, right lower extremity" },
  { code: "M79.A22", desc: "Nontraumatic compartment syndrome, left lower extremity" },
  { code: "T79.A11A", desc: "Traumatic compartment syndrome, right upper extremity, initial" },
  { code: "T79.A12A", desc: "Traumatic compartment syndrome, left upper extremity, initial" },
  { code: "T79.A21A", desc: "Traumatic compartment syndrome, right lower extremity, initial" },
  { code: "T79.A22A", desc: "Traumatic compartment syndrome, left lower extremity, initial" },

  // ── Shoulder — Additional ─────────────────────────────────────────────────
  { code: "M75.40", desc: "Impingement syndrome of shoulder, unspecified" },
  { code: "M75.41", desc: "Impingement syndrome of right shoulder" },
  { code: "M75.42", desc: "Impingement syndrome of left shoulder" },
  { code: "M75.61", desc: "Snapping scapula syndrome, right" },
  { code: "M75.62", desc: "Snapping scapula syndrome, left" },
  { code: "M75.91", desc: "Shoulder lesion, unspecified, right" },
  { code: "M75.92", desc: "Shoulder lesion, unspecified, left" },
  { code: "M24.811", desc: "Other specified joint disorders, right shoulder" },
  { code: "M24.812", desc: "Other specified joint disorders, left shoulder" },
  { code: "M25.011", desc: "Hemarthrosis, right shoulder" },
  { code: "M25.012", desc: "Hemarthrosis, left shoulder" },
  { code: "M25.211", desc: "Flail joint, right shoulder" },
  { code: "M25.212", desc: "Flail joint, left shoulder" },
  { code: "M25.311", desc: "Other instability of right shoulder" },
  { code: "M25.312", desc: "Other instability of left shoulder" },
  { code: "S40.011A", desc: "Contusion of right shoulder, initial" },
  { code: "S40.012A", desc: "Contusion of left shoulder, initial" },
  { code: "S40.021A", desc: "Contusion of right upper arm, initial" },
  { code: "S40.022A", desc: "Contusion of left upper arm, initial" },
  { code: "S46.011A", desc: "Strain of muscle(s) and tendon(s) of rotator cuff, right, initial" },
  { code: "S46.012A", desc: "Strain of muscle(s) and tendon(s) of rotator cuff, left, initial" },
  { code: "S46.211A", desc: "Strain of muscle and tendon of biceps, right, initial" },
  { code: "S46.212A", desc: "Strain of muscle and tendon of biceps, left, initial" },
  { code: "M67.211", desc: "Synovial hypertrophy, right shoulder" },
  { code: "M67.212", desc: "Synovial hypertrophy, left shoulder" },
  { code: "M65.211", desc: "Calcific tendinitis, right shoulder" },
  { code: "M65.212", desc: "Calcific tendinitis, left shoulder" },

  // ── Elbow — Additional ────────────────────────────────────────────────────
  { code: "M25.421", desc: "Effusion, right elbow" },
  { code: "M25.422", desc: "Effusion, left elbow" },
  { code: "M25.221", desc: "Flail joint, right elbow" },
  { code: "M25.222", desc: "Flail joint, left elbow" },
  { code: "M24.221", desc: "Disorder of ligament, right elbow" },
  { code: "M24.222", desc: "Disorder of ligament, left elbow" },
  { code: "M24.321", desc: "Pathological dislocation of right elbow, NEC" },
  { code: "M24.322", desc: "Pathological dislocation of left elbow, NEC" },
  { code: "M24.421", desc: "Recurrent dislocation, right elbow" },
  { code: "M24.422", desc: "Recurrent dislocation, left elbow" },
  { code: "M25.021", desc: "Hemarthrosis, right elbow" },
  { code: "M25.022", desc: "Hemarthrosis, left elbow" },
  { code: "M25.121", desc: "Fistula, right elbow" },
  { code: "M25.122", desc: "Fistula, left elbow" },
  { code: "M93.221", desc: "Osteochondritis dissecans, right elbow" },
  { code: "M93.222", desc: "Osteochondritis dissecans, left elbow" },
  { code: "S50.011A", desc: "Contusion of right elbow, initial" },
  { code: "S50.012A", desc: "Contusion of left elbow, initial" },
  { code: "S50.021A", desc: "Contusion of right forearm, initial" },
  { code: "S50.022A", desc: "Contusion of left forearm, initial" },
  { code: "S53.101A", desc: "Unspecified dislocation of right ulnohumeral joint, initial" },
  { code: "S53.102A", desc: "Unspecified dislocation of left ulnohumeral joint, initial" },
  { code: "M65.221", desc: "Calcific tendinitis, right upper arm" },
  { code: "M65.222", desc: "Calcific tendinitis, left upper arm" },
  { code: "M66.121", desc: "Rupture of synovium, right elbow" },
  { code: "M66.122", desc: "Rupture of synovium, left elbow" },

  // ── Wrist & Hand — Additional ─────────────────────────────────────────────
  // ── TFCC & DRUJ ──────────────────────────────────────────────────────────────
  { code: "M25.331", desc: "TFCC tear, right wrist (other instability of right wrist)" },
  { code: "M25.332", desc: "TFCC tear, left wrist (other instability of left wrist)" },
  { code: "S63.031A", desc: "Traumatic tear of TFCC, right wrist, initial" },
  { code: "S63.032A", desc: "Traumatic tear of TFCC, left wrist, initial" },
  { code: "M24.831", desc: "Other specified joint disorders, right wrist (DRUJ instability)" },
  { code: "M24.832", desc: "Other specified joint disorders, left wrist (DRUJ instability)" },
  { code: "S63.071A", desc: "Dislocation of DRUJ, right wrist, initial" },
  { code: "S63.072A", desc: "Dislocation of DRUJ, left wrist, initial" },
  { code: "M25.031", desc: "Hemarthrosis, right wrist" },
  { code: "M25.032", desc: "Hemarthrosis, left wrist" },
  { code: "M25.041", desc: "Hemarthrosis, right hand" },
  { code: "M25.042", desc: "Hemarthrosis, left hand" },
  { code: "M25.131", desc: "Fistula, right wrist" },
  { code: "M25.132", desc: "Fistula, left wrist" },
  { code: "M25.231", desc: "Flail joint, right wrist" },
  { code: "M25.232", desc: "Flail joint, left wrist" },
  { code: "M25.331", desc: "Other instability, right wrist" },
  { code: "M25.332", desc: "Other instability, left wrist" },
  { code: "M24.131", desc: "Loose body in right wrist" },
  { code: "M24.132", desc: "Loose body in left wrist" },
  { code: "M24.141", desc: "Loose body in right hand" },
  { code: "M24.142", desc: "Loose body in left hand" },
  { code: "M24.231", desc: "Disorder of ligament, right wrist" },
  { code: "M24.232", desc: "Disorder of ligament, left wrist" },
  { code: "M24.241", desc: "Disorder of ligament, right hand" },
  { code: "M24.242", desc: "Disorder of ligament, left hand" },
  { code: "S60.011A", desc: "Contusion of right thumb, initial" },
  { code: "S60.012A", desc: "Contusion of left thumb, initial" },
  { code: "S60.021A", desc: "Contusion of right index finger, initial" },
  { code: "S60.022A", desc: "Contusion of left index finger, initial" },
  { code: "S60.211A", desc: "Contusion of right wrist, initial" },
  { code: "S60.212A", desc: "Contusion of left wrist, initial" },
  { code: "S60.221A", desc: "Contusion of right hand, initial" },
  { code: "S60.222A", desc: "Contusion of left hand, initial" },
  { code: "S63.001A", desc: "Unspecified dislocation of right wrist, initial" },
  { code: "S63.002A", desc: "Unspecified dislocation of left wrist, initial" },
  { code: "S63.011A", desc: "Subluxation of right radiocarpal joint, initial" },
  { code: "S63.012A", desc: "Subluxation of left radiocarpal joint, initial" },
  { code: "S63.031A", desc: "Subluxation of right midcarpal joint, initial" },
  { code: "S63.032A", desc: "Subluxation of left midcarpal joint, initial" },
  { code: "S63.041A", desc: "Subluxation of right CMC joint, initial" },
  { code: "S63.042A", desc: "Subluxation of left CMC joint, initial" },
  { code: "M65.831", desc: "Other synovitis and tenosynovitis, right wrist" },
  { code: "M65.832", desc: "Other synovitis and tenosynovitis, left wrist" },
  { code: "M65.841", desc: "Other synovitis and tenosynovitis, right hand" },
  { code: "M65.842", desc: "Other synovitis and tenosynovitis, left hand" },
  { code: "M67.431", desc: "Ganglion, right wrist" },
  { code: "M67.432", desc: "Ganglion, left wrist" },
  { code: "M67.441", desc: "Ganglion, right hand" },
  { code: "M67.442", desc: "Ganglion, left hand" },
  { code: "M70.031", desc: "Crepitant synovitis, right wrist" },
  { code: "M70.032", desc: "Crepitant synovitis, left wrist" },
  { code: "M70.041", desc: "Crepitant synovitis, right hand" },
  { code: "M70.042", desc: "Crepitant synovitis, left hand" },

  // ── Hip — Additional ──────────────────────────────────────────────────────
  { code: "M24.051", desc: "Loose body in right hip" },
  { code: "M24.052", desc: "Loose body in left hip" },
  { code: "M24.151", desc: "Contracture, right hip" },
  { code: "M24.152", desc: "Contracture, left hip" },
  { code: "M24.251", desc: "Disorder of ligament, right hip" },
  { code: "M24.252", desc: "Disorder of ligament, left hip" },
  { code: "M24.551", desc: "Contracture of right hip joint" },
  { code: "M24.552", desc: "Contracture of left hip joint" },
  { code: "M25.051", desc: "Hemarthrosis, right hip" },
  { code: "M25.052", desc: "Hemarthrosis, left hip" },
  { code: "M25.251", desc: "Flail joint, right hip" },
  { code: "M25.252", desc: "Flail joint, left hip" },
  { code: "M25.351", desc: "Other instability, right hip" },
  { code: "M25.352", desc: "Other instability, left hip" },
  { code: "M25.651", desc: "Stiffness of right hip" },
  { code: "M25.652", desc: "Stiffness of left hip" },
  { code: "M70.71", desc: "Trochanteric bursitis, right hip" },
  { code: "M70.72", desc: "Trochanteric bursitis, left hip" },
  { code: "M71.151", desc: "Abscess of bursa, right hip" },
  { code: "M71.152", desc: "Abscess of bursa, left hip" },
  { code: "M71.251", desc: "Synovial cyst, right hip" },
  { code: "M71.252", desc: "Synovial cyst, left hip" },
  { code: "M76.11", desc: "Psoas tendinitis, right hip" },
  { code: "M76.12", desc: "Psoas tendinitis, left hip" },
  { code: "M76.21", desc: "Iliac crest spur, right" },
  { code: "M76.22", desc: "Iliac crest spur, left" },
  { code: "M76.31", desc: "Iliotibial band syndrome, right" },
  { code: "M76.32", desc: "Iliotibial band syndrome, left" },
  { code: "M93.011", desc: "Acute slipped upper femoral epiphysis, right" },
  { code: "M93.012", desc: "Acute slipped upper femoral epiphysis, left" },
  { code: "M93.021", desc: "Chronic slipped upper femoral epiphysis, right" },
  { code: "M93.022", desc: "Chronic slipped upper femoral epiphysis, left" },
  { code: "S70.011A", desc: "Contusion of right hip, initial" },
  { code: "S70.012A", desc: "Contusion of left hip, initial" },
  { code: "S70.021A", desc: "Contusion of right thigh, initial" },
  { code: "S70.022A", desc: "Contusion of left thigh, initial" },
  { code: "S76.011A", desc: "Strain of right hip muscle, initial" },
  { code: "S76.012A", desc: "Strain of left hip muscle, initial" },
  { code: "S76.111A", desc: "Strain of right quadriceps muscle, initial" },
  { code: "S76.112A", desc: "Strain of left quadriceps muscle, initial" },
  { code: "S76.311A", desc: "Strain of right hamstring muscle, initial" },
  { code: "S76.312A", desc: "Strain of left hamstring muscle, initial" },

  // ── Knee — Additional ─────────────────────────────────────────────────────
  { code: "M23.001", desc: "Cystic meniscus, anterior horn, medial, right knee" },
  { code: "M23.002", desc: "Cystic meniscus, anterior horn, medial, left knee" },
  { code: "M23.051", desc: "Cystic meniscus, posterior horn, lateral, right knee" },
  { code: "M23.052", desc: "Cystic meniscus, posterior horn, lateral, left knee" },
  { code: "M23.101", desc: "Derangement of anterior horn of medial meniscus due to old tear, right knee" },
  { code: "M23.102", desc: "Derangement of anterior horn of medial meniscus due to old tear, left knee" },
  { code: "M23.301", desc: "Other meniscus derangements, right knee" },
  { code: "M23.302", desc: "Other meniscus derangements, left knee" },
  { code: "M23.401", desc: "Free body in right knee joint" },
  { code: "M23.402", desc: "Free body in left knee joint" },
  { code: "M23.501", desc: "Chronic instability of right knee" },
  { code: "M23.502", desc: "Chronic instability of left knee" },
  { code: "M23.811", desc: "Other internal derangements of right knee" },
  { code: "M23.812", desc: "Other internal derangements of left knee" },
  { code: "M24.061", desc: "Loose body in right knee" },
  { code: "M24.062", desc: "Loose body in left knee" },
  { code: "M24.161", desc: "Contracture, right knee" },
  { code: "M24.162", desc: "Contracture, left knee" },
  { code: "M24.261", desc: "Disorder of ligament, right knee" },
  { code: "M24.262", desc: "Disorder of ligament, left knee" },
  { code: "M24.361", desc: "Pathological dislocation of right knee, NEC" },
  { code: "M24.362", desc: "Pathological dislocation of left knee, NEC" },
  { code: "M24.461", desc: "Recurrent dislocation, right knee" },
  { code: "M24.462", desc: "Recurrent dislocation, left knee" },
  { code: "M25.061", desc: "Hemarthrosis, right knee" },
  { code: "M25.062", desc: "Hemarthrosis, left knee" },
  { code: "M25.161", desc: "Fistula, right knee" },
  { code: "M25.162", desc: "Fistula, left knee" },
  { code: "M25.261", desc: "Flail joint, right knee" },
  { code: "M25.262", desc: "Flail joint, left knee" },
  { code: "M65.861", desc: "Other synovitis and tenosynovitis, right knee" },
  { code: "M65.862", desc: "Other synovitis and tenosynovitis, left knee" },
  { code: "M67.261", desc: "Synovial hypertrophy, right knee" },
  { code: "M67.262", desc: "Synovial hypertrophy, left knee" },
  { code: "M70.51", desc: "Other bursitis of knee, right" },
  { code: "M70.52", desc: "Other bursitis of knee, left" },
  { code: "M76.41", desc: "Tibial collateral ligament bursitis, right" },
  { code: "M76.42", desc: "Tibial collateral ligament bursitis, left" },
  { code: "M93.261", desc: "Osteochondritis dissecans, right knee" },
  { code: "M93.262", desc: "Osteochondritis dissecans, left knee" },
  { code: "S80.011A", desc: "Contusion of right knee, initial" },
  { code: "S80.012A", desc: "Contusion of left knee, initial" },
  { code: "S80.021A", desc: "Contusion of right lower leg, initial" },
  { code: "S80.022A", desc: "Contusion of left lower leg, initial" },
  { code: "S83.001A", desc: "Unspecified subluxation of right patella, initial" },
  { code: "S83.002A", desc: "Unspecified subluxation of left patella, initial" },
  { code: "S83.101A", desc: "Unspecified dislocation of right knee, initial" },
  { code: "S83.102A", desc: "Unspecified dislocation of left knee, initial" },
  { code: "S83.201A", desc: "Tear of medial meniscus, right knee, initial" },
  { code: "S83.202A", desc: "Tear of medial meniscus, left knee, initial" },
  { code: "S83.281A", desc: "Other tear of medial meniscus, right knee, initial" },
  { code: "S83.282A", desc: "Other tear of medial meniscus, left knee, initial" },
  { code: "S83.301A", desc: "Tear of lateral meniscus, right knee, initial" },
  { code: "S83.302A", desc: "Tear of lateral meniscus, left knee, initial" },
  { code: "S83.401A", desc: "Sprain of collateral ligament of right knee, initial" },
  { code: "S83.402A", desc: "Sprain of collateral ligament of left knee, initial" },
  { code: "S83.421A", desc: "Sprain of MCL of right knee, initial" },
  { code: "S83.422A", desc: "Sprain of MCL of left knee, initial" },
  { code: "S83.431A", desc: "Sprain of LCL of right knee, initial" },
  { code: "S83.432A", desc: "Sprain of LCL of left knee, initial" },
  { code: "S83.501A", desc: "Sprain of cruciate ligament of right knee, initial" },
  { code: "S83.502A", desc: "Sprain of cruciate ligament of left knee, initial" },
  { code: "S83.521A", desc: "Sprain of PCL of right knee, initial" },
  { code: "S83.522A", desc: "Sprain of PCL of left knee, initial" },
  { code: "S76.211A", desc: "Strain of adductor muscle, right thigh, initial" },
  { code: "S76.212A", desc: "Strain of adductor muscle, left thigh, initial" },

  // ── Ankle & Foot — Additional ─────────────────────────────────────────────
  { code: "M24.071", desc: "Loose body in right ankle" },
  { code: "M24.072", desc: "Loose body in left ankle" },
  { code: "M24.171", desc: "Contracture, right ankle" },
  { code: "M24.172", desc: "Contracture, left ankle" },
  { code: "M24.271", desc: "Disorder of ligament, right ankle" },
  { code: "M24.272", desc: "Disorder of ligament, left ankle" },
  { code: "M24.371", desc: "Pathological dislocation of right ankle" },
  { code: "M24.372", desc: "Pathological dislocation of left ankle" },
  { code: "M24.471", desc: "Recurrent dislocation, right ankle" },
  { code: "M24.472", desc: "Recurrent dislocation, left ankle" },
  { code: "M24.571", desc: "Contracture of right ankle joint" },
  { code: "M24.572", desc: "Contracture of left ankle joint" },
  { code: "M24.671", desc: "Ankylosis, right ankle and foot" },
  { code: "M24.672", desc: "Ankylosis, left ankle and foot" },
  { code: "M25.071", desc: "Hemarthrosis, right ankle" },
  { code: "M25.072", desc: "Hemarthrosis, left ankle" },
  { code: "M25.171", desc: "Fistula, right ankle" },
  { code: "M25.172", desc: "Fistula, left ankle" },
  { code: "M25.271", desc: "Flail joint, right ankle" },
  { code: "M25.272", desc: "Flail joint, left ankle" },
  { code: "M65.871", desc: "Other synovitis, right ankle and foot" },
  { code: "M65.872", desc: "Other synovitis, left ankle and foot" },
  { code: "M67.271", desc: "Synovial hypertrophy, right ankle" },
  { code: "M67.272", desc: "Synovial hypertrophy, left ankle" },
  { code: "M67.471", desc: "Ganglion, right ankle and foot" },
  { code: "M67.472", desc: "Ganglion, left ankle and foot" },
  { code: "M70.61", desc: "Bursitis, right foot" },
  { code: "M70.62", desc: "Bursitis, left foot" },
  { code: "M70.71", desc: "Other bursitis of ankle and foot, right" },
  { code: "M70.72", desc: "Other bursitis of ankle and foot, left" },
  { code: "M71.171", desc: "Abscess of bursa, right ankle and foot" },
  { code: "M71.172", desc: "Abscess of bursa, left ankle and foot" },
  { code: "M71.571", desc: "Other bursitis, right ankle and foot" },
  { code: "M71.572", desc: "Other bursitis, left ankle and foot" },
  { code: "M93.271", desc: "Osteochondritis dissecans, right ankle and joint" },
  { code: "M93.272", desc: "Osteochondritis dissecans, left ankle and joint" },
  { code: "M19.171", desc: "Post-traumatic osteoarthritis, right ankle and foot" },
  { code: "M19.172", desc: "Post-traumatic osteoarthritis, left ankle and foot" },
  { code: "M19.071", desc: "Primary osteoarthritis, right ankle and foot" },
  { code: "M19.072", desc: "Primary osteoarthritis, left ankle and foot" },
  { code: "S90.011A", desc: "Contusion of right great toe, initial" },
  { code: "S90.012A", desc: "Contusion of left great toe, initial" },
  { code: "S90.111A", desc: "Contusion of right foot, initial" },
  { code: "S90.112A", desc: "Contusion of left foot, initial" },
  { code: "S90.311A", desc: "Contusion of right ankle, initial" },
  { code: "S90.312A", desc: "Contusion of left ankle, initial" },
  { code: "S93.011A", desc: "Subluxation of right ankle joint, initial" },
  { code: "S93.012A", desc: "Subluxation of left ankle joint, initial" },
  { code: "S93.301A", desc: "Unspecified subluxation of right foot, initial" },
  { code: "S93.302A", desc: "Unspecified subluxation of left foot, initial" },
  { code: "S96.011A", desc: "Strain of muscle and tendon of right foot, initial" },
  { code: "S96.012A", desc: "Strain of muscle and tendon of left foot, initial" },
  { code: "S96.111A", desc: "Strain of muscle and tendon at ankle level, right, initial" },
  { code: "S96.112A", desc: "Strain of muscle and tendon at ankle level, left, initial" },
  { code: "M20.21", desc: "Hallux rigidus, right foot" },
  { code: "M20.22", desc: "Hallux rigidus, left foot" },
  { code: "M20.61", desc: "Acquired deformities of right toe(s), unspecified" },
  { code: "M20.62", desc: "Acquired deformities of left toe(s), unspecified" },

  // ── Spine — Additional ────────────────────────────────────────────────────
  { code: "M47.11", desc: "Anterior spinal artery compression syndromes, occipito-atlanto-axial region" },
  { code: "M47.12", desc: "Anterior spinal artery compression syndromes, cervical region" },
  { code: "M47.13", desc: "Anterior spinal artery compression syndromes, cervicothoracic region" },
  { code: "M47.14", desc: "Anterior spinal artery compression syndromes, thoracic region" },
  { code: "M47.15", desc: "Anterior spinal artery compression syndromes, thoracolumbar region" },
  { code: "M47.16", desc: "Anterior spinal artery compression syndromes, lumbar region" },
  { code: "M47.211", desc: "Spondylosis with radiculopathy, occipito-atlanto-axial region" },
  { code: "M47.212", desc: "Spondylosis with radiculopathy, cervical region" },
  { code: "M47.213", desc: "Spondylosis with radiculopathy, cervicothoracic region" },
  { code: "M47.214", desc: "Spondylosis with radiculopathy, thoracic region" },
  { code: "M47.215", desc: "Spondylosis with radiculopathy, thoracolumbar region" },
  { code: "M47.216", desc: "Spondylosis with radiculopathy, lumbar region" },
  { code: "M47.217", desc: "Spondylosis with radiculopathy, lumbosacral region" },
  { code: "M47.811", desc: "Spondylosis without myelopathy or radiculopathy, occipito-atlanto-axial region" },
  { code: "M47.813", desc: "Spondylosis without myelopathy, cervicothoracic region" },
  { code: "M47.814", desc: "Spondylosis without myelopathy, thoracic region" },
  { code: "M47.815", desc: "Spondylosis without myelopathy, thoracolumbar region" },
  { code: "M48.00", desc: "Spinal stenosis, site unspecified" },
  { code: "M48.01", desc: "Spinal stenosis, occipito-atlanto-axial region" },
  { code: "M48.02", desc: "Spinal stenosis, cervical region" },
  { code: "M48.03", desc: "Spinal stenosis, cervicothoracic region" },
  { code: "M48.04", desc: "Spinal stenosis, thoracic region" },
  { code: "M48.05", desc: "Spinal stenosis, thoracolumbar region" },
  { code: "M48.061", desc: "Spinal stenosis, lumbar region without neurogenic claudication" },
  { code: "M48.062", desc: "Spinal stenosis, lumbar region with neurogenic claudication" },
  { code: "M48.07", desc: "Spinal stenosis, lumbosacral region" },
  { code: "M43.10", desc: "Spondylolisthesis, site unspecified" },
  { code: "M43.11", desc: "Spondylolisthesis, occipito-atlanto-axial region" },
  { code: "M43.12", desc: "Spondylolisthesis, cervical region" },
  { code: "M43.13", desc: "Spondylolisthesis, cervicothoracic region" },
  { code: "M43.14", desc: "Spondylolisthesis, thoracic region" },
  { code: "M43.15", desc: "Spondylolisthesis, thoracolumbar region" },
  { code: "M43.17", desc: "Spondylolisthesis, lumbosacral region" },
  { code: "M43.18", desc: "Spondylolisthesis, sacral and sacrococcygeal region" },
  { code: "M54.11", desc: "Radiculopathy, occipito-atlanto-axial region" },
  { code: "M54.13", desc: "Radiculopathy, cervicothoracic region" },
  { code: "M54.14", desc: "Radiculopathy, thoracic region" },
  { code: "M54.15", desc: "Radiculopathy, thoracolumbar region" },
  { code: "M54.18", desc: "Radiculopathy, sacral and sacrococcygeal region" },
  { code: "M54.30", desc: "Sciatica, unspecified side" },
  { code: "M54.31", desc: "Sciatica, right side" },
  { code: "M54.32", desc: "Sciatica, left side" },
  { code: "M54.40", desc: "Lumbago with sciatica, unspecified side" },
  { code: "M54.6", desc: "Pain in thoracic spine" },
  { code: "M54.81", desc: "Occipital neuralgia" },
  { code: "M54.89", desc: "Other dorsalgia" },
  { code: "M50.00", desc: "Cervical disc disorder with myelopathy, unspecified level" },
  { code: "M50.01", desc: "Cervical disc disorder with myelopathy, high cervical region" },
  { code: "M50.02", desc: "Cervical disc disorder with myelopathy, mid-cervical region" },
  { code: "M50.03", desc: "Cervical disc disorder with myelopathy, cervicothoracic region" },
  { code: "M50.121", desc: "Cervical disc degeneration with radiculopathy, mid-cervical" },
  { code: "M50.220", desc: "Cervical disc displacement at C4-C5 level" },
  { code: "M50.221", desc: "Cervical disc displacement at C5-C6 level" },
  { code: "M50.222", desc: "Cervical disc displacement at C6-C7 level" },
  { code: "M51.04", desc: "Intervertebral disc disorder with myelopathy, thoracic region" },
  { code: "M51.05", desc: "Intervertebral disc disorder with myelopathy, thoracolumbar region" },
  { code: "M51.34", desc: "Other intervertebral disc degeneration, thoracic" },
  { code: "M51.35", desc: "Other intervertebral disc degeneration, thoracolumbar" },
  { code: "M51.36", desc: "Other intervertebral disc degeneration, lumbar" },
  { code: "M51.37", desc: "Other intervertebral disc degeneration, lumbosacral" },
  { code: "M51.44", desc: "Schmorl nodes, thoracic region" },
  { code: "M51.45", desc: "Schmorl nodes, thoracolumbar region" },
  { code: "M51.46", desc: "Schmorl nodes, lumbar region" },
  { code: "M51.47", desc: "Schmorl nodes, lumbosacral region" },
  { code: "M53.1", desc: "Cervicobrachial syndrome" },
  { code: "M53.2X1", desc: "Spinal instabilities, occipito-atlanto-axial region" },
  { code: "M53.2X6", desc: "Spinal instabilities, lumbar region" },
  { code: "M53.3", desc: "Sacrococcygeal disorders, NEC" },
  { code: "M53.82", desc: "Other specified dorsopathies, cervical region" },
  { code: "M53.86", desc: "Other specified dorsopathies, lumbar region" },
  { code: "M96.0", desc: "Pseudarthrosis after fusion or arthrodesis" },
  { code: "M96.89", desc: "Other intraoperative and postprocedural complications of musculoskeletal system" },
  { code: "T84.110A", desc: "Breakdown of internal fixation device of vertebra, initial" },
  { code: "T84.120A", desc: "Displacement of internal fixation device of vertebra, initial" },
  { code: "T84.190A", desc: "Other complication of internal fixation device of vertebra, initial" },

  // ── Fractures — Additional Specific ───────────────────────────────────────
  { code: "S12.400A", desc: "Unspecified traumatic spondylolisthesis of fifth cervical vertebra, initial" },
  { code: "S12.500A", desc: "Unspecified traumatic spondylolisthesis of sixth cervical vertebra, initial" },
  { code: "S12.600A", desc: "Unspecified fracture of seventh cervical vertebra, initial" },
  { code: "S22.000A", desc: "Fracture of T1 vertebra, initial" },
  { code: "S22.010A", desc: "Fracture of T2 vertebra, initial" },
  { code: "S22.020A", desc: "Fracture of T3 vertebra, initial" },
  { code: "S22.030A", desc: "Fracture of T4 vertebra, initial" },
  { code: "S22.040A", desc: "Fracture of T5 vertebra, initial" },
  { code: "S22.050A", desc: "Fracture of T6 vertebra, initial" },
  { code: "S22.060A", desc: "Fracture of T7 vertebra, initial" },
  { code: "S22.070A", desc: "Fracture of T8 vertebra, initial" },
  { code: "S22.080A", desc: "Fracture of T9 vertebra, initial" },
  { code: "S22.090A", desc: "Fracture of T10 vertebra, initial" },
  { code: "S22.100A", desc: "Fracture of T11 vertebra, initial" },
  { code: "S22.110A", desc: "Fracture of T12 vertebra, initial" },
  { code: "S32.010A", desc: "Fracture of L1 vertebra, initial" },
  { code: "S32.020A", desc: "Fracture of L2 vertebra, initial" },
  { code: "S32.030A", desc: "Fracture of L3 vertebra, initial" },
  { code: "S32.040A", desc: "Fracture of L4 vertebra, initial" },
  { code: "S32.050A", desc: "Fracture of L5 vertebra, initial" },
  { code: "S32.101A", desc: "Fracture of sacrum, zone I, initial" },
  { code: "S32.111A", desc: "Displaced Zone II sacral fracture, initial" },
  { code: "S32.121A", desc: "Displaced Zone III sacral fracture, initial" },
  { code: "S32.301A", desc: "Unspecified fracture of right ilium, initial" },
  { code: "S32.302A", desc: "Unspecified fracture of left ilium, initial" },
  { code: "S32.401A", desc: "Unspecified fracture of right acetabulum, initial" },
  { code: "S32.402A", desc: "Unspecified fracture of left acetabulum, initial" },
  { code: "S32.501A", desc: "Unspecified fracture of right pubis, initial" },
  { code: "S32.502A", desc: "Unspecified fracture of left pubis, initial" },
  { code: "S32.601A", desc: "Fracture of right ischium, initial" },
  { code: "S32.602A", desc: "Fracture of left ischium, initial" },
  { code: "S42.011A", desc: "Displaced fracture of sternal end of right clavicle, initial" },
  { code: "S42.012A", desc: "Displaced fracture of sternal end of left clavicle, initial" },
  { code: "S42.031A", desc: "Displaced fracture of shaft of right clavicle, initial" },
  { code: "S42.032A", desc: "Displaced fracture of shaft of left clavicle, initial" },
  { code: "S42.111A", desc: "Displaced fracture of body of right scapula, initial" },
  { code: "S42.112A", desc: "Displaced fracture of body of left scapula, initial" },
  { code: "S42.211A", desc: "2-part displaced fracture of greater tuberosity of right humerus, initial" },
  { code: "S42.212A", desc: "2-part displaced fracture of greater tuberosity of left humerus, initial" },
  { code: "S42.221A", desc: "2-part displaced fracture of lesser tuberosity of right humerus, initial" },
  { code: "S42.222A", desc: "2-part displaced fracture of lesser tuberosity of left humerus, initial" },
  { code: "S42.311A", desc: "Displaced transverse fracture of shaft of right humerus, initial" },
  { code: "S42.312A", desc: "Displaced transverse fracture of shaft of left humerus, initial" },
  { code: "S42.411A", desc: "Displaced simple supracondylar fracture, right humerus, initial" },
  { code: "S42.412A", desc: "Displaced simple supracondylar fracture, left humerus, initial" },
  { code: "S52.511A", desc: "Displaced fracture of right radial styloid process, initial" },
  { code: "S52.512A", desc: "Displaced fracture of left radial styloid process, initial" },
  { code: "S52.521A", desc: "Displaced fracture of right ulnar styloid process, initial" },
  { code: "S52.522A", desc: "Displaced fracture of left ulnar styloid process, initial" },
  { code: "S82.011A", desc: "Displaced osteochondral fracture of right patella, initial" },
  { code: "S82.012A", desc: "Displaced osteochondral fracture of left patella, initial" },
  { code: "S82.111A", desc: "Displaced fracture of right tibial spine, initial" },
  { code: "S82.112A", desc: "Displaced fracture of left tibial spine, initial" },
  { code: "S82.211A", desc: "Displaced transverse fracture of shaft of right tibia, initial" },
  { code: "S82.212A", desc: "Displaced transverse fracture of shaft of left tibia, initial" },
  { code: "S82.411A", desc: "Displaced fibula fracture, spiral, right, initial" },
  { code: "S82.412A", desc: "Displaced fibula fracture, spiral, left, initial" },
  { code: "S82.811A", desc: "Torus fracture of upper end of right fibula, initial" },
  { code: "S82.812A", desc: "Torus fracture of upper end of left fibula, initial" },
  { code: "S82.821A", desc: "Torus fracture of lower end of right fibula, initial" },
  { code: "S82.822A", desc: "Torus fracture of lower end of left fibula, initial" },
  { code: "S92.011A", desc: "Displaced fracture of body of right calcaneus, initial" },
  { code: "S92.012A", desc: "Displaced fracture of body of left calcaneus, initial" },
  { code: "S92.111A", desc: "Displaced fracture of neck of right talus, initial" },
  { code: "S92.112A", desc: "Displaced fracture of neck of left talus, initial" },
  { code: "S92.211A", desc: "Displaced fracture of cuboid bone of right foot, initial" },
  { code: "S92.212A", desc: "Displaced fracture of cuboid bone of left foot, initial" },
  { code: "S92.311A", desc: "Displaced avulsion fracture of right foot, initial" },
  { code: "S92.312A", desc: "Displaced avulsion fracture of left foot, initial" },
  { code: "S92.411A", desc: "Displaced fracture of right great toe, initial" },
  { code: "S92.412A", desc: "Displaced fracture of left great toe, initial" },
  { code: "S92.501A", desc: "Displaced fracture of proximal phalanx of right lesser toe, initial" },
  { code: "S92.502A", desc: "Displaced fracture of proximal phalanx of left lesser toe, initial" },

  // ── Periprosthetic & Hardware Complications ────────────────────────────────
  { code: "T84.010A", desc: "Broken internal joint prosthesis, unspecified, initial" },
  { code: "T84.020A", desc: "Dislocation of internal joint prosthesis, unspecified, initial" },
  { code: "T84.030A", desc: "Mechanical loosening of internal prosthetic joint, unspecified, initial" },
  { code: "T84.040A", desc: "Periprosthetic fracture around internal prosthetic joint, initial" },
  { code: "T84.041A", desc: "Periprosthetic fracture around internal right hip prosthesis, initial" },
  { code: "T84.042A", desc: "Periprosthetic fracture around internal left hip prosthesis, initial" },
  { code: "T84.043A", desc: "Periprosthetic fracture around internal right knee prosthesis, initial" },
  { code: "T84.044A", desc: "Periprosthetic fracture around internal left knee prosthesis, initial" },
  { code: "T84.060A", desc: "Wear of articular bearing surface of internal prosthetic joint, initial" },
  { code: "T84.061A", desc: "Wear of articular bearing of internal right hip prosthesis, initial" },
  { code: "T84.062A", desc: "Wear of articular bearing of internal left hip prosthesis, initial" },
  { code: "T84.063A", desc: "Wear of articular bearing of internal right knee prosthesis, initial" },
  { code: "T84.064A", desc: "Wear of articular bearing of internal left knee prosthesis, initial" },
  { code: "T84.100A", desc: "Breakdown of internal fixation device, unspecified bone, initial" },
  { code: "T84.101A", desc: "Breakdown of internal fixation device of right humerus, initial" },
  { code: "T84.102A", desc: "Breakdown of internal fixation device of left humerus, initial" },
  { code: "T84.103A", desc: "Breakdown of internal fixation device of right radius and ulna, initial" },
  { code: "T84.104A", desc: "Breakdown of internal fixation device of left radius and ulna, initial" },
  { code: "T84.105A", desc: "Breakdown of internal fixation device of right femur, initial" },
  { code: "T84.106A", desc: "Breakdown of internal fixation device of left femur, initial" },
  { code: "T84.107A", desc: "Breakdown of internal fixation device of right tibia and fibula, initial" },
  { code: "T84.108A", desc: "Breakdown of internal fixation device of left tibia and fibula, initial" },
  { code: "T84.213A", desc: "Breakdown of internal fixation device of bones of right foot and toes, initial" },
  { code: "T84.214A", desc: "Breakdown of internal fixation device of bones of left foot and toes, initial" },
  { code: "T84.290A", desc: "Other mechanical complication of internal fixation device, bones of hand and fingers, initial" },
  { code: "Z47.1", desc: "Aftercare following joint replacement surgery" },
  { code: "Z47.31", desc: "Aftercare following explantation of shoulder joint prosthesis" },
  { code: "Z47.32", desc: "Aftercare following explantation of hip joint prosthesis" },
  { code: "Z47.33", desc: "Aftercare following explantation of knee joint prosthesis" },
  { code: "Z96.621", desc: "Presence of right artificial elbow joint" },
  { code: "Z96.622", desc: "Presence of left artificial elbow joint" },
  { code: "Z96.631", desc: "Presence of right artificial wrist joint" },
  { code: "Z96.632", desc: "Presence of left artificial wrist joint" },
  { code: "Z96.643", desc: "Presence of artificial hip joint, bilateral" },
  { code: "Z96.653", desc: "Presence of artificial knee joint, bilateral" },
  { code: "Z96.661", desc: "Presence of right artificial ankle joint" },
  { code: "Z96.662", desc: "Presence of left artificial ankle joint" },
  { code: "Z96.698", desc: "Presence of other orthopedic joint implants" },
  { code: "Z96.81", desc: "Presence of artificial skin" },
  { code: "Z97.11", desc: "Presence of right artificial limb (complete)(partial)" },
  { code: "Z97.12", desc: "Presence of left artificial limb (complete)(partial)" },
  { code: "Z97.13", desc: "Presence of right artificial arm (complete)(partial)" },
  { code: "Z97.14", desc: "Presence of left artificial arm (complete)(partial)" },
  { code: "Z97.15", desc: "Presence of right artificial leg (complete)(partial)" },
  { code: "Z97.16", desc: "Presence of left artificial leg (complete)(partial)" },

  // ── Muscle, Tendon & Fascia ────────────────────────────────────────────────
  { code: "M60.011", desc: "Infective myositis, right shoulder region" },
  { code: "M60.012", desc: "Infective myositis, left shoulder region" },
  { code: "M60.021", desc: "Infective myositis, right upper arm" },
  { code: "M60.022", desc: "Infective myositis, left upper arm" },
  { code: "M60.041", desc: "Infective myositis, right hand" },
  { code: "M60.042", desc: "Infective myositis, left hand" },
  { code: "M60.051", desc: "Infective myositis, right thigh" },
  { code: "M60.052", desc: "Infective myositis, left thigh" },
  { code: "M60.061", desc: "Infective myositis, right lower leg" },
  { code: "M60.062", desc: "Infective myositis, left lower leg" },
  { code: "M60.071", desc: "Infective myositis, right ankle and foot" },
  { code: "M60.072", desc: "Infective myositis, left ankle and foot" },
  { code: "M61.311", desc: "Calcification and ossification of muscles, right shoulder" },
  { code: "M61.312", desc: "Calcification and ossification of muscles, left shoulder" },
  { code: "M62.011", desc: "Separation of muscle, right shoulder" },
  { code: "M62.012", desc: "Separation of muscle, left shoulder" },
  { code: "M62.121", desc: "Ischemic infarction of muscle, right upper arm" },
  { code: "M62.122", desc: "Ischemic infarction of muscle, left upper arm" },
  { code: "M62.411", desc: "Contracture of muscle, right shoulder" },
  { code: "M62.412", desc: "Contracture of muscle, left shoulder" },
  { code: "M62.421", desc: "Contracture of muscle, right upper arm" },
  { code: "M62.422", desc: "Contracture of muscle, left upper arm" },
  { code: "M62.431", desc: "Contracture of muscle, right forearm" },
  { code: "M62.432", desc: "Contracture of muscle, left forearm" },
  { code: "M62.441", desc: "Contracture of muscle, right hand" },
  { code: "M62.442", desc: "Contracture of muscle, left hand" },
  { code: "M62.451", desc: "Contracture of muscle, right thigh" },
  { code: "M62.452", desc: "Contracture of muscle, left thigh" },
  { code: "M62.461", desc: "Contracture of muscle, right lower leg" },
  { code: "M62.462", desc: "Contracture of muscle, left lower leg" },
  { code: "M62.471", desc: "Contracture of muscle, right ankle and foot" },
  { code: "M62.472", desc: "Contracture of muscle, left ankle and foot" },
  { code: "M62.511", desc: "Muscle wasting and atrophy, NEC, right shoulder" },
  { code: "M62.512", desc: "Muscle wasting and atrophy, NEC, left shoulder" },
  { code: "M62.561", desc: "Muscle wasting and atrophy, NEC, right lower leg" },
  { code: "M62.562", desc: "Muscle wasting and atrophy, NEC, left lower leg" },
  { code: "M66.211", desc: "Spontaneous rupture of extensor tendons, right shoulder" },
  { code: "M66.212", desc: "Spontaneous rupture of extensor tendons, left shoulder" },
  { code: "M66.221", desc: "Spontaneous rupture of extensor tendons, right upper arm" },
  { code: "M66.222", desc: "Spontaneous rupture of extensor tendons, left upper arm" },
  { code: "M66.261", desc: "Spontaneous rupture of extensor tendons, right lower leg" },
  { code: "M66.262", desc: "Spontaneous rupture of extensor tendons, left lower leg" },
  { code: "M66.311", desc: "Spontaneous rupture of flexor tendons, right shoulder" },
  { code: "M66.312", desc: "Spontaneous rupture of flexor tendons, left shoulder" },
  { code: "M66.361", desc: "Spontaneous rupture of flexor tendons, right lower leg (Achilles)" },
  { code: "M66.362", desc: "Spontaneous rupture of flexor tendons, left lower leg (Achilles)" },
  { code: "M67.211", desc: "Synovial hypertrophy, right shoulder" },
  { code: "M67.221", desc: "Synovial hypertrophy, right upper arm" },
  { code: "M67.222", desc: "Synovial hypertrophy, left upper arm" },
  { code: "M76.811", desc: "Gluteal tendinitis, right hip" },
  { code: "M76.812", desc: "Gluteal tendinitis, left hip" },
  { code: "M76.821", desc: "Patellar tendinitis, right knee" },
  { code: "M76.822", desc: "Patellar tendinitis, left knee" },
  { code: "M76.881", desc: "Other enthesopathies, right lower limb" },
  { code: "M76.882", desc: "Other enthesopathies, left lower limb" },
  { code: "M77.21", desc: "Periarthritis, right elbow" },
  { code: "M77.22", desc: "Periarthritis, left elbow" },
  { code: "M77.51", desc: "Other enthesopathy of right foot and ankle" },
  { code: "M77.52", desc: "Other enthesopathy of left foot and ankle" },
  { code: "M79.011", desc: "Rheumatism, unspecified, right shoulder" },
  { code: "M79.012", desc: "Rheumatism, unspecified, left shoulder" },
  { code: "M79.021", desc: "Rheumatism, unspecified, right upper arm" },
  { code: "M79.022", desc: "Rheumatism, unspecified, left upper arm" },
  { code: "M79.651", desc: "Pain in right thigh" },
  { code: "M79.652", desc: "Pain in left thigh" },
  { code: "M79.661", desc: "Pain in right lower leg" },
  { code: "M79.662", desc: "Pain in left lower leg" },
];

export const ORTHO_CPT = [
  // ── Office Visits ────────────────────────────────────────────────────────────
  { code: "99213", desc: "Office/outpatient visit, established patient, moderate" },
  { code: "99214", desc: "Office/outpatient visit, established patient, high" },
  { code: "99203", desc: "Office/outpatient visit, new patient, moderate" },
  { code: "99204", desc: "Office/outpatient visit, new patient, high" },
  { code: "99215", desc: "Office/outpatient visit, established patient, high complexity" },
  { code: "99205", desc: "Office/outpatient visit, new patient, high complexity" },

  // ── General Orthopedic ───────────────────────────────────────────────────────
  { code: "27447", desc: "Total knee arthroplasty" },
  { code: "27130", desc: "Total hip arthroplasty" },
  { code: "29827", desc: "Arthroscopy, shoulder, rotator cuff repair" },
  { code: "29881", desc: "Arthroscopy, knee, meniscectomy" },
  { code: "22612", desc: "Arthrodesis, posterior, lumbar" },
  { code: "27245", desc: "ORIF, intertrochanteric fracture, femur" },
  { code: "29823", desc: "Arthroscopy, shoulder, debridement, extensive" },
  { code: "27487", desc: "Revision of total knee arthroplasty" },
  { code: "27134", desc: "Revision of total hip arthroplasty" },
  { code: "20610", desc: "Arthrocentesis, major joint or bursa" },
  { code: "20600", desc: "Arthrocentesis, small joint or bursa" },
  { code: "20605", desc: "Arthrocentesis, intermediate joint or bursa" },
  { code: "73721", desc: "MRI, any joint of lower extremity" },
  { code: "73221", desc: "MRI, any joint of upper extremity" },
  { code: "72148", desc: "MRI, lumbar spine" },
  { code: "27370", desc: "Injection, knee joint" },
  { code: "23350", desc: "Injection procedure for shoulder arthrography" },
  { code: "29877", desc: "Arthroscopy, knee, chondroplasty" },

  // ── Imaging — Upper Extremity ────────────────────────────────────────────────
  { code: "73100", desc: "X-ray, wrist, 2 views" },
  { code: "73110", desc: "X-ray, wrist, minimum 3 views" },
  { code: "73120", desc: "X-ray, hand, 2 views" },
  { code: "73130", desc: "X-ray, hand, minimum 3 views" },
  { code: "73140", desc: "X-ray, finger(s), minimum 2 views" },
  { code: "73070", desc: "X-ray, elbow, 2 views" },
  { code: "73080", desc: "X-ray, elbow, minimum 3 views" },
  { code: "73060", desc: "X-ray, humerus, minimum 2 views" },
  { code: "73200", desc: "CT, upper extremity without contrast" },
  { code: "73201", desc: "CT, upper extremity with contrast" },
  { code: "73222", desc: "MRI, any joint of upper extremity with contrast" },
  { code: "76536", desc: "Ultrasound, soft tissue head and neck" },
  { code: "76881", desc: "Ultrasound, extremity, non-vascular, complete" },
  { code: "76882", desc: "Ultrasound, extremity, non-vascular, limited" },

  // ── Carpal Tunnel & Nerve ────────────────────────────────────────────────────
  { code: "29848", desc: "Endoscopy, wrist, surgical; endoscopic carpal tunnel release" },
  { code: "64721", desc: "Open carpal tunnel release (neuroplasty and/or transposition, median nerve at wrist)" },
  { code: "64722", desc: "Decompression, unspecified nerve" },
  { code: "95900", desc: "Nerve conduction, motor, each nerve" },
  { code: "95904", desc: "Nerve conduction, sensory, each nerve" },
  { code: "95903", desc: "Nerve conduction, motor, with F-wave" },
  { code: "64718", desc: "Neuroplasty and/or transposition, ulnar nerve at elbow" },
  { code: "64719", desc: "Neuroplasty and/or transposition, ulnar nerve at wrist" },
  { code: "64722", desc: "Decompression, unspecified nerve" },
  { code: "64713", desc: "Neuroplasty, brachial plexus" },
  { code: "64708", desc: "Neuroplasty, major peripheral nerve, arm or leg" },

  // ── Trigger Finger & Tendon ──────────────────────────────────────────────────
  { code: "26055", desc: "Trigger finger release" },
  { code: "26145", desc: "Synovectomy, tendon sheath, finger or thumb" },
  { code: "26200", desc: "Excision of bone cyst or benign tumor, metacarpal" },
  { code: "26210", desc: "Excision of bone cyst or benign tumor, proximal phalanx" },
  { code: "26356", desc: "Repair of flexor tendon, finger, primary, zones 1-2" },
  { code: "26357", desc: "Repair of flexor tendon, finger, secondary, zones 1-2" },
  { code: "26358", desc: "Repair of flexor tendon, finger, secondary with graft" },
  { code: "26370", desc: "Repair of profundus tendon, with intact superficialis" },
  { code: "26410", desc: "Repair of extensor tendon, finger, primary" },
  { code: "26418", desc: "Repair of extensor tendon, finger, secondary" },
  { code: "26420", desc: "Repair of extensor tendon, finger, secondary with graft" },
  { code: "26440", desc: "Tenolysis, flexor tendon, palm or finger" },
  { code: "26445", desc: "Tenolysis, extensor tendon, hand or finger" },
  { code: "26471", desc: "Tenodesis, proximal interphalangeal joint" },
  { code: "26474", desc: "Tenodesis, distal joint of finger" },

  // ── De Quervain & Wrist Tendons ──────────────────────────────────────────────
  { code: "25000", desc: "Incision of tendon sheath, wrist (de Quervain)" },
  { code: "25020", desc: "Decompression fasciotomy, forearm and/or wrist" },
  { code: "25023", desc: "Decompression fasciotomy, forearm and/or wrist; flexor and extensor" },
  { code: "25100", desc: "Arthrotomy, wrist, with biopsy" },
  { code: "25105", desc: "Arthrotomy, wrist, with synovectomy" },
  { code: "25107", desc: "Arthrotomy, distal radioulnar joint" },
  { code: "25110", desc: "Excision of lesion of tendon sheath, forearm and/or wrist" },
  { code: "25111", desc: "Excision of ganglion, wrist, primary" },
  { code: "25112", desc: "Excision of ganglion, wrist, recurrent" },
  { code: "25115", desc: "Radical excision, bursa, synovia of wrist or forearm tendon" },
  { code: "25116", desc: "Radical excision, bursa, synovia of wrist or forearm tendon, with resection" },

  // ── Wrist Fractures & ORIF ───────────────────────────────────────────────────
  { code: "25600", desc: "Closed treatment of distal radial fracture, without manipulation" },
  { code: "25605", desc: "Closed treatment of distal radial fracture, with manipulation" },
  { code: "25607", desc: "ORIF, distal radial fracture, with internal fixation" },
  { code: "25608", desc: "ORIF, distal radial fracture, with internal fixation, 2 fragments" },
  { code: "25609", desc: "ORIF, distal radial fracture, with internal fixation, 3+ fragments" },
  { code: "25622", desc: "Closed treatment of carpal scaphoid fracture, without manipulation" },
  { code: "25624", desc: "Closed treatment of carpal scaphoid fracture, with manipulation" },
  { code: "25628", desc: "ORIF, carpal scaphoid fracture" },
  { code: "25650", desc: "Closed treatment of ulnar styloid fracture" },
  { code: "25651", desc: "Percutaneous fixation of ulnar styloid fracture" },

  // ── Wrist Reconstruction & Arthroplasty ──────────────────────────────────────
  { code: "25332", desc: "Arthroplasty, wrist, with or without interposition" },
  { code: "25334", desc: "Arthroplasty, wrist, with implant" },
  { code: "25400", desc: "Repair of nonunion or malunion, radius or ulna" },
  { code: "25405", desc: "Repair of nonunion or malunion, radius or ulna, with graft" },
  { code: "25431", desc: "Repair of nonunion of carpal bone, (excluding carpal scaphoid)" },
  { code: "25440", desc: "Repair of nonunion, scaphoid carpal (navicular)" },
  { code: "25441", desc: "Arthroplasty with prosthetic replacement, distal radius" },
  { code: "25442", desc: "Arthroplasty with prosthetic replacement, distal ulna" },
  { code: "25443", desc: "Arthroplasty with prosthetic replacement, scaphoid carpal" },
  { code: "25444", desc: "Arthroplasty with prosthetic replacement, lunate" },
  { code: "25445", desc: "Arthroplasty with prosthetic replacement, trapezium" },
  { code: "25446", desc: "Total wrist arthroplasty" },
  { code: "25447", desc: "Arthroplasty, interposition, intercarpal or carpometacarpal joints" },

  // ── CMC / Thumb ──────────────────────────────────────────────────────────────
  { code: "26160", desc: "Excision of lesion of tendon sheath or capsule, hand or finger" },
  { code: "26170", desc: "Excision of tendon, palm, flexor, single" },
  { code: "26180", desc: "Excision of tendon, finger, flexor, single" },
  { code: "26185", desc: "Sesamoidectomy, thumb or finger" },
  { code: "26236", desc: "Partial excision of bone, phalanx of finger" },
  { code: "26250", desc: "Radical resection for tumor, metacarpal" },
  { code: "26255", desc: "Radical resection for tumor, metacarpal; with autograft" },
  { code: "26260", desc: "Radical resection for tumor, proximal or middle phalanx of finger" },
  { code: "26261", desc: "Radical resection for tumor, proximal or middle phalanx of finger; with autograft" },
  // ── MCP & PIP Arthroplasty ────────────────────────────────────────────────
  { code: "26530", desc: "Arthroplasty, MCP joint; without implant, each joint" },
  { code: "26531", desc: "Arthroplasty, MCP joint; with prosthetic implant, each joint" },
  { code: "26535", desc: "Arthroplasty, PIP joint; without implant, each joint" },
  { code: "26536", desc: "Arthroplasty, PIP joint; with prosthetic implant, each joint" },
  { code: "26537", desc: "Arthroplasty, PIP joint; revision with prosthetic implant, each joint" },
  { code: "26538", desc: "Arthroplasty, MCP joint; revision with prosthetic implant, each joint" },
  { code: "26160", desc: "Excision of lesion of tendon sheath or capsule, MCP or PIP joint" },
  { code: "26520", desc: "Capsulectomy or capsulotomy, MCP joint, each joint" },
  { code: "26525", desc: "Capsulectomy or capsulotomy, IP joint, each joint" },
  { code: "26540", desc: "Repair of collateral ligament, metacarpophalangeal joint" },
  { code: "26541", desc: "Reconstruction of collateral ligament, MCP joint, single" },
  { code: "26542", desc: "Reconstruction of collateral ligament, MCP joint, with tendon graft" },
  { code: "26545", desc: "Reconstruction of collateral ligament, IP joint, single" },

  // ── Metacarpal & Phalangeal Fractures ────────────────────────────────────────
  { code: "26600", desc: "Closed treatment of metacarpal fracture, single, without manipulation" },
  { code: "26605", desc: "Closed treatment of metacarpal fracture, single, with manipulation" },
  { code: "26607", desc: "Closed treatment of metacarpal fracture with manipulation, percutaneous fixation" },
  { code: "26608", desc: "Percutaneous fixation of metacarpal fracture" },
  { code: "26615", desc: "ORIF, metacarpal fracture, single" },
  { code: "26641", desc: "Closed treatment of carpometacarpal dislocation, thumb, with manipulation" },
  { code: "26645", desc: "Closed treatment of carpometacarpal fracture dislocation, thumb (Bennett fracture)" },
  { code: "26650", desc: "Percutaneous fixation of Bennett fracture" },
  { code: "26665", desc: "ORIF, carpometacarpal fracture dislocation, thumb (Bennett fracture)" },
  { code: "26700", desc: "Closed treatment of MCP dislocation, single, without anesthesia" },
  { code: "26705", desc: "Closed treatment of MCP dislocation, single, requiring anesthesia" },
  { code: "26715", desc: "ORIF, MCP dislocation, single" },
  { code: "26720", desc: "Closed treatment of phalangeal fracture, proximal or middle, without manipulation" },
  { code: "26725", desc: "Closed treatment of phalangeal fracture, proximal or middle, with manipulation" },
  { code: "26727", desc: "Percutaneous fixation of unstable phalangeal fracture" },
  { code: "26735", desc: "ORIF, phalangeal fracture, proximal or middle" },
  { code: "26740", desc: "Closed treatment of articular fracture, involving MCP or IP joint" },
  { code: "26742", desc: "Closed treatment of articular fracture with manipulation" },
  { code: "26746", desc: "ORIF, articular fracture" },
  { code: "26750", desc: "Closed treatment of distal phalangeal fracture, without manipulation" },
  { code: "26755", desc: "Closed treatment of distal phalangeal fracture, with manipulation" },
  { code: "26756", desc: "Percutaneous fixation of distal phalangeal fracture" },
  { code: "26765", desc: "ORIF, distal phalangeal fracture" },

  // ── Dupuytren's ──────────────────────────────────────────────────────────────
  { code: "26040", desc: "Fasciotomy, palmar, open, partial" },
  { code: "26045", desc: "Fasciotomy, palmar, open, complete" },
  { code: "26121", desc: "Fasciectomy, partial palmar with release of single digit" },
  { code: "26123", desc: "Fasciectomy, partial palmar with release of each additional digit" },
  { code: "26125", desc: "Fasciectomy, partial palmar, each additional digit" },

  // ── Elbow Procedures ─────────────────────────────────────────────────────────
  { code: "24000", desc: "Arthrotomy, elbow, with synovectomy" },
  { code: "24006", desc: "Arthrotomy of elbow, with capsular excision for capsular release" },
  { code: "24071", desc: "Excision, tumor, soft tissue, upper arm or elbow" },
  { code: "24100", desc: "Arthrotomy, elbow, with synovial biopsy" },
  { code: "24101", desc: "Arthrotomy, elbow, with joint exploration" },
  { code: "24102", desc: "Arthrotomy, elbow, with synovectomy" },
  { code: "24105", desc: "Excision, olecranon bursa" },
  { code: "24110", desc: "Excision of cyst or benign tumor, humerus" },
  { code: "24120", desc: "Excision of cyst or benign tumor, head or neck of radius or olecranon process" },
  { code: "24130", desc: "Excision, radial head" },
  { code: "24138", desc: "Sequestrectomy, elbow" },
  { code: "24147", desc: "Partial excision of bone, olecranon process" },
  { code: "24149", desc: "Radical resection of capsule, heterotopic bone, elbow" },
  { code: "24150", desc: "Radical resection of tumor, elbow; with bone" },
  { code: "24152", desc: "Radical resection of tumor, elbow; proximal radius" },
  { code: "24153", desc: "Radical resection of tumor, elbow; distal humerus" },
  { code: "24160", desc: "Implant removal, elbow" },
  { code: "24200", desc: "Removal of foreign body, upper arm or elbow, subcutaneous" },
  { code: "24201", desc: "Removal of foreign body, upper arm or elbow, deep" },
  { code: "24300", desc: "Manipulation under anesthesia, elbow" },
  { code: "24310", desc: "Tenotomy, open, elbow, lateral or medial" },
  { code: "24320", desc: "Tenodesis at elbow" },
  { code: "24330", desc: "Flexor-pronator muscle slide in cerebral palsy, forearm and wrist" },
  { code: "24340", desc: "Tenodesis of biceps tendon at elbow (Biceps tendon repair)" },
  { code: "24341", desc: "Repair of distal biceps tendon" },
  { code: "24342", desc: "Reinsertion of ruptured biceps or triceps tendon, distal" },
  { code: "24343", desc: "Repair of lateral collateral ligament, elbow" },
  { code: "24344", desc: "Reconstruction of lateral collateral ligament, elbow with tendon graft" },
  { code: "24345", desc: "Repair of medial collateral ligament, elbow" },
  { code: "24346", desc: "Reconstruction of medial collateral ligament, elbow with tendon graft (Tommy John)" },
  { code: "24357", desc: "Tenotomy, elbow, lateral or medial (tennis elbow)" },
  { code: "24358", desc: "Tenotomy, elbow, lateral or medial, with release of muscle origin" },
  { code: "24359", desc: "Tenotomy, elbow, lateral or medial, with tendon repair" },
  { code: "24360", desc: "Arthroplasty, elbow; membrane (Velpeau)" },
  { code: "24361", desc: "Arthroplasty, elbow; with implant" },
  { code: "24363", desc: "Arthroplasty, radial head" },
  { code: "24364", desc: "Arthroplasty, radial head with implant" },
  { code: "24365", desc: "Arthroplasty, radial head and neck" },
  { code: "24366", desc: "Arthroplasty, radial head and neck with implant" },
  { code: "24370", desc: "Revision of total elbow arthroplasty" },
  { code: "24400", desc: "Osteotomy, humerus, with or without internal fixation" },
  { code: "24410", desc: "Multiple osteotomies with realignment, humerus" },
  { code: "24420", desc: "Osteoplasty, humerus" },
  { code: "24430", desc: "Repair of nonunion or malunion, humerus" },
  { code: "24435", desc: "Repair of nonunion or malunion, humerus, with bone graft" },
  { code: "24470", desc: "Hemiepiphyseal arrest, distal humerus" },
  { code: "24498", desc: "Prophylactic treatment, humerus" },
  { code: "24500", desc: "Closed treatment of humeral shaft fracture, without manipulation" },
  { code: "24505", desc: "Closed treatment of humeral shaft fracture, with manipulation" },
  { code: "24515", desc: "ORIF, humeral shaft fracture" },
  { code: "24516", desc: "Treatment of humeral shaft fracture, with insertion of intramedullary implant" },
  { code: "24530", desc: "Closed treatment of supracondylar or transcondylar humeral fracture" },
  { code: "24535", desc: "Closed treatment of supracondylar fracture with manipulation, percutaneous fixation" },
  { code: "24538", desc: "Percutaneous fixation of supracondylar or transcondylar humeral fracture" },
  { code: "24545", desc: "ORIF, humeral condylar fracture, lateral or medial" },
  { code: "24546", desc: "ORIF, humeral condylar fracture, bicondylar" },
  { code: "24560", desc: "Closed treatment of humeral epicondylar fracture" },
  { code: "24565", desc: "Closed treatment of humeral epicondylar fracture with manipulation" },
  { code: "24566", desc: "Percutaneous fixation of humeral epicondylar fracture" },
  { code: "24575", desc: "ORIF, humeral epicondylar fracture" },
  { code: "24577", desc: "Closed treatment of humeral condylar fracture" },
  { code: "24579", desc: "ORIF, humeral condylar fracture" },
  { code: "24582", desc: "Percutaneous fixation of humeral condylar fracture" },
  { code: "24586", desc: "ORIF, periarticular fracture, elbow" },
  { code: "24600", desc: "Treatment of closed elbow dislocation, without anesthesia" },
  { code: "24605", desc: "Treatment of closed elbow dislocation, requiring anesthesia" },
  { code: "24615", desc: "Treatment of open elbow dislocation" },
  { code: "24620", desc: "Closed treatment of Monteggia fracture dislocation" },
  { code: "24635", desc: "ORIF, Monteggia fracture dislocation" },
  { code: "24640", desc: "Closed treatment of radial head subluxation (nursemaid elbow)" },
  { code: "24650", desc: "Closed treatment of radial head or neck fracture, without manipulation" },
  { code: "24655", desc: "Closed treatment of radial head or neck fracture, with manipulation" },
  { code: "24665", desc: "ORIF, radial head or neck fracture" },
  { code: "24666", desc: "ORIF, radial head or neck fracture, with radial head prosthesis" },
  { code: "24670", desc: "Closed treatment of ulnar fracture, proximal, without manipulation" },
  { code: "24675", desc: "Closed treatment of ulnar fracture, proximal, with manipulation" },
  { code: "24685", desc: "ORIF, ulnar fracture, proximal" },
  { code: "29830", desc: "Arthroscopy, elbow, diagnostic" },
  { code: "29834", desc: "Arthroscopy, elbow, with removal of loose body" },
  { code: "29835", desc: "Arthroscopy, elbow, with synovectomy, partial" },
  { code: "29836", desc: "Arthroscopy, elbow, with synovectomy, complete" },
  { code: "29837", desc: "Arthroscopy, elbow, with debridement" },
  { code: "29838", desc: "Arthroscopy, elbow, with excision of loose body or foreign body" },

  // ── Wrist Arthroscopy ────────────────────────────────────────────────────────
  { code: "29840", desc: "Arthroscopy, wrist, diagnostic" },
  { code: "29843", desc: "Arthroscopy, wrist, with repair of TFCC" },
  { code: "29844", desc: "Arthroscopy, wrist, with synovectomy, partial" },
  { code: "29845", desc: "Arthroscopy, wrist, with synovectomy, complete" },
  { code: "29846", desc: "Arthroscopy, wrist, with excision of TFCC" },
  { code: "29847", desc: "Arthroscopy, wrist, with internal fixation of fracture" },

  // ── Injections — Upper Extremity ─────────────────────────────────────────────
  { code: "20526", desc: "Injection, carpal tunnel" },
  { code: "20527", desc: "Injection, enzymatic (e.g., collagenase), palmar fascial cord (Dupuytren contracture)" },
  { code: "20550", desc: "Injection, single tendon sheath or ligament" },
  { code: "20551", desc: "Injection, single tendon origin or insertion" },
  { code: "20552", desc: "Injection, single or multiple trigger points, 1-2 muscles" },
  { code: "20553", desc: "Injection, single or multiple trigger points, 3+ muscles" },
  { code: "20600", desc: "Arthrocentesis, small joint (finger, toe)" },
  { code: "20604", desc: "Arthrocentesis, small joint, with ultrasound guidance" },
  { code: "20605", desc: "Arthrocentesis, intermediate joint (wrist, elbow)" },
  { code: "20606", desc: "Arthrocentesis, intermediate joint, with ultrasound guidance" },
  { code: "20610", desc: "Arthrocentesis, major joint (shoulder, knee, hip)" },
  { code: "20611", desc: "Arthrocentesis, major joint, with ultrasound guidance" },
  { code: "20612", desc: "Aspiration and/or injection of ganglion cyst" },

  // ── Excision & Biopsy — Hand, Wrist, Upper Extremity ─────────────────────────
  { code: "26115", desc: "Excision, tumor, soft tissue, hand or finger, subcutaneous; less than 1.5 cm" },
  { code: "26116", desc: "Excision, tumor, soft tissue, hand or finger, subcutaneous; 1.5 cm or greater" },
  { code: "26117", desc: "Radical resection of tumor, soft tissue, hand or finger; less than 3 cm" },
  { code: "26118", desc: "Radical resection of tumor, soft tissue, hand or finger; 3 cm or greater" },
  { code: "26160", desc: "Excision of lesion of tendon sheath or joint capsule, hand or finger" },
  { code: "26111", desc: "Excision, benign cyst or ganglion of tendon sheath, hand or finger" },
  { code: "26113", desc: "Excision, malignant soft tissue tumor, hand or finger" },
  { code: "25071", desc: "Excision, tumor, soft tissue, forearm and/or wrist; subcutaneous, 3 cm or greater" },
  { code: "25073", desc: "Radical resection of tumor, soft tissue, forearm and/or wrist; less than 3 cm" },
  { code: "25075", desc: "Excision, tumor, soft tissue, forearm and/or wrist; subcutaneous, less than 3 cm" },
  { code: "24071", desc: "Excision, tumor, soft tissue, upper arm or elbow; subcutaneous, less than 3 cm" },
  { code: "24073", desc: "Excision, tumor, soft tissue, upper arm or elbow; subcutaneous, 3 cm or greater" },
  { code: "24075", desc: "Excision, tumor, soft tissue, upper arm or elbow; subfascial, less than 5 cm" },
  { code: "21920", desc: "Biopsy, soft tissue of back or flank; superficial" },
  { code: "20206", desc: "Biopsy, muscle, percutaneous needle" },
  { code: "20220", desc: "Biopsy, bone, trocar, or needle; superficial" },
  { code: "20225", desc: "Biopsy, bone, trocar or needle; deep" },
  { code: "20240", desc: "Biopsy, bone, open; superficial" },
  { code: "20245", desc: "Biopsy, bone, open; deep" },
  { code: "20250", desc: "Biopsy, vertebral body, open; thoracic" },
  { code: "20251", desc: "Biopsy, vertebral body, open; lumbar or cervical" },
  { code: "11100", desc: "Biopsy of skin, subcutaneous tissue; single lesion" },
  { code: "11101", desc: "Biopsy of skin, subcutaneous tissue; each separate/additional lesion" },
  { code: "11400", desc: "Excision, benign lesion, trunk/arm/leg; 0.5 cm or less" },
  { code: "11401", desc: "Excision, benign lesion, trunk/arm/leg; 0.6-1.0 cm" },
  { code: "11402", desc: "Excision, benign lesion, trunk/arm/leg; 1.1-2.0 cm" },
  { code: "11403", desc: "Excision, benign lesion, trunk/arm/leg; 2.1-3.0 cm" },
  { code: "11404", desc: "Excision, benign lesion, trunk/arm/leg; 3.1-4.0 cm" },
  { code: "11406", desc: "Excision, benign lesion, trunk/arm/leg; over 4.0 cm" },
  { code: "11600", desc: "Excision, malignant lesion, trunk/arm/leg; 0.5 cm or less" },
  { code: "11601", desc: "Excision, malignant lesion, trunk/arm/leg; 0.6-1.0 cm" },
  { code: "11602", desc: "Excision, malignant lesion, trunk/arm/leg; 1.1-2.0 cm" },
  { code: "11603", desc: "Excision, malignant lesion, trunk/arm/leg; 2.1-3.0 cm" },
  { code: "11604", desc: "Excision, malignant lesion, trunk/arm/leg; 3.1-4.0 cm" },
  { code: "11606", desc: "Excision, malignant lesion, trunk/arm/leg; over 4.0 cm" },
  { code: "10030", desc: "Image-guided fluid collection drainage, soft tissue" },
  { code: "10060", desc: "Incision and drainage of abscess; simple or single" },
  { code: "10061", desc: "Incision and drainage of abscess; complicated or multiple" },
  { code: "10120", desc: "Incision and removal of foreign body, subcutaneous tissues; simple" },
  { code: "10121", desc: "Incision and removal of foreign body, subcutaneous tissues; complicated" },
  { code: "10140", desc: "Incision and drainage of hematoma, seroma, or fluid collection" },
  { code: "10160", desc: "Puncture aspiration of abscess, hematoma, bulla, or cyst" },

  // ── MCP Joint Arthroplasty & Reconstruction ───────────────────────────────────
  { code: "26530", desc: "Arthroplasty, MCP joint; each joint" },
  { code: "26531", desc: "Arthroplasty, MCP joint with prosthetic implant; each joint" },
  { code: "26535", desc: "Arthroplasty, IP joint; each joint" },
  { code: "26536", desc: "Arthroplasty, IP joint with prosthetic implant; each joint" },
  { code: "26516", desc: "Capsulodesis, MCP joint; single digit" },
  { code: "26517", desc: "Capsulodesis, MCP joint; two digits" },
  { code: "26518", desc: "Capsulodesis, MCP joint; three or four digits" },
  { code: "26520", desc: "Capsulectomy or capsulotomy; MCP joint, each joint" },
  { code: "26525", desc: "Capsulectomy or capsulotomy; IP joint, each joint" },
  { code: "26540", desc: "Repair of collateral ligament, MCP joint" },
  { code: "26541", desc: "Reconstruction collateral ligament, MCP joint, single, with tendon graft" },
  { code: "26542", desc: "Reconstruction collateral ligament, MCP joint, with local tissue" },
  { code: "26545", desc: "Reconstruction collateral ligament, IP joint, single, with tendon graft" },
  { code: "26546", desc: "Repair of nonunion, metacarpal or phalanx" },
  { code: "26548", desc: "Repair and reconstruction, finger, volar plate, IP joint" },
  { code: "26550", desc: "Pollicization of a digit" },
  { code: "26551", desc: "Transfer, toe-to-hand; great toe wrap-around with bone graft" },
  { code: "26553", desc: "Transfer, toe-to-hand; single transfer" },
  { code: "26554", desc: "Transfer, toe-to-hand; double transfer" },
  { code: "26555", desc: "Transfer, finger to another position without amputation" },
  { code: "26560", desc: "Repair of syndactyly; each web space; without skin graft" },
  { code: "26561", desc: "Repair of syndactyly; each web space; with skin graft" },
  { code: "26562", desc: "Repair of syndactyly; each web space; complex" },
  { code: "26565", desc: "Osteotomy; metacarpal, each" },
  { code: "26567", desc: "Osteotomy; phalanx of finger, each" },
  { code: "26568", desc: "Osteoplasty, lengthening, metacarpal or phalanx" },
  { code: "26580", desc: "Repair cleft hand" },
  { code: "26587", desc: "Reconstruction of additional digit, polydactyly" },
  { code: "26590", desc: "Repair macrodactyly" },
  { code: "26591", desc: "Repair, intrinsic muscles of hand, each muscle" },
  { code: "26593", desc: "Release, intrinsic muscles of hand, each muscle" },

  // ── Nerve Repair — Hand & Upper Extremity ─────────────────────────────────────
  { code: "64831", desc: "Suture of digital nerve, hand or foot; single" },
  { code: "64832", desc: "Suture of digital nerve, hand or foot; each additional digital nerve" },
  { code: "64835", desc: "Suture of median motor thenar nerve" },
  { code: "64836", desc: "Suture of ulnar motor nerve" },
  { code: "64837", desc: "Suture of each additional motor nerve" },
  { code: "64840", desc: "Suture of posterior tibial nerve" },
  { code: "64856", desc: "Suture of major peripheral nerve, arm or leg; with transposition" },
  { code: "64857", desc: "Suture of major peripheral nerve, arm or leg; without transposition" },
  { code: "64858", desc: "Suture of sciatic nerve" },
  { code: "64859", desc: "Suture of each additional major peripheral nerve" },
  { code: "64861", desc: "Suture of brachial plexus" },
  { code: "64870", desc: "Suture of facial nerve; intracranial" },
  { code: "64885", desc: "Nerve graft, single strand, up to 4 cm; hand or foot" },
  { code: "64886", desc: "Nerve graft, single strand, more than 4 cm; hand or foot" },
  { code: "64890", desc: "Nerve graft, multiple strands, up to 4 cm; hand or foot" },
  { code: "64891", desc: "Nerve graft, multiple strands, more than 4 cm; hand or foot" },
  { code: "64892", desc: "Nerve graft, single strand, up to 4 cm; arm or leg" },
  { code: "64893", desc: "Nerve graft, single strand, more than 4 cm; arm or leg" },
  { code: "64895", desc: "Nerve graft, multiple strands, up to 4 cm; arm or leg" },
  { code: "64896", desc: "Nerve graft, multiple strands, more than 4 cm; arm or leg" },
  { code: "64905", desc: "Nerve pedicle transfer; first stage" },
  { code: "64906", desc: "Nerve pedicle transfer; second stage" },
  { code: "64910", desc: "Nerve repair; with synthetic conduit or vein allograft" },
  { code: "64911", desc: "Nerve repair; with autogenous vein graft" },
  { code: "64999", desc: "Unlisted procedure, nervous system" },

  // ── Amputation & Replantation ─────────────────────────────────────────────────
  { code: "26910", desc: "Amputation, metacarpal, with finger or thumb" },
  { code: "26951", desc: "Amputation, finger or thumb, primary; each finger or thumb" },
  { code: "26952", desc: "Amputation, finger or thumb, primary with local advancement flap; each" },
  { code: "26989", desc: "Unlisted procedure, hands or fingers" },
  { code: "20802", desc: "Replantation, arm, complete amputation; elbow through forearm" },
  { code: "20805", desc: "Replantation, forearm, complete amputation" },
  { code: "20808", desc: "Replantation, hand, complete amputation" },
  { code: "20816", desc: "Replantation, digit, excluding thumb, complete amputation; single finger" },
  { code: "20822", desc: "Replantation, digit, excluding thumb; each additional digit" },
  { code: "20824", desc: "Replantation, thumb, complete amputation" },
  { code: "20827", desc: "Replantation, thumb, complete amputation; with microvascular anastomosis" },

  // ── Skin & Wound Closure ──────────────────────────────────────────────────────
  { code: "12001", desc: "Simple repair of superficial wounds; 2.5 cm or less" },
  { code: "12002", desc: "Simple repair of superficial wounds; 2.6-7.5 cm" },
  { code: "12004", desc: "Simple repair of superficial wounds; 7.6-12.5 cm" },
  { code: "12011", desc: "Simple repair, face/ears/eyelids/nose/lips/mucous membranes; 2.5 cm or less" },
  { code: "12041", desc: "Repair, intermediate, neck/hands/feet/genitalia; 2.5 cm or less" },
  { code: "12042", desc: "Repair, intermediate, neck/hands/feet/genitalia; 2.6-7.5 cm" },
  { code: "13120", desc: "Repair, complex, scalp/arms/legs; 1.1-2.5 cm" },
  { code: "13121", desc: "Repair, complex, scalp/arms/legs; 2.6-7.5 cm" },
  { code: "13122", desc: "Repair, complex, scalp/arms/legs; each additional 5 cm or less" },
  { code: "14020", desc: "Adjacent tissue transfer or rearrangement, scalp/arms/legs; 10 sq cm or less" },
  { code: "14021", desc: "Adjacent tissue transfer or rearrangement, scalp/arms/legs; 10.1-30.0 sq cm" },
  { code: "15120", desc: "Split-thickness autograft, face/scalp/eyelids/ears/nose/lips; first 100 sq cm" },
  { code: "15121", desc: "Split-thickness autograft; each additional 100 sq cm" },
  { code: "15240", desc: "Full thickness graft, free, including direct closure of donor site; 20 sq cm or less" },
  { code: "15241", desc: "Full thickness graft; each additional 20 sq cm" },
  { code: "15570", desc: "Formation of direct or tubed pedicle, with or without transfer; trunk" },
  { code: "15574", desc: "Formation of direct or tubed pedicle; forearm" },
  { code: "15576", desc: "Formation of direct or tubed pedicle; hand/finger" },

  // ── Shoulder — Open & Arthroscopic ────────────────────────────────────────
  { code: "23395", desc: "Muscle transfer, any type, shoulder or upper arm; single" },
  { code: "23400", desc: "Scapulopexy" },
  { code: "23410", desc: "Repair of ruptured musculotendinous cuff; acute" },
  { code: "23412", desc: "Repair of ruptured musculotendinous cuff; chronic" },
  { code: "23415", desc: "Coracoacromial ligament release, with or without coracoplasty" },
  { code: "23420", desc: "Reconstruction of complete shoulder (rotator) cuff avulsion" },
  { code: "23430", desc: "Tenodesis of long tendon of biceps" },
  { code: "23440", desc: "Resection or transplantation of long tendon of biceps" },
  { code: "23450", desc: "Capsulorrhaphy, anterior, Putti-Platt or Bankart procedure" },
  { code: "23455", desc: "Capsulorrhaphy, anterior; with labral repair" },
  { code: "23460", desc: "Capsulorrhaphy, anterior, any type; with bone block" },
  { code: "23462", desc: "Capsulorrhaphy, posterior" },
  { code: "23465", desc: "Capsulorrhaphy, glenohumeral joint, posterior, with or without bone block" },
  { code: "23466", desc: "Capsulorrhaphy, glenohumeral joint, any type, multidirectional instability" },
  { code: "23470", desc: "Arthroplasty, glenohumeral joint; hemiarthroplasty" },
  { code: "23472", desc: "Arthroplasty, glenohumeral joint; total shoulder, excluding reverse" },
  { code: "23473", desc: "Revision of total shoulder arthroplasty" },
  { code: "23474", desc: "Revision of total shoulder arthroplasty; humeral or glenoid component" },
  { code: "23480", desc: "Osteotomy, clavicle, with or without internal fixation" },
  { code: "23485", desc: "Osteotomy, clavicle, with bone graft" },
  { code: "23490", desc: "Prophylactic treatment, clavicle" },
  { code: "23500", desc: "Closed treatment of clavicular fracture, without manipulation" },
  { code: "23505", desc: "Closed treatment of clavicular fracture, with manipulation" },
  { code: "23515", desc: "ORIF, clavicular fracture" },
  { code: "23530", desc: "Closed treatment of sternoclavicular dislocation, acute or chronic" },
  { code: "23532", desc: "ORIF, sternoclavicular dislocation" },
  { code: "23540", desc: "Closed treatment of acromioclavicular dislocation, acute" },
  { code: "23545", desc: "Closed treatment of AC dislocation, with manipulation" },
  { code: "23550", desc: "ORIF, acromioclavicular dislocation, acute or chronic" },
  { code: "23552", desc: "ORIF, acromioclavicular dislocation, with fascial graft" },
  { code: "23570", desc: "Closed treatment of scapular fracture, without manipulation" },
  { code: "23575", desc: "Closed treatment of scapular fracture, with manipulation" },
  { code: "23585", desc: "ORIF, scapular fracture" },
  { code: "23600", desc: "Closed treatment of proximal humeral fracture, without manipulation" },
  { code: "23605", desc: "Closed treatment of proximal humeral fracture, with manipulation" },
  { code: "23615", desc: "ORIF, proximal humeral fracture" },
  { code: "23616", desc: "ORIF, proximal humeral fracture with prosthetic replacement" },
  { code: "23620", desc: "Closed treatment of greater tuberosity fracture, without manipulation" },
  { code: "23625", desc: "Closed treatment of greater tuberosity fracture, with manipulation" },
  { code: "23630", desc: "ORIF, greater tuberosity fracture" },
  { code: "23650", desc: "Closed treatment of shoulder dislocation, without anesthesia" },
  { code: "23655", desc: "Closed treatment of shoulder dislocation, requiring anesthesia" },
  { code: "23660", desc: "ORIF, acute shoulder dislocation" },
  { code: "23670", desc: "Closed treatment of shoulder dislocation with surgical or anatomical neck fracture" },
  { code: "23675", desc: "Closed treatment of shoulder dislocation with fracture, with manipulation" },
  { code: "23680", desc: "ORIF, shoulder dislocation with fracture" },
  { code: "29819", desc: "Arthroscopy, shoulder, with removal of loose body or foreign body" },
  { code: "29820", desc: "Arthroscopy, shoulder, surgical; synovectomy, partial" },
  { code: "29821", desc: "Arthroscopy, shoulder, surgical; synovectomy, complete" },
  { code: "29822", desc: "Arthroscopy, shoulder, surgical; debridement, limited" },
  { code: "29824", desc: "Arthroscopy, shoulder, distal claviculectomy including AC joint" },
  { code: "29825", desc: "Arthroscopy, shoulder, with lysis and resection of adhesions" },
  { code: "29826", desc: "Arthroscopy, shoulder, decompression of subacromial space with partial acromioplasty" },
  { code: "29827", desc: "Arthroscopy, shoulder, with rotator cuff repair" },
  { code: "29828", desc: "Arthroscopy, shoulder, biceps tenodesis" },
  { code: "29806", desc: "Arthroscopy, shoulder, capsulorrhaphy" },
  { code: "29807", desc: "Arthroscopy, shoulder, repair of SLAP lesion" },
  { code: "29814", desc: "Arthroscopy, shoulder, with glenoid bone grafting" },
  { code: "29815", desc: "Arthroscopy, shoulder, instability repair, anterior" },
  { code: "29816", desc: "Arthroscopy, shoulder, instability repair, posterior" },
  { code: "29817", desc: "Arthroscopy, shoulder, instability repair, multidirectional" },

  // ── Hip — Open & Arthroscopic ──────────────────────────────────────────────
  { code: "27033", desc: "Arthrotomy, hip, with exploration or removal of loose body" },
  { code: "27035", desc: "Denervation, hip joint, intrapelvic or extrapelvic intraarticular branches" },
  { code: "27036", desc: "Capsulectomy or capsulotomy, hip, with or without excision of heterotopic bone" },
  { code: "27040", desc: "Biopsy, soft tissue of hip; superficial" },
  { code: "27041", desc: "Biopsy, soft tissue of hip; deep, subfascial or intramuscular" },
  { code: "27050", desc: "Arthrotomy, with biopsy, sacroiliac joint" },
  { code: "27052", desc: "Arthrotomy, with joint exploration, including biopsy, hip" },
  { code: "27054", desc: "Arthrotomy with synovectomy, hip" },
  { code: "27060", desc: "Excision, ischial bursa" },
  { code: "27062", desc: "Excision, trochanteric bursa" },
  { code: "27070", desc: "Partial excision, bone, hip" },
  { code: "27071", desc: "Partial excision, bone, hip; deep" },
  { code: "27080", desc: "Coccygectomy, primary" },
  { code: "27090", desc: "Removal of hip prosthesis" },
  { code: "27091", desc: "Removal of hip prosthesis; complicated" },
  { code: "27095", desc: "Injection procedure for hip arthrography" },
  { code: "27096", desc: "Injection procedure for sacroiliac joint arthrography" },
  { code: "27097", desc: "Release or recession, hamstring, proximal" },
  { code: "27098", desc: "Transfer, adductor to ischium" },
  { code: "27100", desc: "Transfer external oblique muscle to greater trochanter" },
  { code: "27105", desc: "Transfer paraspinal muscle to hip" },
  { code: "27110", desc: "Transfer iliopsoas to greater trochanter of femur" },
  { code: "27111", desc: "Transfer iliopsoas; to femoral neck" },
  { code: "27120", desc: "Acetabuloplasty; primary" },
  { code: "27122", desc: "Acetabuloplasty; resection, femoral head" },
  { code: "27125", desc: "Hemiarthroplasty, hip, partial" },
  { code: "27130", desc: "Total hip arthroplasty" },
  { code: "27132", desc: "Conversion of previous hip surgery to total hip arthroplasty" },
  { code: "27134", desc: "Revision of total hip arthroplasty; both components" },
  { code: "27137", desc: "Revision of total hip arthroplasty; acetabular component only" },
  { code: "27138", desc: "Revision of total hip arthroplasty; femoral component only" },
  { code: "27140", desc: "Osteotomy, femoral neck" },
  { code: "27146", desc: "Osteotomy, iliac, acetabular or innominate bone" },
  { code: "27147", desc: "Osteotomy, iliac, acetabular or innominate bone; with open reduction of hip" },
  { code: "27151", desc: "Osteotomy, iliac, acetabular or innominate bone, periacetabular" },
  { code: "27165", desc: "Osteotomy, intertrochanteric or subtrochanteric including internal or external fixation" },
  { code: "27170", desc: "Bone graft, femoral head, neck, intertrochanteric" },
  { code: "27175", desc: "Treatment of slipped femoral epiphysis; by traction, without reduction" },
  { code: "27176", desc: "Treatment of slipped femoral epiphysis; by single or multiple pinning, in situ" },
  { code: "27177", desc: "ORIF, slipped femoral epiphysis" },
  { code: "27178", desc: "Closed treatment of slipped femoral epiphysis, with osteoplasty" },
  { code: "27179", desc: "Osteoplasty of femoral neck" },
  { code: "27181", desc: "ORIF, slipped femoral epiphysis, with osteoplasty" },
  { code: "27185", desc: "Epiphyseal arrest by epiphysiodesis or stapling, greater trochanter of femur" },
  { code: "27197", desc: "Closed treatment of posterior pelvic ring fracture" },
  { code: "27198", desc: "Closed treatment of posterior pelvic ring fracture, with manipulation" },
  { code: "27200", desc: "Closed treatment of coccygeal fracture" },
  { code: "27215", desc: "ORIF, iliac fracture" },
  { code: "27216", desc: "Percutaneous skeletal fixation of posterior pelvic ring fracture" },
  { code: "27217", desc: "ORIF, anterior pelvic ring fracture" },
  { code: "27218", desc: "ORIF, posterior pelvic ring fracture" },
  { code: "27220", desc: "Closed treatment of acetabulum fracture, without manipulation" },
  { code: "27222", desc: "Closed treatment of acetabulum fracture, with manipulation" },
  { code: "27226", desc: "ORIF, acetabulum fracture, one column" },
  { code: "27227", desc: "ORIF, acetabulum fracture, two columns" },
  { code: "27228", desc: "ORIF, acetabulum fracture, two columns, with arthroplasty" },
  { code: "27230", desc: "Closed treatment of femoral fracture, proximal end, neck; without manipulation" },
  { code: "27232", desc: "Closed treatment of femoral fracture, proximal, neck; with manipulation" },
  { code: "27235", desc: "Percutaneous skeletal fixation of femoral fracture, proximal end, neck" },
  { code: "27236", desc: "ORIF, femoral fracture, proximal end, neck" },
  { code: "27238", desc: "Closed treatment of intertrochanteric, pertrochanteric, or subtrochanteric femoral fracture; without manipulation" },
  { code: "27240", desc: "Closed treatment of intertrochanteric fracture; with manipulation" },
  { code: "27244", desc: "Treatment of intertrochanteric fracture; with plate/screw type implant" },
  { code: "27245", desc: "Treatment of intertrochanteric fracture; with intramedullary implant" },
  { code: "27246", desc: "Closed treatment of greater trochanteric fracture, without manipulation" },
  { code: "27248", desc: "ORIF, greater trochanteric fracture" },
  { code: "27250", desc: "Closed treatment of hip dislocation, traumatic; without anesthesia" },
  { code: "27252", desc: "Closed treatment of hip dislocation; requiring anesthesia" },
  { code: "27253", desc: "ORIF, hip dislocation, traumatic" },
  { code: "27254", desc: "ORIF, hip dislocation with acetabular wall fracture" },
  { code: "27256", desc: "Treatment of spontaneous hip dislocation; requiring anesthesia" },
  { code: "27257", desc: "Treatment of spontaneous hip dislocation; with acetabular cartilage repair" },
  { code: "27258", desc: "ORIF, spontaneous hip dislocation, acetabular cartilage repair" },
  { code: "27259", desc: "Open treatment of spontaneous hip dislocation with acetabular repair, including repair of ligamentum teres" },
  { code: "27269", desc: "Closed treatment of femoral fracture, proximal end, head" },
  { code: "29860", desc: "Arthroscopy, hip, diagnostic" },
  { code: "29861", desc: "Arthroscopy, hip, with removal of loose body or foreign body" },
  { code: "29862", desc: "Arthroscopy, hip, surgical; with chondroplasty" },
  { code: "29863", desc: "Arthroscopy, hip, surgical; with synovectomy" },
  { code: "29914", desc: "Arthroscopy, hip, surgical; with femoroplasty" },
  { code: "29915", desc: "Arthroscopy, hip, surgical; with acetabuloplasty" },
  { code: "29916", desc: "Arthroscopy, hip, surgical; with labral repair" },

  // ── Knee — Open & Arthroscopic ─────────────────────────────────────────────
  { code: "27310", desc: "Arthrotomy, knee, with exploration, drainage" },
  { code: "27315", desc: "Neurectomy, popliteal (gastrocnemius)" },
  { code: "27320", desc: "Neurectomy, popliteal; hamstring" },
  { code: "27323", desc: "Biopsy, soft tissue of thigh or knee; superficial" },
  { code: "27324", desc: "Biopsy, soft tissue of thigh or knee; deep, subfascial, or intramuscular" },
  { code: "27325", desc: "Neurectomy, hamstring muscle" },
  { code: "27326", desc: "Neurectomy, popliteal" },
  { code: "27327", desc: "Excision, tumor, soft tissue thigh or knee; subcutaneous, less than 3 cm" },
  { code: "27328", desc: "Excision, tumor, soft tissue thigh or knee; subfascial, less than 5 cm" },
  { code: "27329", desc: "Radical resection of tumor, soft tissue thigh or knee; less than 5 cm" },
  { code: "27330", desc: "Arthrotomy, knee; with synovial biopsy only" },
  { code: "27331", desc: "Arthrotomy, knee; including joint exploration, biopsy, or removal of loose body" },
  { code: "27332", desc: "Arthrotomy, with excision of semilunar cartilage (meniscectomy); medial OR lateral" },
  { code: "27333", desc: "Arthrotomy, with excision of semilunar cartilage (meniscectomy); medial AND lateral" },
  { code: "27334", desc: "Arthrotomy, with synovectomy; anterior OR posterior" },
  { code: "27335", desc: "Arthrotomy, with synovectomy; anterior AND posterior" },
  { code: "27340", desc: "Excision, prepatellar bursa" },
  { code: "27345", desc: "Excision of popliteal cyst (Baker cyst)" },
  { code: "27347", desc: "Excision of lesion of meniscus or capsule; knee" },
  { code: "27350", desc: "Patellectomy or hemipatellectomy" },
  { code: "27355", desc: "Excision or curettage of bone cyst, distal femur" },
  { code: "27356", desc: "Excision or curettage of bone cyst, distal femur; with allograft" },
  { code: "27357", desc: "Excision or curettage of bone cyst, distal femur; with internal fixation" },
  { code: "27358", desc: "Excision or curettage of bone cyst or benign tumor, distal femur; with allograft and internal fixation" },
  { code: "27360", desc: "Partial excision, bone, femur or patella, intraarticular" },
  { code: "27365", desc: "Radical resection of tumor, bone, distal femur" },
  { code: "27370", desc: "Injection procedure for knee arthrography or viscosupplementation" },
  { code: "27372", desc: "Removal of foreign body, deep, thigh region or knee" },
  { code: "27380", desc: "Suture of infrapatellar tendon; primary" },
  { code: "27381", desc: "Suture of infrapatellar tendon; secondary reconstruction" },
  { code: "27385", desc: "Suture of quadriceps or hamstring muscle rupture; primary" },
  { code: "27386", desc: "Suture of quadriceps or hamstring muscle rupture; secondary reconstruction" },
  { code: "27390", desc: "Tenotomy, hamstring, knee to hip; single tendon" },
  { code: "27391", desc: "Tenotomy, hamstring, knee to hip; multiple tendons, each leg" },
  { code: "27392", desc: "Tenotomy, hamstring, knee to hip; bilateral, multiple tendons" },
  { code: "27393", desc: "Lengthening of hamstring tendon; single tendon" },
  { code: "27394", desc: "Lengthening of hamstring tendon; multiple tendons, each leg" },
  { code: "27395", desc: "Lengthening of hamstring tendon; bilateral, multiple tendons" },
  { code: "27396", desc: "Transplant, hamstring tendon to patella; single tendon" },
  { code: "27397", desc: "Transplant, hamstring tendon to patella; multiple tendons" },
  { code: "27400", desc: "Transfer or transplant of tendon, muscle fascia; knee area" },
  { code: "27403", desc: "Arthrotomy with meniscal repair, knee" },
  { code: "27405", desc: "Repair, primary, torn ligament and/or capsule, knee; collateral" },
  { code: "27407", desc: "Repair, primary, torn ligament and/or capsule, knee; cruciate" },
  { code: "27409", desc: "Repair, primary, torn ligament and/or capsule, knee; collateral and cruciate ligaments" },
  { code: "27412", desc: "Autologous chondrocyte implantation, knee" },
  { code: "27415", desc: "Osteochondral allograft, knee" },
  { code: "27416", desc: "Osteochondral autograft, knee" },
  { code: "27418", desc: "Anterior tibial tubercleplasty" },
  { code: "27420", desc: "Reconstruction of dislocating patella" },
  { code: "27422", desc: "Reconstruction of dislocating patella; with extensor realignment" },
  { code: "27424", desc: "Reconstruction of dislocating patella; with patellectomy" },
  { code: "27425", desc: "Lateral retinacular release, open" },
  { code: "27427", desc: "Ligamentous reconstruction (augmentation), knee; extra-articular" },
  { code: "27428", desc: "Ligamentous reconstruction, knee; intra-articular" },
  { code: "27429", desc: "Ligamentous reconstruction, knee; intra-articular and extra-articular" },
  { code: "27430", desc: "Quadricepsplasty" },
  { code: "27435", desc: "Capsulotomy, posterior capsular release, knee" },
  { code: "27437", desc: "Arthroplasty, patella; without prosthesis" },
  { code: "27438", desc: "Arthroplasty, patella; with prosthesis" },
  { code: "27440", desc: "Arthroplasty, knee, tibial plateau" },
  { code: "27441", desc: "Arthroplasty, knee, tibial plateau; with bone graft" },
  { code: "27442", desc: "Arthroplasty, femoral condyles or tibial plateau; medial OR lateral" },
  { code: "27443", desc: "Arthroplasty, femoral condyles or tibial plateau; medial AND lateral" },
  { code: "27445", desc: "Arthroplasty, knee, hinge prosthesis" },
  { code: "27446", desc: "Arthroplasty, knee, condyle and plateau; medial OR lateral" },
  { code: "27447", desc: "Total knee arthroplasty, condyle and plateau; medial AND lateral" },
  { code: "27448", desc: "Osteotomy, femur, shaft or supracondylar; without fixation" },
  { code: "27450", desc: "Osteotomy, femur, shaft or supracondylar; with fixation" },
  { code: "27454", desc: "Osteotomy, multiple, with realignment on intramedullary rod, femoral shaft" },
  { code: "27455", desc: "Osteotomy, proximal tibia; without fibula osteotomy" },
  { code: "27457", desc: "Osteotomy, proximal tibia; with fibula osteotomy" },
  { code: "27465", desc: "Osteoplasty, femur; shortening" },
  { code: "27466", desc: "Osteoplasty, femur; lengthening" },
  { code: "27468", desc: "Osteoplasty, femur; combined, lengthening and shortening with segment transfer" },
  { code: "27470", desc: "Repair of nonunion or malunion, femur, distal to head and neck" },
  { code: "27472", desc: "Repair of nonunion or malunion, femur; with bone graft" },
  { code: "27477", desc: "Arrest, epiphyseal, any method; distal femur" },
  { code: "27479", desc: "Arrest, epiphyseal, any method; combined distal femur, proximal tibia, and fibula" },
  { code: "27485", desc: "Hemarthroplasty, knee, medial or lateral compartment" },
  { code: "27486", desc: "Revision of total knee arthroplasty; one component" },
  { code: "27487", desc: "Revision of total knee arthroplasty; femoral and entire tibial component" },
  { code: "27488", desc: "Removal of prosthesis, including all cement, from femoral and tibial canals" },
  { code: "27495", desc: "Prophylactic treatment, femur; with or without intramedullary rod" },
  { code: "27500", desc: "Closed treatment of femoral shaft fracture, without manipulation" },
  { code: "27501", desc: "Closed treatment of supracondylar or transcondylar femoral fracture without intercondylar extension" },
  { code: "27502", desc: "Closed treatment of femoral shaft fracture, with manipulation" },
  { code: "27503", desc: "Closed treatment of supracondylar or transcondylar femoral fracture with manipulation" },
  { code: "27506", desc: "ORIF, femoral shaft fracture with plate/screws" },
  { code: "27507", desc: "ORIF, femoral shaft fracture; with intramedullary implant" },
  { code: "27510", desc: "Closed treatment of distal femoral fracture, without manipulation" },
  { code: "27511", desc: "ORIF, distal femoral fracture; medial or lateral condyle" },
  { code: "27513", desc: "ORIF, distal femoral fracture; intercondylar" },
  { code: "27514", desc: "ORIF, distal femoral fracture; with intramedullary implant" },
  { code: "27520", desc: "Closed treatment of patellar fracture, without manipulation" },
  { code: "27522", desc: "Closed treatment of patellar fracture, with manipulation" },
  { code: "27524", desc: "ORIF, patellar fracture" },
  { code: "27530", desc: "Closed treatment of tibial fracture, proximal; without manipulation" },
  { code: "27532", desc: "Closed treatment of tibial fracture, proximal; with manipulation" },
  { code: "27535", desc: "ORIF, tibial fracture, proximal; unicondylar, medial or lateral" },
  { code: "27536", desc: "ORIF, tibial fracture, proximal; bicondylar" },
  { code: "27540", desc: "ORIF, tibial fracture, proximal; with total knee arthroplasty" },
  { code: "27550", desc: "Closed treatment of knee dislocation; without anesthesia" },
  { code: "27552", desc: "Closed treatment of knee dislocation; requiring anesthesia" },
  { code: "27556", desc: "ORIF, knee dislocation" },
  { code: "27557", desc: "ORIF, knee dislocation; with ligament repair" },
  { code: "27558", desc: "ORIF, knee dislocation; with ligament repair and primary or secondary reconstruction" },
  { code: "27560", desc: "Closed treatment of patellar dislocation; without anesthesia" },
  { code: "27562", desc: "Closed treatment of patellar dislocation; requiring anesthesia" },
  { code: "27566", desc: "ORIF, patellar dislocation, with or without partial or total patellectomy" },
  { code: "27570", desc: "Manipulation of knee joint under general anesthesia" },
  { code: "27580", desc: "Arthrodesis, knee, any technique" },
  { code: "29870", desc: "Arthroscopy, knee, diagnostic" },
  { code: "29871", desc: "Arthroscopy, knee, with irrigation and drainage for infection" },
  { code: "29873", desc: "Arthroscopy, knee, with lateral retinacular release" },
  { code: "29874", desc: "Arthroscopy, knee, for removal of loose body" },
  { code: "29875", desc: "Arthroscopy, knee, surgical; synovectomy, limited" },
  { code: "29876", desc: "Arthroscopy, knee, surgical; synovectomy, major, two or more compartments" },
  { code: "29877", desc: "Arthroscopy, knee, surgical; debridement/shaving of articular cartilage (chondroplasty)" },
  { code: "29879", desc: "Arthroscopy, knee, surgical; abrasion arthroplasty or multiple drilling or microfracture" },
  { code: "29880", desc: "Arthroscopy, knee, surgical; with meniscectomy, medial AND lateral" },
  { code: "29881", desc: "Arthroscopy, knee, surgical; with meniscectomy, medial OR lateral" },
  { code: "29882", desc: "Arthroscopy, knee, surgical; with meniscus repair, medial OR lateral" },
  { code: "29883", desc: "Arthroscopy, knee, surgical; with meniscus repair, medial AND lateral" },
  { code: "29884", desc: "Arthroscopy, knee, surgical; with lysis of adhesions, with or without manipulation" },
  { code: "29885", desc: "Arthroscopy, knee, surgical; drilling for osteochondritis dissecans with bone grafting" },
  { code: "29886", desc: "Arthroscopy, knee, surgical; drilling for intact osteochondritis dissecans lesion" },
  { code: "29887", desc: "Arthroscopy, knee, surgical; drilling for intact osteochondritis dissecans with internal fixation" },
  { code: "29888", desc: "Arthroscopy, knee, surgical; ACL repair/augmentation or reconstruction" },
  { code: "29889", desc: "Arthroscopy, knee, surgical; PCL repair/augmentation or reconstruction" },

  // ── Leg, Ankle & Foot ──────────────────────────────────────────────────────
  { code: "27600", desc: "Decompression fasciotomy, leg; anterior and/or lateral compartments only" },
  { code: "27601", desc: "Decompression fasciotomy, leg; posterior compartment only" },
  { code: "27602", desc: "Decompression fasciotomy, leg; anterior, lateral, and posterior compartments" },
  { code: "27603", desc: "Excision, tumor, soft tissue, leg or ankle area; subcutaneous, less than 3 cm" },
  { code: "27604", desc: "Excision, tumor, soft tissue, leg or ankle area; subfascial, less than 5 cm" },
  { code: "27605", desc: "Tenotomy, percutaneous, Achilles tendon; local anesthesia" },
  { code: "27606", desc: "Tenotomy, percutaneous, Achilles tendon; general anesthesia" },
  { code: "27607", desc: "Excision of lesion, tendon, or bursa, leg or ankle" },
  { code: "27610", desc: "Arthrotomy, ankle, with exploration, drainage, or removal of foreign body" },
  { code: "27612", desc: "Arthrotomy, ankle; with joint exploration, with or without biopsy" },
  { code: "27613", desc: "Biopsy, soft tissue of leg or ankle area; superficial" },
  { code: "27614", desc: "Biopsy, soft tissue of leg or ankle area; deep, subfascial or intramuscular" },
  { code: "27620", desc: "Arthrotomy, ankle, with synovectomy" },
  { code: "27625", desc: "Arthrotomy, with synovectomy, ankle; anterior" },
  { code: "27626", desc: "Arthrotomy, with synovectomy, ankle; anterior and posterior" },
  { code: "27630", desc: "Excision of lesion of tendon sheath or capsule, leg and/or ankle" },
  { code: "27632", desc: "Excision, ganglion, ankle or foot" },
  { code: "27634", desc: "Excision, tumor or vascular malformation, soft tissue, leg or ankle" },
  { code: "27635", desc: "Excision or curettage of bone cyst or benign tumor, tibia or fibula" },
  { code: "27637", desc: "Excision or curettage of bone cyst, tibia or fibula; with allograft" },
  { code: "27638", desc: "Excision or curettage of bone cyst, tibia or fibula; with internal fixation" },
  { code: "27640", desc: "Partial excision, bone, tibia" },
  { code: "27641", desc: "Partial excision, fibula" },
  { code: "27645", desc: "Radical resection of tumor, tibia" },
  { code: "27646", desc: "Radical resection of tumor, fibula" },
  { code: "27647", desc: "Radical resection of tumor, talus or calcaneus" },
  { code: "27648", desc: "Injection procedure for ankle arthrography" },
  { code: "27650", desc: "Repair, primary, open or percutaneous, ruptured Achilles tendon" },
  { code: "27652", desc: "Repair, primary, open or percutaneous, ruptured Achilles tendon; with graft" },
  { code: "27654", desc: "Repair, secondary, Achilles tendon, with or without graft" },
  { code: "27656", desc: "Fasciotomy, plantar" },
  { code: "27658", desc: "Repair, primary, flexor tendon, leg; primary" },
  { code: "27659", desc: "Repair, primary, flexor tendon, leg; secondary" },
  { code: "27664", desc: "Repair, primary, extensor tendon, leg; primary" },
  { code: "27665", desc: "Repair, primary, extensor tendon, leg; secondary" },
  { code: "27675", desc: "Repair, dislocating peroneal tendons; without fibular osteotomy" },
  { code: "27676", desc: "Repair, dislocating peroneal tendons; with fibular osteotomy" },
  { code: "27680", desc: "Tenolysis, flexor or extensor tendon, leg and/or ankle; single tendon" },
  { code: "27681", desc: "Tenolysis, flexor or extensor tendon, leg and/or ankle; multiple tendons" },
  { code: "27685", desc: "Lengthening or shortening of tendon, leg or ankle; single tendon" },
  { code: "27686", desc: "Lengthening or shortening of tendon, leg or ankle; multiple tendons" },
  { code: "27687", desc: "Gastrocnemius recession" },
  { code: "27690", desc: "Transfer or transplant of single tendon, leg" },
  { code: "27691", desc: "Transfer or transplant of each additional tendon, leg" },
  { code: "27695", desc: "Repair, primary, disrupted ligament, ankle; collateral" },
  { code: "27696", desc: "Repair, primary, disrupted ligament, ankle; both collateral ligaments" },
  { code: "27698", desc: "Repair, secondary, disrupted ligament, ankle, collateral" },
  { code: "27700", desc: "Arthroplasty, ankle" },
  { code: "27702", desc: "Arthroplasty, ankle; with implant" },
  { code: "27703", desc: "Arthroplasty, ankle; revision" },
  { code: "27704", desc: "Removal of ankle implant" },
  { code: "27705", desc: "Osteotomy, tibia" },
  { code: "27707", desc: "Osteotomy, fibula" },
  { code: "27709", desc: "Osteotomy, tibia and fibula" },
  { code: "27712", desc: "Multiple osteotomies, with realignment on intramedullary rod, tibia" },
  { code: "27715", desc: "Osteoplasty, tibia and/or fibula, lengthening or shortening" },
  { code: "27720", desc: "Repair of nonunion or malunion, tibia; without graft" },
  { code: "27722", desc: "Repair of nonunion or malunion, tibia; with bone graft" },
  { code: "27724", desc: "Repair of nonunion or malunion, tibia; with sliding graft" },
  { code: "27725", desc: "Repair of nonunion or malunion of fibula" },
  { code: "27727", desc: "Repair of congenital pseudoarthrosis, tibia" },
  { code: "27730", desc: "Arrest, epiphyseal, distal tibia" },
  { code: "27732", desc: "Arrest, epiphyseal, distal fibula" },
  { code: "27734", desc: "Arrest, epiphyseal, distal tibia and fibula" },
  { code: "27740", desc: "Arrest, epiphyseal, any method, combined distal tibia and fibula" },
  { code: "27745", desc: "Prophylactic treatment, tibia; with or without intramedullary rod" },
  { code: "27750", desc: "Closed treatment of tibial shaft fracture, without manipulation" },
  { code: "27752", desc: "Closed treatment of tibial shaft fracture, with manipulation" },
  { code: "27756", desc: "Percutaneous skeletal fixation of tibial shaft fracture" },
  { code: "27758", desc: "ORIF, tibial shaft fracture with plate/screws" },
  { code: "27759", desc: "Treatment of tibial shaft fracture; by intramedullary implant" },
  { code: "27760", desc: "Closed treatment of medial malleolus fracture, without manipulation" },
  { code: "27762", desc: "Closed treatment of medial malleolus fracture, with manipulation" },
  { code: "27766", desc: "ORIF, medial malleolus fracture" },
  { code: "27767", desc: "Closed treatment of posterior malleolus fracture, without manipulation" },
  { code: "27768", desc: "Closed treatment of posterior malleolus fracture, with manipulation" },
  { code: "27769", desc: "ORIF, posterior malleolus fracture" },
  { code: "27780", desc: "Closed treatment of proximal fibula fracture, without manipulation" },
  { code: "27781", desc: "Closed treatment of proximal fibula fracture, with manipulation" },
  { code: "27782", desc: "Closed treatment of proximal fibula fracture; with manipulation, immobilization" },
  { code: "27784", desc: "ORIF, proximal fibula fracture" },
  { code: "27786", desc: "Closed treatment of distal fibular fracture, without manipulation" },
  { code: "27788", desc: "Closed treatment of distal fibular fracture, with manipulation" },
  { code: "27792", desc: "ORIF, distal fibular fracture" },
  { code: "27808", desc: "Closed treatment of bimalleolar ankle fracture, without manipulation" },
  { code: "27810", desc: "Closed treatment of bimalleolar ankle fracture, with manipulation" },
  { code: "27814", desc: "ORIF, bimalleolar ankle fracture" },
  { code: "27816", desc: "Closed treatment of trimalleolar ankle fracture, without manipulation" },
  { code: "27818", desc: "Closed treatment of trimalleolar ankle fracture, with manipulation" },
  { code: "27822", desc: "ORIF, trimalleolar ankle fracture; medial and posterior malleoli only" },
  { code: "27823", desc: "ORIF, trimalleolar ankle fracture; medial, lateral, and posterior malleoli" },
  { code: "27824", desc: "Closed treatment of fracture of weight bearing articular portion of distal tibia, without manipulation" },
  { code: "27825", desc: "Closed treatment of pilon fracture, with manipulation" },
  { code: "27826", desc: "ORIF, pilon fracture; fibula only" },
  { code: "27827", desc: "ORIF, pilon fracture; tibia only" },
  { code: "27828", desc: "ORIF, pilon fracture; tibia and fibula" },
  { code: "27829", desc: "ORIF, distal tibiofibular joint diastasis" },
  { code: "27830", desc: "Closed treatment of proximal tibiofibular joint dislocation" },
  { code: "27831", desc: "Closed treatment of proximal tibiofibular joint dislocation; with anesthesia" },
  { code: "27832", desc: "ORIF, proximal tibiofibular joint dislocation" },
  { code: "27840", desc: "Closed treatment of ankle dislocation, without anesthesia" },
  { code: "27842", desc: "Closed treatment of ankle dislocation, requiring anesthesia" },
  { code: "27846", desc: "ORIF, ankle dislocation" },
  { code: "27848", desc: "ORIF, ankle dislocation; with fracture" },
  { code: "27870", desc: "Arthrodesis, ankle, open" },
  { code: "27871", desc: "Arthrodesis, tibiofibular joint, proximal or distal" },
  { code: "27880", desc: "Amputation, leg, through tibia and fibula" },
  { code: "27881", desc: "Amputation, leg; with immediate fitting technique" },
  { code: "27882", desc: "Amputation, leg; open, circular" },
  { code: "27884", desc: "Amputation, leg; secondary closure or scar revision" },
  { code: "27886", desc: "Amputation, leg; re-amputation" },
  { code: "27888", desc: "Amputation, ankle, through malleoli of tibia and fibula" },
  { code: "27889", desc: "Ankle disarticulation" },
  { code: "29894", desc: "Arthroscopy, ankle, with removal of loose body or foreign body" },
  { code: "29895", desc: "Arthroscopy, ankle, surgical; synovectomy, partial" },
  { code: "29897", desc: "Arthroscopy, ankle, surgical; debridement, limited" },
  { code: "29898", desc: "Arthroscopy, ankle, surgical; debridement, extensive" },
  { code: "29899", desc: "Arthroscopy, ankle; with ankle arthrodesis" },
  { code: "29900", desc: "Arthroscopy, metacarpophalangeal joint, diagnostic" },
  { code: "29902", desc: "Arthroscopy, metacarpophalangeal joint, surgical" },

  // ── Foot Procedures ────────────────────────────────────────────────────────
  { code: "28001", desc: "Incision and drainage, bursa, foot" },
  { code: "28002", desc: "Incision and drainage below fascia, with or without tendon sheath involvement, foot" },
  { code: "28003", desc: "Incision and drainage below fascia, multiple areas, foot" },
  { code: "28005", desc: "Incision, bone cortex, foot" },
  { code: "28008", desc: "Fasciotomy, foot and/or toe" },
  { code: "28010", desc: "Tenotomy, percutaneous, toe" },
  { code: "28011", desc: "Tenotomy, percutaneous, toe; multiple" },
  { code: "28020", desc: "Arthrotomy, including exploration, drainage, or removal of loose body; intertarsal or tarsometatarsal joint" },
  { code: "28022", desc: "Arthrotomy, including exploration, drainage, or removal of loose body; metatarsophalangeal joint" },
  { code: "28024", desc: "Arthrotomy, including exploration, drainage, or removal of loose body; interphalangeal joint" },
  { code: "28030", desc: "Neurectomy, intrinsic musculature of foot" },
  { code: "28035", desc: "Release, tarsal tunnel" },
  { code: "28043", desc: "Excision, tumor, soft tissue, foot; subcutaneous, less than 1.5 cm" },
  { code: "28045", desc: "Excision, tumor, soft tissue, foot; subfascial, less than 1.5 cm" },
  { code: "28046", desc: "Radical resection of tumor, soft tissue, foot; less than 3 cm" },
  { code: "28047", desc: "Radical resection of tumor, soft tissue, foot; 3 cm or greater" },
  { code: "28050", desc: "Arthrotomy with biopsy, intertarsal or tarsometatarsal joint" },
  { code: "28052", desc: "Arthrotomy with biopsy, metatarsophalangeal joint" },
  { code: "28054", desc: "Arthrotomy with biopsy, interphalangeal joint" },
  { code: "28055", desc: "Neurectomy, Morton neuroma" },
  { code: "28060", desc: "Fasciectomy, plantar fascia; partial" },
  { code: "28062", desc: "Fasciectomy, plantar fascia; radical" },
  { code: "28070", desc: "Synovectomy, intertarsal or tarsometatarsal joint" },
  { code: "28072", desc: "Synovectomy, metatarsophalangeal joint" },
  { code: "28080", desc: "Excision, interdigital neuroma; single" },
  { code: "28086", desc: "Synovectomy, tendon sheath, foot; flexor" },
  { code: "28088", desc: "Synovectomy, tendon sheath, foot; extensor" },
  { code: "28090", desc: "Excision of lesion, tendon, tendon sheath, or capsule" },
  { code: "28092", desc: "Excision of lesion, tendon, tendon sheath, or capsule; each additional" },
  { code: "28100", desc: "Excision or curettage of bone cyst or benign tumor, talus or calcaneus" },
  { code: "28102", desc: "Excision or curettage of bone cyst, talus or calcaneus; with allograft" },
  { code: "28103", desc: "Excision or curettage of bone cyst, talus or calcaneus; with internal fixation" },
  { code: "28104", desc: "Excision or curettage of bone cyst, tarsal or metatarsal bone" },
  { code: "28106", desc: "Excision or curettage of bone cyst, tarsal or metatarsal; with allograft" },
  { code: "28107", desc: "Excision or curettage of bone cyst, tarsal or metatarsal; with internal fixation" },
  { code: "28108", desc: "Excision or curettage of bone cyst or benign tumor, phalanges of foot" },
  { code: "28110", desc: "Ostectomy, partial, fifth metatarsal head (bunionette)" },
  { code: "28111", desc: "Ostectomy, complete, fifth metatarsal head" },
  { code: "28112", desc: "Ostectomy, complete, fifth metatarsal head; with fibular sesamoidectomy" },
  { code: "28113", desc: "Ostectomy, complete, fifth metatarsal head; all other metatarsal heads" },
  { code: "28114", desc: "Ostectomy, complete, all metatarsal heads with resection of proximal phalanges" },
  { code: "28116", desc: "Ostectomy, calcaneus" },
  { code: "28118", desc: "Ostectomy, calcaneus; for Haglund deformity" },
  { code: "28119", desc: "Ostectomy, calcaneus; other, e.g., for Haglund deformity" },
  { code: "28120", desc: "Partial excision, bone, talus or calcaneus" },
  { code: "28122", desc: "Partial excision, bone, tarsal or metatarsal bone" },
  { code: "28124", desc: "Partial excision, bone, phalanx of toe" },
  { code: "28126", desc: "Resection, partial, or complete, phalangeal base, each toe" },
  { code: "28130", desc: "Talectomy (astragalectomy)" },
  { code: "28140", desc: "Metatarsectomy" },
  { code: "28150", desc: "Phalangectomy, toe, each toe" },
  { code: "28153", desc: "Resection, condyle(s), distal end of phalanx, each toe" },
  { code: "28160", desc: "Hemiphalangectomy or interphalangeal joint excision, toe; proximal end of phalanx" },
  { code: "28171", desc: "Radical resection of tumor, tarsal bone" },
  { code: "28173", desc: "Radical resection of tumor, metatarsal" },
  { code: "28175", desc: "Radical resection of tumor, phalanx of toe" },
  { code: "28190", desc: "Removal of foreign body, foot; subcutaneous" },
  { code: "28192", desc: "Removal of foreign body, foot; deep" },
  { code: "28193", desc: "Removal of foreign body, foot; complicated" },
  { code: "28200", desc: "Repair, tendon, flexor, foot; primary or secondary, without free graft" },
  { code: "28202", desc: "Repair, tendon, flexor, foot; secondary, with free graft" },
  { code: "28208", desc: "Repair, tendon, extensor, foot; primary or secondary" },
  { code: "28210", desc: "Repair, tendon, extensor, foot; secondary, with free graft" },
  { code: "28220", desc: "Tenolysis, flexor tendon, foot; single tendon" },
  { code: "28222", desc: "Tenolysis, flexor tendon, foot; multiple tendons" },
  { code: "28225", desc: "Tenolysis, extensor tendon, foot; single tendon" },
  { code: "28226", desc: "Tenolysis, extensor tendon, foot; multiple tendons" },
  { code: "28230", desc: "Tenotomy, open, tendon flexor; foot, single tendon" },
  { code: "28232", desc: "Tenotomy, open, tendon flexor; toe, single" },
  { code: "28234", desc: "Tenotomy, open, extensor; foot or toe, single" },
  { code: "28238", desc: "Reconstruction for metatarsus primus varus (Mitchell or similar)" },
  { code: "28240", desc: "Tenotomy, lengthening, or release, abductor hallucis muscle" },
  { code: "28250", desc: "Division of plantar fascia and muscle origins" },
  { code: "28260", desc: "Capsulotomy, midfoot; medial release only" },
  { code: "28261", desc: "Capsulotomy, midfoot; with tendon lengthening" },
  { code: "28262", desc: "Capsulotomy, midfoot; extensive, including posterior talar release" },
  { code: "28270", desc: "Capsulotomy; metatarsophalangeal joint, with or without tenorrhaphy" },
  { code: "28272", desc: "Capsulotomy; interphalangeal joint, each joint" },
  { code: "28280", desc: "Syndactylization, toes" },
  { code: "28285", desc: "Correction, hammertoe" },
  { code: "28286", desc: "Correction, cock-up fifth toe, soft tissue procedures" },
  { code: "28288", desc: "Ostectomy, partial, exostectomy or condylectomy, metatarsal head" },
  { code: "28289", desc: "Hallux rigidus correction with cheilectomy, debridement and capsular release of first MTP joint" },
  { code: "28290", desc: "Correction, hallux valgus (bunion) with sesamoidectomy" },
  { code: "28291", desc: "Hallux rigidus correction; with implant" },
  { code: "28292", desc: "Correction, hallux valgus, simple" },
  { code: "28295", desc: "Correction, hallux valgus, with sesamoidectomy" },
  { code: "28296", desc: "Correction, hallux valgus, with metatarsal osteotomy" },
  { code: "28297", desc: "Correction, hallux valgus, Lapidus-type procedure" },
  { code: "28298", desc: "Correction, hallux valgus, by phalanx osteotomy" },
  { code: "28299", desc: "Correction, hallux valgus, double osteotomy" },
  { code: "28300", desc: "Osteotomy, calcaneus" },
  { code: "28302", desc: "Osteotomy, calcaneus; with displacement" },
  { code: "28304", desc: "Osteotomy, tarsal bones, other than calcaneus or talus" },
  { code: "28305", desc: "Osteotomy, tarsal bones; with autograft" },
  { code: "28306", desc: "Osteotomy, metatarsal; first metatarsal" },
  { code: "28307", desc: "Osteotomy, metatarsal; first metatarsal, with autograft" },
  { code: "28308", desc: "Osteotomy, metatarsal; other than first metatarsal, each" },
  { code: "28309", desc: "Osteotomy, metatarsal; multiple" },
  { code: "28310", desc: "Osteotomy, rotation of big toe, alone or combined" },
  { code: "28312", desc: "Osteotomy, other phalanges, any type" },
  { code: "28315", desc: "Sesamoidectomy, first toe" },
  { code: "28320", desc: "Repair, nonunion or malunion; tarsal bones" },
  { code: "28322", desc: "Repair, nonunion or malunion; metatarsal, with or without bone graft" },
  { code: "28340", desc: "Reconstruction, cleft foot" },
  { code: "28341", desc: "Reconstruction, cleft foot; complex" },
  { code: "28344", desc: "Reconstruction, polydactyly toe" },
  { code: "28345", desc: "Reconstruction, macrodactyly, toe" },
  { code: "28360", desc: "Reconstruction, cleft foot" },
  { code: "28400", desc: "Closed treatment of calcaneal fracture, without manipulation" },
  { code: "28405", desc: "Closed treatment of calcaneal fracture, with manipulation" },
  { code: "28406", desc: "Percutaneous skeletal fixation of calcaneal fracture" },
  { code: "28415", desc: "ORIF, calcaneal fracture" },
  { code: "28420", desc: "ORIF, calcaneal fracture; with primary iliac or other autogenous bone graft" },
  { code: "28430", desc: "Closed treatment of talus fracture, without manipulation" },
  { code: "28435", desc: "Closed treatment of talus fracture, with manipulation" },
  { code: "28436", desc: "Percutaneous skeletal fixation of talus fracture" },
  { code: "28445", desc: "ORIF, talus fracture" },
  { code: "28446", desc: "ORIF, talus fracture; with primary iliac or other autogenous bone graft" },
  { code: "28450", desc: "Treatment of tarsal bone fracture, without manipulation; other than talus or calcaneus" },
  { code: "28455", desc: "Treatment of tarsal bone fracture, with manipulation; other than talus or calcaneus" },
  { code: "28456", desc: "Percutaneous skeletal fixation, tarsal bone fracture" },
  { code: "28465", desc: "ORIF, tarsal bone fracture" },
  { code: "28470", desc: "Closed treatment of metatarsal fracture, without manipulation; single" },
  { code: "28475", desc: "Closed treatment of metatarsal fracture, with manipulation; single" },
  { code: "28476", desc: "Percutaneous skeletal fixation, metatarsal fracture" },
  { code: "28485", desc: "ORIF, metatarsal fracture" },
  { code: "28490", desc: "Closed treatment of fracture great toe, phalanx or phalanges, without manipulation" },
  { code: "28495", desc: "Closed treatment of fracture great toe, with manipulation" },
  { code: "28496", desc: "Percutaneous skeletal fixation, fracture great toe" },
  { code: "28505", desc: "ORIF, fracture great toe" },
  { code: "28510", desc: "Closed treatment of fracture, phalanx or phalanges, other than great toe, without manipulation" },
  { code: "28515", desc: "Closed treatment of fracture, phalanx or phalanges, other than great toe, with manipulation" },
  { code: "28525", desc: "ORIF, fracture, phalanx or phalanges, other than great toe" },
  { code: "28530", desc: "Closed treatment of sesamoid fracture" },
  { code: "28531", desc: "ORIF, sesamoid fracture" },
  { code: "28540", desc: "Closed treatment of tarsal bone dislocation, other than talocrural" },
  { code: "28545", desc: "Closed treatment of tarsal bone dislocation, with manipulation; other than talocrural" },
  { code: "28546", desc: "Percutaneous skeletal fixation of tarsal bone dislocation" },
  { code: "28555", desc: "ORIF, tarsal bone dislocation" },
  { code: "28570", desc: "Closed treatment of talotarsal joint dislocation; without anesthesia" },
  { code: "28575", desc: "Closed treatment of talotarsal joint dislocation; requiring anesthesia" },
  { code: "28576", desc: "Percutaneous skeletal fixation of talotarsal joint dislocation" },
  { code: "28585", desc: "ORIF, talotarsal joint dislocation" },
  { code: "28600", desc: "Closed treatment of tarsometatarsal joint dislocation; without anesthesia" },
  { code: "28605", desc: "Closed treatment of tarsometatarsal joint dislocation; requiring anesthesia" },
  { code: "28606", desc: "Percutaneous skeletal fixation of tarsometatarsal joint dislocation" },
  { code: "28615", desc: "ORIF, tarsometatarsal joint dislocation" },
  { code: "28630", desc: "Closed treatment of metatarsophalangeal joint dislocation; without anesthesia" },
  { code: "28635", desc: "Closed treatment of metatarsophalangeal joint dislocation; requiring anesthesia" },
  { code: "28636", desc: "Percutaneous skeletal fixation of metatarsophalangeal joint dislocation" },
  { code: "28645", desc: "ORIF, metatarsophalangeal joint dislocation" },
  { code: "28660", desc: "Closed treatment of interphalangeal joint dislocation; without anesthesia" },
  { code: "28665", desc: "Closed treatment of interphalangeal joint dislocation; requiring anesthesia" },
  { code: "28666", desc: "Percutaneous skeletal fixation of interphalangeal joint dislocation" },
  { code: "28675", desc: "ORIF, interphalangeal joint dislocation" },
  { code: "28705", desc: "Arthrodesis, pantalar" },
  { code: "28715", desc: "Arthrodesis, triple" },
  { code: "28725", desc: "Arthrodesis, subtalar" },
  { code: "28730", desc: "Arthrodesis, midtarsal or tarsometatarsal, multiple or transverse" },
  { code: "28735", desc: "Arthrodesis, midtarsal or tarsometatarsal; with osteotomy" },
  { code: "28737", desc: "Arthrodesis, with tendon lengthening and advancement, midtarsal" },
  { code: "28740", desc: "Arthrodesis, midtarsal or tarsometatarsal, single joint" },
  { code: "28750", desc: "Arthrodesis, great toe; metatarsophalangeal joint" },
  { code: "28755", desc: "Arthrodesis, great toe; interphalangeal joint" },
  { code: "28760", desc: "Arthrodesis, with extensor hallucis longus transfer to first metatarsal neck" },
  { code: "28800", desc: "Amputation, foot; midtarsal" },
  { code: "28805", desc: "Amputation, foot; transmetatarsal" },
  { code: "28810", desc: "Amputation, metatarsal, with toe, single" },
  { code: "28820", desc: "Amputation, toe; metatarsophalangeal joint" },
  { code: "28825", desc: "Amputation, toe; interphalangeal joint" },
  { code: "28890", desc: "Extracorporeal shock wave, plantar fascia" },

  // ── Spine Procedures ────────────────────────────────────────────────────────
  { code: "22551", desc: "Arthrodesis, anterior interbody, cervical; single interspace" },
  { code: "22552", desc: "Arthrodesis, anterior interbody, cervical; each additional interspace" },
  { code: "22554", desc: "Arthrodesis, anterior interbody, lumbar; single interspace" },
  { code: "22556", desc: "Arthrodesis, anterior interbody, lumbar; each additional interspace" },
  { code: "22558", desc: "Arthrodesis, anterior interbody, lumbar, transperitoneal or retroperitoneal" },
  { code: "22585", desc: "Arthrodesis, anterior interbody technique, lumbar; additional interspace" },
  { code: "22586", desc: "Arthrodesis, pre-sacral interbody technique, including imaging guidance" },
  { code: "22600", desc: "Arthrodesis, posterior, for spinal deformity, cervical" },
  { code: "22610", desc: "Arthrodesis, posterior, for spinal deformity, thoracic" },
  { code: "22612", desc: "Arthrodesis, posterior, for spinal deformity, lumbar" },
  { code: "22614", desc: "Arthrodesis, posterior, for spinal deformity; each additional vertebral segment" },
  { code: "22630", desc: "Arthrodesis, posterior interbody, lumbar; single interspace" },
  { code: "22632", desc: "Arthrodesis, posterior interbody, lumbar; each additional interspace" },
  { code: "22633", desc: "Arthrodesis, combined posterior/posteroateral and posterior interbody, lumbar; single interspace" },
  { code: "22634", desc: "Arthrodesis, combined; each additional interspace" },
  { code: "22800", desc: "Arthrodesis, posterior, for spinal deformity; up to 6 vertebral segments" },
  { code: "22802", desc: "Arthrodesis, posterior; 7-12 vertebral segments" },
  { code: "22804", desc: "Arthrodesis, posterior; 13 or more vertebral segments" },
  { code: "22840", desc: "Posterior non-segmental instrumentation, e.g., Harrington rod technique, pedicle fixation" },
  { code: "22841", desc: "Internal spinal fixation by wiring of spinous processes" },
  { code: "22842", desc: "Posterior segmental instrumentation; 3-6 vertebral segments" },
  { code: "22843", desc: "Posterior segmental instrumentation; 7-12 vertebral segments" },
  { code: "22844", desc: "Posterior segmental instrumentation; 13 or more vertebral segments" },
  { code: "22845", desc: "Anterior instrumentation; 2-3 vertebral segments" },
  { code: "22846", desc: "Anterior instrumentation; 4-7 vertebral segments" },
  { code: "22847", desc: "Anterior instrumentation; 8 or more vertebral segments" },
  { code: "22848", desc: "Pelvic fixation, sacral, iliac" },
  { code: "22850", desc: "Removal of posterior nonsegmental instrumentation" },
  { code: "22852", desc: "Removal of posterior segmental instrumentation" },
  { code: "22855", desc: "Removal of anterior instrumentation" },
  { code: "22856", desc: "Total disc arthroplasty, anterior approach, single interspace, cervical" },
  { code: "22857", desc: "Total disc arthroplasty, anterior approach, single interspace, lumbar" },
  { code: "22858", desc: "Total disc arthroplasty, cervical; second interspace" },
  { code: "22861", desc: "Revision, total disc arthroplasty, anterior approach, single interspace, cervical" },
  { code: "22862", desc: "Revision, total disc arthroplasty, anterior approach, single interspace, lumbar" },
  { code: "22864", desc: "Removal, total disc arthroplasty, single interspace, cervical" },
  { code: "22865", desc: "Removal, total disc arthroplasty, single interspace, lumbar" },
  { code: "62380", desc: "Endoscopic decompression of spinal cord, nerve root, interlaminar approach" },
  { code: "63001", desc: "Laminectomy with decompression of spinal cord, cervical" },
  { code: "63003", desc: "Laminectomy with decompression of spinal cord, thoracic" },
  { code: "63005", desc: "Laminectomy with decompression of spinal cord, lumbar, except for spondylolisthesis" },
  { code: "63011", desc: "Laminectomy with decompression of spinal cord, sacral" },
  { code: "63012", desc: "Laminectomy, with removal of abnormal facets and/or pedicles, lumbar" },
  { code: "63015", desc: "Laminectomy; more than 2 vertebral segments, cervical" },
  { code: "63016", desc: "Laminectomy; more than 2 vertebral segments, thoracic" },
  { code: "63017", desc: "Laminectomy; more than 2 vertebral segments, lumbar" },
  { code: "63020", desc: "Laminotomy, interlaminar approach, cervical, single level" },
  { code: "63030", desc: "Laminotomy, interlaminar approach, lumbar, single level" },
  { code: "63035", desc: "Laminotomy, interlaminar approach; each additional level" },
  { code: "63040", desc: "Laminotomy, cervical; re-exploration, single interspace" },
  { code: "63042", desc: "Laminotomy, lumbar; re-exploration, single interspace" },
  { code: "63045", desc: "Laminectomy, facetectomy and foraminotomy, cervical, single segment" },
  { code: "63046", desc: "Laminectomy, facetectomy and foraminotomy, thoracic, single segment" },
  { code: "63047", desc: "Laminectomy, facetectomy and foraminotomy, lumbar, single segment" },
  { code: "63048", desc: "Laminectomy, facetectomy and foraminotomy; each additional segment" },
  { code: "63050", desc: "Laminoplasty, cervical; 2 or more vertebral segments" },
  { code: "63051", desc: "Laminoplasty, cervical; with reconstruction of the posterior bony elements" },
  { code: "63055", desc: "Transpedicular approach with decompression of spinal cord, thoracic, single segment" },
  { code: "63056", desc: "Transpedicular approach; each additional segment" },
  { code: "63057", desc: "Transpedicular approach with decompression; each additional segment" },
  { code: "63064", desc: "Costovertebral approach with decompression of spinal cord, thoracic, single segment" },
  { code: "63066", desc: "Costovertebral approach with decompression; each additional segment" },
  { code: "63075", desc: "Discectomy, anterior, with decompression of spinal cord and/or nerve root, cervical; single interspace" },
  { code: "63076", desc: "Discectomy, anterior, cervical; each additional interspace" },
  { code: "63077", desc: "Discectomy, anterior, with decompression of spinal cord, thoracic; single interspace" },
  { code: "63081", desc: "Vertebral corpectomy, anterior approach, single segment; cervical" },
  { code: "63082", desc: "Vertebral corpectomy; each additional segment, cervical" },
  { code: "63085", desc: "Vertebral corpectomy, anterior approach, single segment; thoracic" },
  { code: "63086", desc: "Vertebral corpectomy, anterior approach; each additional segment, thoracic" },
  { code: "63087", desc: "Vertebral corpectomy; combined thoracolumbar approach" },
  { code: "63088", desc: "Vertebral corpectomy; each additional segment, thoracolumbar" },
  { code: "63090", desc: "Vertebral corpectomy; lumbar, single segment" },
  { code: "63091", desc: "Vertebral corpectomy; each additional segment, lumbar" },
  { code: "63101", desc: "Vertebral corpectomy, lateral extracavitary approach, thoracic; single segment" },
  { code: "63103", desc: "Vertebral corpectomy, lateral extracavitary approach; each additional segment" },
  { code: "63170", desc: "Laminectomy with myelotomy, 1-2 segments" },
  { code: "63172", desc: "Laminectomy with drainage of intramedullary cyst/syrinx; to subarachnoid space" },
  { code: "63173", desc: "Laminectomy with drainage of intramedullary cyst/syrinx; to peritoneal or pleural space" },
  { code: "63180", desc: "Laminectomy and section of dentate ligaments, with or without dural graft, cervical" },
  { code: "63182", desc: "Laminectomy and section of dentate ligaments, thoracic" },
  { code: "63185", desc: "Laminectomy with rhizotomy; 1-2 segments" },
  { code: "63190", desc: "Laminectomy with rhizotomy; more than 2 segments" },
  { code: "63194", desc: "Laminectomy with cordotomy, with section of 1 spinothalamic tract; cervical" },
  { code: "63195", desc: "Laminectomy with cordotomy, with section of 1 spinothalamic tract; thoracic" },
  { code: "63197", desc: "Laminectomy with cordotomy with section of both spinothalamic tracts; cervical" },
  { code: "63198", desc: "Laminectomy with cordotomy with section of both spinothalamic tracts; thoracic" },
  { code: "63200", desc: "Laminectomy, with release of tethered spinal cord, lumbar" },
  { code: "22510", desc: "Percutaneous vertebroplasty, cervical" },
  { code: "22511", desc: "Percutaneous vertebroplasty, thoracic" },
  { code: "22512", desc: "Percutaneous vertebroplasty; each additional thoracic or lumbar vertebral body" },
  { code: "22513", desc: "Percutaneous vertebral augmentation, kyphoplasty; thoracic" },
  { code: "22514", desc: "Percutaneous vertebral augmentation, kyphoplasty; lumbar" },
  { code: "22515", desc: "Percutaneous vertebral augmentation; each additional thoracic or lumbar vertebral body" },
  { code: "27279", desc: "Arthrodesis, sacroiliac joint, percutaneous or minimally invasive" },
  { code: "27280", desc: "Arthrodesis, open, sacroiliac joint, including obtaining bone graft" },

  // ── General & Fracture Care ────────────────────────────────────────────────
  { code: "29000", desc: "Application of hip spica cast" },
  { code: "29010", desc: "Application of Risser jacket, localizer, body; only" },
  { code: "29015", desc: "Application of Risser jacket; including head" },
  { code: "29035", desc: "Application of body cast, shoulder to hips" },
  { code: "29040", desc: "Application of body cast, shoulder to hips; including head, Minerva type" },
  { code: "29044", desc: "Application of body cast, shoulder to hips; including 1 thigh" },
  { code: "29046", desc: "Application of body cast, shoulder to hips; including both thighs" },
  { code: "29049", desc: "Application of figure of eight" },
  { code: "29055", desc: "Application of shoulder spica" },
  { code: "29058", desc: "Application of plaster figure-of-eight" },
  { code: "29065", desc: "Application of cast, shoulder to hand (long arm)" },
  { code: "29075", desc: "Application of cast, elbow to finger (short arm)" },
  { code: "29085", desc: "Application of hand and wrist cast; gauntlet" },
  { code: "29086", desc: "Application of hand and wrist cast; thumb spica" },
  { code: "29105", desc: "Application of long arm splint, shoulder to hand" },
  { code: "29125", desc: "Application of static short arm splint" },
  { code: "29126", desc: "Application of dynamic short arm splint" },
  { code: "29130", desc: "Application of finger splint; static" },
  { code: "29131", desc: "Application of finger splint; dynamic" },
  { code: "29200", desc: "Strapping, thorax" },
  { code: "29240", desc: "Strapping, shoulder" },
  { code: "29260", desc: "Strapping, elbow or wrist" },
  { code: "29280", desc: "Strapping, hand or finger" },
  { code: "29305", desc: "Application of hip spica cast; 1 leg" },
  { code: "29325", desc: "Application of hip spica cast; 1 and one half spica or both legs" },
  { code: "29345", desc: "Application of long leg cast, thigh to toes" },
  { code: "29355", desc: "Application of long leg cast; walker or ambulatory type" },
  { code: "29358", desc: "Application of long leg cast brace" },
  { code: "29365", desc: "Application of cylinder cast, thigh to ankle" },
  { code: "29405", desc: "Application of short leg cast, below knee to toes" },
  { code: "29425", desc: "Application of short leg cast; walking or ambulatory type" },
  { code: "29435", desc: "Application of patellar tendon bearing cast" },
  { code: "29440", desc: "Adding walker to previously applied cast" },
  { code: "29445", desc: "Application of rigid total contact leg cast" },
  { code: "29450", desc: "Application of clubfoot cast with molding or manipulation, long or short leg" },
  { code: "29505", desc: "Application of long leg splint, thigh to ankle or toes" },
  { code: "29515", desc: "Application of short leg splint, lower leg and ankle" },
  { code: "29520", desc: "Strapping, hip" },
  { code: "29530", desc: "Strapping, knee" },
  { code: "29540", desc: "Strapping, ankle and/or foot" },
  { code: "29550", desc: "Strapping, toes" },
  { code: "29580", desc: "Application of Unna boot" },
  { code: "29581", desc: "Application of multi-layer compression system; leg" },
  { code: "29700", desc: "Removal or bivalving of gauntlet, boot, or body cast" },
  { code: "29705", desc: "Removal or bivalving of full arm or full leg cast" },
  { code: "29710", desc: "Removal or bivalving of shoulder spica, Minerva, or Risser jacket" },
  { code: "29720", desc: "Repair of spica, body cast, or jacket" },
  { code: "29730", desc: "Windowing of cast" },
  { code: "29740", desc: "Wedging of cast, except clubfoot" },
  { code: "29750", desc: "Wedging of clubfoot cast" },
  { code: "20670", desc: "Removal of implant; superficial" },
  { code: "20680", desc: "Removal of implant; deep" },
  { code: "20690", desc: "Application of uniplane external fixation" },
  { code: "20692", desc: "Application of multiplane external fixation" },
  { code: "20693", desc: "Adjustment or removal of multiplane external fixation" },
  { code: "20694", desc: "Removal under anesthesia of external fixation system" },
  { code: "20696", desc: "Application of multiplane external fixation with ring fixator; small" },
  { code: "20697", desc: "Application of multiplane external fixation; large" },
  { code: "20900", desc: "Bone graft, any donor area; minor or small" },
  { code: "20902", desc: "Bone graft, any donor area; major or large" },
  { code: "20910", desc: "Cartilage graft, costochondral" },
  { code: "20912", desc: "Cartilage graft, nasal septum" },
  { code: "20920", desc: "Fascia lata graft, by stripper" },
  { code: "20922", desc: "Fascia lata graft, by incision and area exposure, complex or sheet" },
  { code: "20924", desc: "Tendon graft, from a distance" },
  { code: "20926", desc: "Tissue grafts, other" },
  { code: "20930", desc: "Allograft, morselized, or placement of osteopromotive material" },
  { code: "20931", desc: "Allograft, structural, for spine surgery only" },
  { code: "20936", desc: "Autograft for spine surgery only; morselized" },
  { code: "20937", desc: "Autograft for spine surgery only; structural, bicortical or tricortical" },
  { code: "20938", desc: "Autograft for spine surgery only; structural, harvested through separate skin or fascial incision" },
  { code: "20950", desc: "Monitoring of interstitial fluid pressure in closed injury" },
  { code: "20955", desc: "Bone graft with microvascular anastomosis; fibula" },
  { code: "20956", desc: "Bone graft with microvascular anastomosis; iliac crest" },
  { code: "20957", desc: "Bone graft with microvascular anastomosis; metatarsal" },
  { code: "20962", desc: "Bone graft with microvascular anastomosis; other than fibula, iliac crest, or metatarsal" },
  { code: "20969", desc: "Free osteocutaneous flap with microvascular anastomosis; other than iliac crest, metatarsal, or great toe" },
  { code: "20970", desc: "Free osteocutaneous flap; iliac crest" },
  { code: "20972", desc: "Free osteocutaneous flap; metatarsal" },
  { code: "20973", desc: "Free osteocutaneous flap; great toe with web space" },
  { code: "20974", desc: "Electrical stimulation to aid bone healing; noninvasive" },
  { code: "20975", desc: "Electrical stimulation to aid bone healing; invasive" },
  { code: "20979", desc: "Low-intensity ultrasound stimulation to aid bone healing, noninvasive" },
  { code: "20982", desc: "Ablation, bone tumor(s); radiofrequency" },
  { code: "20983", desc: "Ablation, bone tumor(s); cryoablation" },
  { code: "20985", desc: "Computer-assisted musculoskeletal surgical navigational orthopedic procedure" },

  // ── Shoulder — Additional CPT ──────────────────────────────────────────────
  { code: "23000", desc: "Removal of subdeltoid calcareous deposits, open" },
  { code: "23020", desc: "Capsular contracture release, shoulder, Sever type procedure" },
  { code: "23030", desc: "Incision and drainage, shoulder area; deep abscess or hematoma" },
  { code: "23040", desc: "Arthrotomy, glenohumeral joint, including exploration, drainage, or removal of foreign body" },
  { code: "23044", desc: "Arthrotomy, acromioclavicular or sternoclavicular joint, including exploration, drainage, or removal of foreign body" },
  { code: "23065", desc: "Biopsy, soft tissue of shoulder area; superficial" },
  { code: "23066", desc: "Biopsy, soft tissue of shoulder area; deep, subfascial, or intramuscular" },
  { code: "23071", desc: "Excision, tumor, soft tissue of shoulder area; subcutaneous, 3 cm or greater" },
  { code: "23073", desc: "Excision, tumor, soft tissue of shoulder area; deep, subfascial, or intramuscular, 5 cm or greater" },
  { code: "23075", desc: "Excision, tumor, soft tissue of shoulder area; subcutaneous, less than 3 cm" },
  { code: "23076", desc: "Excision, tumor, soft tissue of shoulder area; deep, subfascial or intramuscular, less than 5 cm" },
  { code: "23077", desc: "Radical resection of tumor, soft tissue of shoulder area; less than 5 cm" },
  { code: "23078", desc: "Radical resection of tumor, soft tissue of shoulder area; 5 cm or greater" },
  { code: "23100", desc: "Arthrotomy, glenohumeral joint, including exploration, biopsy, removal of loose body" },
  { code: "23101", desc: "Arthrotomy, acromioclavicular joint, including exploration, biopsy, removal of loose body" },
  { code: "23105", desc: "Arthrotomy, glenohumeral joint; with synovectomy" },
  { code: "23106", desc: "Arthrotomy, sternoclavicular joint; with synovectomy" },
  { code: "23107", desc: "Arthrotomy, glenohumeral joint; with joint exploration and removal of loose body" },
  { code: "23110", desc: "Excision, lesion, glenoid of scapula" },
  { code: "23115", desc: "Excision, lesion, glenoid of scapula; with bone graft" },
  { code: "23120", desc: "Claviculectomy, partial" },
  { code: "23125", desc: "Claviculectomy, total" },
  { code: "23130", desc: "Acromioplasty or acromionectomy, partial, with or without coracoacromial ligament release" },
  { code: "23140", desc: "Excision or curettage of bone cyst or benign tumor, clavicle or scapula" },
  { code: "23145", desc: "Excision or curettage of bone cyst or benign tumor, clavicle or scapula; with allograft" },
  { code: "23146", desc: "Excision or curettage of bone cyst or benign tumor, clavicle or scapula; with autograft" },
  { code: "23150", desc: "Excision or curettage of bone cyst or benign tumor, proximal humerus" },
  { code: "23155", desc: "Excision or curettage of bone cyst or benign tumor, proximal humerus; with allograft" },
  { code: "23156", desc: "Excision or curettage of bone cyst or benign tumor, proximal humerus; with autograft" },
  { code: "23170", desc: "Sequestrectomy, clavicle" },
  { code: "23172", desc: "Sequestrectomy, scapula" },
  { code: "23174", desc: "Sequestrectomy, proximal humerus" },
  { code: "23180", desc: "Partial excision, clavicle" },
  { code: "23182", desc: "Partial excision, scapula" },
  { code: "23184", desc: "Partial excision, proximal humerus" },
  { code: "23190", desc: "Ostectomy, scapula, partial (e.g., superior medial angle)" },
  { code: "23195", desc: "Resection, humeral head" },
  { code: "23200", desc: "Radical resection for tumor; clavicle" },
  { code: "23210", desc: "Radical resection for tumor; scapula" },
  { code: "23220", desc: "Radical resection for tumor; proximal humerus" },
  { code: "23221", desc: "Radical resection for tumor; proximal humerus, with autograft" },
  { code: "23222", desc: "Radical resection for tumor; proximal humerus, with prosthetic replacement" },
  { code: "23330", desc: "Removal of foreign body, shoulder; subcutaneous" },
  { code: "23331", desc: "Removal of foreign body, shoulder; deep" },
  { code: "23332", desc: "Removal of foreign body, shoulder; complicated" },
  { code: "23395", desc: "Muscle transfer, any type, shoulder or upper arm; single" },
  { code: "23397", desc: "Muscle transfer, any type, shoulder or upper arm; multiple" },
  { code: "23405", desc: "Tenotomy, shoulder area; single tendon" },
  { code: "23406", desc: "Tenotomy, shoulder area; multiple tendons through same incision" },
  { code: "23410", desc: "Repair of ruptured musculotendinous cuff; acute" },
  { code: "23412", desc: "Repair of ruptured musculotendinous cuff; chronic" },
  { code: "23415", desc: "Coracoacromial ligament release" },
  { code: "23420", desc: "Reconstruction of complete shoulder cuff avulsion, chronic" },
  { code: "23430", desc: "Tenodesis of long tendon of biceps" },
  { code: "23440", desc: "Resection or transplantation of long tendon of biceps" },
  { code: "23462", desc: "Capsulorrhaphy, posterior" },
  { code: "23465", desc: "Capsulorrhaphy, glenohumeral joint, posterior" },
  { code: "23466", desc: "Capsulorrhaphy, glenohumeral joint, any type; multidirectional instability" },
  { code: "23476", desc: "Arthroplasty, glenohumeral joint; total shoulder, reverse ball and socket" },

  // ── Hip — Additional CPT ───────────────────────────────────────────────────
  { code: "27000", desc: "Tenotomy, adductor of hip; percutaneous" },
  { code: "27001", desc: "Tenotomy, adductor of hip; open" },
  { code: "27003", desc: "Tenotomy, adductor, subcutaneous, open, with adductor and obturator neurectomy" },
  { code: "27005", desc: "Tenotomy, hip flexor(s), open" },
  { code: "27006", desc: "Tenotomy, abductors and/or extensor of hip, open" },
  { code: "27025", desc: "Fasciotomy, hip or thigh, any type" },
  { code: "27030", desc: "Arthrotomy, hip, with drainage" },
  { code: "27043", desc: "Excision, tumor, soft tissue of pelvis and hip area; subcutaneous, less than 3 cm" },
  { code: "27045", desc: "Excision, tumor, soft tissue of pelvis and hip area; subfascial, less than 5 cm" },
  { code: "27047", desc: "Excision, tumor, soft tissue of pelvis and hip area; subcutaneous, 3 cm or greater" },
  { code: "27048", desc: "Excision, tumor, soft tissue of pelvis and hip area; deep, subfascial or intramuscular, 5 cm or greater" },
  { code: "27049", desc: "Radical resection of tumor, soft tissue of pelvis and hip area; less than 5 cm" },
  { code: "27135", desc: "Total hip arthroplasty; with constrained acetabular component" },
  { code: "27187", desc: "Prophylactic treatment, femoral neck and proximal femur" },
  { code: "27299", desc: "Unlisted procedure, pelvis or hip joint" },

  // ── Knee — Additional CPT ──────────────────────────────────────────────────
  { code: "27301", desc: "Incision and drainage, deep abscess, bursa, or hematoma, thigh or knee region" },
  { code: "27303", desc: "Incision, deep, with opening of bone cortex, femur or knee" },
  { code: "27305", desc: "Fasciotomy, iliotibial (tenotomy), open" },
  { code: "27306", desc: "Tenotomy, percutaneous, adductor or hamstring; single tendon" },
  { code: "27307", desc: "Tenotomy, percutaneous, adductor or hamstring; multiple tendons" },
  { code: "27308", desc: "Tenotomy, open, adductor or hamstring; single tendon" },
  { code: "27309", desc: "Tenotomy, open, adductor or hamstring; multiple tendons" },
  { code: "27313", desc: "Tenotomy, hamstring, knee to hip; single tendon" },
  { code: "27345", desc: "Excision of popliteal cyst" },
  { code: "27346", desc: "Excision of popliteal cyst, complicated" },
  { code: "27395", desc: "Lengthening of hamstring tendon; bilateral" },
  { code: "27410", desc: "Reconstruction, ACL; extra-articular" },
  { code: "27411", desc: "Reconstruction, ACL; intra-articular" },
  { code: "27413", desc: "Reconstruction, PCL; extra-articular" },
  { code: "27414", desc: "Reconstruction, PCL; intra-articular" },
  { code: "27590", desc: "Amputation, thigh, through femur, any level" },
  { code: "27591", desc: "Amputation, thigh; immediate fitting technique" },
  { code: "27592", desc: "Amputation, thigh; open, circular" },
  { code: "27594", desc: "Amputation, thigh; secondary closure or scar revision" },
  { code: "27596", desc: "Amputation, thigh; re-amputation" },
  { code: "27598", desc: "Disarticulation at knee" },
  { code: "27599", desc: "Unlisted procedure, femur or knee" },

  // ── Spine — Additional CPT ─────────────────────────────────────────────────
  { code: "20930", desc: "Allograft, morselized, for spine" },
  { code: "20931", desc: "Allograft, structural, for spine" },
  { code: "20936", desc: "Autograft for spine; morselized" },
  { code: "20937", desc: "Autograft for spine; structural, bicortical or tricortical" },
  { code: "20938", desc: "Autograft for spine; structural, harvested through separate incision" },
  { code: "22100", desc: "Partial excision of posterior vertebral component, cervical; single vertebral segment" },
  { code: "22101", desc: "Partial excision of posterior vertebral component, thoracic; single vertebral segment" },
  { code: "22102", desc: "Partial excision of posterior vertebral component, lumbar; single vertebral segment" },
  { code: "22103", desc: "Partial excision of posterior vertebral component; each additional segment" },
  { code: "22110", desc: "Partial excision of vertebral body, anterior approach with decompression of spinal cord and/or nerve root; cervical" },
  { code: "22112", desc: "Partial excision of vertebral body; thoracic" },
  { code: "22114", desc: "Partial excision of vertebral body; lumbar" },
  { code: "22116", desc: "Partial excision of vertebral body; each additional vertebral segment" },
  { code: "22210", desc: "Osteotomy of spine, posterior or posterolateral approach, one vertebral segment; cervical" },
  { code: "22212", desc: "Osteotomy of spine; thoracic" },
  { code: "22214", desc: "Osteotomy of spine; lumbar" },
  { code: "22216", desc: "Osteotomy of spine; each additional vertebral segment" },
  { code: "22220", desc: "Osteotomy of spine, including diskectomy, anterior approach, single vertebral segment; cervical" },
  { code: "22222", desc: "Osteotomy of spine, including diskectomy, anterior; thoracic" },
  { code: "22224", desc: "Osteotomy of spine, including diskectomy, anterior; lumbar" },
  { code: "22226", desc: "Osteotomy of spine, including diskectomy, anterior; each additional vertebral segment" },
  { code: "22310", desc: "Closed treatment of vertebral fracture, without manipulation; requiring and including casting or bracing" },
  { code: "22315", desc: "Closed treatment of vertebral fracture with manipulation, requiring casting or bracing" },
  { code: "22318", desc: "ORIF, odontoid fracture(s) and/or dislocation, anterior approach, including placement of instrumentation" },
  { code: "22319", desc: "ORIF, odontoid fracture(s) and/or dislocation; anterior approach, with graft" },
  { code: "22325", desc: "ORIF, vertebral fracture(s) and/or dislocation, posterior approach, 1 fractured vertebra or dislocated segment" },
  { code: "22326", desc: "ORIF, vertebral fracture, posterior approach; cervical" },
  { code: "22327", desc: "ORIF, vertebral fracture, posterior approach; thoracic" },
  { code: "22328", desc: "ORIF, vertebral fracture, posterior approach; each additional fractured vertebra" },
  { code: "22505", desc: "Manipulation of spine requiring anesthesia, any region" },
  { code: "22532", desc: "Arthrodesis, lateral extracavitary technique, lumbar; single interspace" },
  { code: "22533", desc: "Arthrodesis, lateral extracavitary technique; each additional interspace" },
  { code: "22534", desc: "Arthrodesis, lateral extracavitary technique, thoracic or thoracolumbar; each additional interspace" },
  { code: "22548", desc: "Arthrodesis, anterior transoral or extraoral technique, clivus-C1-C2 (atlas-axis)" },
  { code: "22549", desc: "Arthrodesis, anterior transoral or extraoral technique; with bone graft" },
  { code: "22590", desc: "Arthrodesis, posterior technique, craniocervical" },
  { code: "22595", desc: "Arthrodesis, posterior technique, atlas-axis" },
  { code: "22850", desc: "Removal of posterior nonsegmental instrumentation" },
  { code: "22851", desc: "Application of interbody biomechanical device(s), 1 interspace" },
  { code: "22853", desc: "Insertion of interbody biomechanical device(s), lumbar, single interspace" },
  { code: "22854", desc: "Insertion of interbody biomechanical device(s); each additional interspace" },
  { code: "22859", desc: "Unlisted procedure, spine (vertebral column)" },
  { code: "22900", desc: "Excision, tumor, soft tissue of abdominal wall; subcutaneous, less than 3 cm" },
  { code: "22901", desc: "Excision, tumor, soft tissue of abdominal wall; subfascial, less than 5 cm" },
  { code: "27279", desc: "Arthrodesis, sacroiliac joint, percutaneous or minimally invasive" },
  { code: "27280", desc: "Arthrodesis, open, sacroiliac joint" },
  { code: "27282", desc: "Arthrodesis, symphysis pubis" },

  // ── Radiology & Diagnostic ─────────────────────────────────────────────────
  { code: "73000", desc: "X-ray, clavicle, complete" },
  { code: "73010", desc: "X-ray, scapula, complete" },
  { code: "73020", desc: "X-ray, shoulder; 1 view" },
  { code: "73030", desc: "X-ray, shoulder; complete, minimum 2 views" },
  { code: "73040", desc: "X-ray, shoulder, arthrography, radiological supervision and interpretation" },
  { code: "73050", desc: "X-ray, acromioclavicular joints, bilateral" },
  { code: "73090", desc: "X-ray, forearm; 2 views" },
  { code: "73092", desc: "X-ray, upper extremity, infant; minimum 2 views" },
  { code: "73501", desc: "X-ray, hip, 1 view" },
  { code: "73502", desc: "X-ray, hip, 2-3 views" },
  { code: "73503", desc: "X-ray, hip, minimum 4 views" },
  { code: "73521", desc: "X-ray, hips, bilateral; 2 views" },
  { code: "73522", desc: "X-ray, hips, bilateral; 3-4 views" },
  { code: "73523", desc: "X-ray, hips, bilateral; minimum 5 views" },
  { code: "73551", desc: "X-ray, femur; 1 view" },
  { code: "73552", desc: "X-ray, femur; minimum 2 views" },
  { code: "73560", desc: "X-ray, knee; 1 or 2 views" },
  { code: "73562", desc: "X-ray, knee; 3 views" },
  { code: "73564", desc: "X-ray, knee; complete, 4 or more views" },
  { code: "73565", desc: "X-ray, knees, bilateral, standing, AP" },
  { code: "73590", desc: "X-ray, tibia and fibula; 2 views" },
  { code: "73592", desc: "X-ray, lower extremity, infant; minimum 2 views" },
  { code: "73600", desc: "X-ray, ankle; 2 views" },
  { code: "73610", desc: "X-ray, ankle; complete, minimum 3 views" },
  { code: "73620", desc: "X-ray, foot; 2 views" },
  { code: "73630", desc: "X-ray, foot; complete, minimum 3 views" },
  { code: "73650", desc: "X-ray, calcaneus; minimum 2 views" },
  { code: "73660", desc: "X-ray, toe(s), minimum 2 views" },
  { code: "73700", desc: "CT, lower extremity without contrast" },
  { code: "73701", desc: "CT, lower extremity with contrast" },
  { code: "73702", desc: "CT, lower extremity without and with contrast" },
  { code: "73706", desc: "CT angiography, lower extremity" },
  { code: "73718", desc: "MRI, lower extremity, other than joint; without contrast" },
  { code: "73719", desc: "MRI, lower extremity, other than joint; with contrast" },
  { code: "73720", desc: "MRI, lower extremity, other than joint; without and with contrast" },
  { code: "73721", desc: "MRI, any joint of lower extremity; without contrast" },
  { code: "73722", desc: "MRI, any joint of lower extremity; with contrast" },
  { code: "73723", desc: "MRI, any joint of lower extremity; without and with contrast" },
  { code: "73718", desc: "MRI, lower extremity other than joint; without contrast" },
  { code: "73206", desc: "CT angiography, upper extremity" },
  { code: "72125", desc: "CT, cervical spine; without contrast" },
  { code: "72126", desc: "CT, cervical spine; with contrast" },
  { code: "72127", desc: "CT, cervical spine; without and with contrast" },
  { code: "72128", desc: "CT, thoracic spine; without contrast" },
  { code: "72129", desc: "CT, thoracic spine; with contrast" },
  { code: "72130", desc: "CT, thoracic spine; without and with contrast" },
  { code: "72131", desc: "CT, lumbar spine; without contrast" },
  { code: "72132", desc: "CT, lumbar spine; with contrast" },
  { code: "72133", desc: "CT, lumbar spine; without and with contrast" },
  { code: "72141", desc: "MRI, cervical spine; without contrast" },
  { code: "72142", desc: "MRI, cervical spine; with contrast" },
  { code: "72146", desc: "MRI, thoracic spine; without contrast" },
  { code: "72147", desc: "MRI, thoracic spine; with contrast" },
  { code: "72148", desc: "MRI, lumbar spine; without contrast" },
  { code: "72149", desc: "MRI, lumbar spine; with contrast" },
  { code: "72156", desc: "MRI, cervical spine; without and with contrast" },
  { code: "72157", desc: "MRI, thoracic spine; without and with contrast" },
  { code: "72158", desc: "MRI, lumbar spine; without and with contrast" },
  { code: "72159", desc: "MRI angiography, spinal canal and contents" },
  { code: "72170", desc: "X-ray, pelvis; 1-2 views" },
  { code: "72190", desc: "X-ray, pelvis; complete, minimum 3 views" },
  { code: "72191", desc: "CT angiography, pelvis" },
  { code: "72192", desc: "CT, pelvis; without contrast" },
  { code: "72193", desc: "CT, pelvis; with contrast" },
  { code: "72194", desc: "CT, pelvis; without and with contrast" },
  { code: "72195", desc: "MRI, pelvis; without contrast" },
  { code: "72196", desc: "MRI, pelvis; with contrast" },
  { code: "72197", desc: "MRI, pelvis; without and with contrast" },
  { code: "72200", desc: "X-ray, sacroiliac joints; less than 3 views" },
  { code: "72202", desc: "X-ray, sacroiliac joints; 3 or more views" },
  { code: "72220", desc: "X-ray, sacrum and coccyx; minimum 2 views" },
  { code: "72240", desc: "Myelography, cervical; radiological supervision and interpretation" },
  { code: "72255", desc: "Myelography, thoracic; radiological supervision and interpretation" },
  { code: "72265", desc: "Myelography, lumbosacral; radiological supervision and interpretation" },
  { code: "72270", desc: "Myelography, 2 or more spinal regions" },
  { code: "77002", desc: "Fluoroscopic guidance for needle placement" },
  { code: "77003", desc: "Fluoroscopic guidance and localization of needle or catheter tip for spine or paraspinous injections" },
  { code: "77011", desc: "CT guidance for stereotactic localization" },
  { code: "77012", desc: "CT guidance for needle placement" },
  { code: "77013", desc: "CT guidance for, and monitoring of, parenchymal tissue ablation" },
  { code: "77021", desc: "MRI guidance for needle placement" },
  { code: "77022", desc: "MRI guidance for, and monitoring of, parenchymal tissue ablation" },
  { code: "77072", desc: "Bone age studies" },
  { code: "77073", desc: "Bone length studies (orthoroentgenogram, scanogram)" },
  { code: "77074", desc: "Radiologic examination, osseous survey; limited" },
  { code: "77075", desc: "Radiologic examination, osseous survey; complete (axial and appendicular skeleton)" },
  { code: "77076", desc: "Radiologic examination, osseous survey; infant" },
  { code: "77078", desc: "CT bone density study, one or more sites" },
  { code: "77080", desc: "Dual-energy X-ray absorptiometry (DEXA), bone density study, axial skeleton" },
  { code: "77081", desc: "DEXA, bone density study; appendicular skeleton" },
  { code: "77085", desc: "DEXA, vertebral fracture assessment" },
  { code: "77086", desc: "Vertebral fracture assessment via dual-energy X-ray absorptiometry" },

  // ── Pain Management & Injections — Spine ───────────────────────────────────
  { code: "62310", desc: "Injection, single, epidural or subarachnoid; cervical or thoracic" },
  { code: "62311", desc: "Injection, single, epidural or subarachnoid; lumbar or sacral" },
  { code: "62320", desc: "Injection, interlaminar epidural or subarachnoid, cervical or thoracic; without imaging guidance" },
  { code: "62321", desc: "Injection, interlaminar epidural or subarachnoid, cervical or thoracic; with imaging guidance" },
  { code: "62322", desc: "Injection, interlaminar epidural or subarachnoid, lumbar or sacral; without imaging guidance" },
  { code: "62323", desc: "Injection, interlaminar epidural or subarachnoid, lumbar or sacral; with imaging guidance" },
  { code: "62324", desc: "Injection, interlaminar epidural or subarachnoid, cervical or thoracic; with catheter" },
  { code: "62325", desc: "Injection, interlaminar epidural or subarachnoid, cervical or thoracic; with catheter and imaging" },
  { code: "62326", desc: "Injection, interlaminar epidural or subarachnoid, lumbar or sacral; with catheter" },
  { code: "62327", desc: "Injection, interlaminar epidural or subarachnoid, lumbar or sacral; with catheter and imaging" },
  { code: "64483", desc: "Injection, anesthetic and/or steroid, transforaminal epidural; lumbar or sacral, single level" },
  { code: "64484", desc: "Injection, anesthetic and/or steroid, transforaminal epidural; lumbar or sacral, each additional level" },
  { code: "64490", desc: "Injection, diagnostic or therapeutic, paravertebral facet joint or facet joint nerve; cervical or thoracic, single level" },
  { code: "64491", desc: "Injection, facet joint nerve; cervical or thoracic, second level" },
  { code: "64492", desc: "Injection, facet joint nerve; cervical or thoracic, third and any additional levels" },
  { code: "64493", desc: "Injection, facet joint nerve; lumbar or sacral, single level" },
  { code: "64494", desc: "Injection, facet joint nerve; lumbar or sacral, second level" },
  { code: "64495", desc: "Injection, facet joint nerve; lumbar or sacral, third and any additional levels" },
  { code: "64633", desc: "Destruction by neurolytic agent, paravertebral facet joint nerve(s); cervical or thoracic, single facet joint" },
  { code: "64634", desc: "Destruction by neurolytic agent, facet joint nerve(s); cervical or thoracic, each additional facet joint" },
  { code: "64635", desc: "Destruction by neurolytic agent, facet joint nerve(s); lumbar or sacral, single facet joint" },
  { code: "64636", desc: "Destruction by neurolytic agent, facet joint nerve(s); lumbar or sacral, each additional facet joint" },
  { code: "64479", desc: "Injection, anesthetic agent and/or steroid, transforaminal epidural; cervical or thoracic, single level" },
  { code: "64480", desc: "Injection, transforaminal epidural; cervical or thoracic, each additional level" },
  { code: "64415", desc: "Injection, anesthetic agent; brachial plexus, single" },
  { code: "64416", desc: "Injection, anesthetic agent; brachial plexus, continuous infusion" },
  { code: "64417", desc: "Injection, anesthetic agent; axillary nerve" },
  { code: "64418", desc: "Injection, anesthetic agent; suprascapular nerve" },
  { code: "64420", desc: "Injection, anesthetic agent; intercostal nerve, single" },
  { code: "64421", desc: "Injection, anesthetic agent; intercostal nerves, multiple, regional block" },
  { code: "64425", desc: "Injection, anesthetic agent; ilioinguinal, iliohypogastric nerves" },
  { code: "64430", desc: "Injection, anesthetic agent; pudendal nerve" },
  { code: "64445", desc: "Injection, anesthetic agent; sciatic nerve, single" },
  { code: "64446", desc: "Injection, anesthetic agent; sciatic nerve, continuous infusion" },
  { code: "64447", desc: "Injection, anesthetic agent; femoral nerve, single" },
  { code: "64448", desc: "Injection, anesthetic agent; femoral nerve, continuous infusion" },
  { code: "64449", desc: "Injection, anesthetic agent; lumbar plexus, posterior approach" },
  { code: "64450", desc: "Injection, anesthetic agent; other peripheral nerve or branch" },
  { code: "64505", desc: "Injection, anesthetic agent; sphenopalatine ganglion" },
  { code: "64510", desc: "Injection, anesthetic agent; stellate ganglion" },
  { code: "64520", desc: "Injection, anesthetic agent; lumbar or thoracic sympathetic, paravertebral" },
  { code: "64530", desc: "Injection, anesthetic agent; celiac plexus, with or without radiologic monitoring" },

  // ── E&M and Other ─────────────────────────────────────────────────────────
  { code: "99201", desc: "Office/outpatient visit, new patient; problem-focused" },
  { code: "99202", desc: "Office/outpatient visit, new patient; expanded problem-focused" },
  { code: "99211", desc: "Office/outpatient visit, established; minimal" },
  { code: "99212", desc: "Office/outpatient visit, established; problem-focused" },
  { code: "99232", desc: "Subsequent hospital care, per day; low to moderate complexity" },
  { code: "99233", desc: "Subsequent hospital care, per day; high complexity" },
  { code: "99238", desc: "Hospital discharge day management; 30 minutes or less" },
  { code: "99239", desc: "Hospital discharge day management; more than 30 minutes" },
  { code: "99241", desc: "Office consultation; problem-focused" },
  { code: "99242", desc: "Office consultation; expanded problem-focused" },
  { code: "99243", desc: "Office consultation; detailed" },
  { code: "99244", desc: "Office consultation; comprehensive, moderate complexity" },
  { code: "99245", desc: "Office consultation; comprehensive, high complexity" },
  { code: "99251", desc: "Inpatient consultation; problem-focused" },
  { code: "99252", desc: "Inpatient consultation; expanded problem-focused" },
  { code: "99253", desc: "Inpatient consultation; detailed" },
  { code: "99254", desc: "Inpatient consultation; comprehensive, moderate complexity" },
  { code: "99255", desc: "Inpatient consultation; comprehensive, high complexity" },
  { code: "97001", desc: "Physical therapy evaluation" },
  { code: "97002", desc: "Physical therapy re-evaluation" },
  { code: "97010", desc: "Application of hot or cold packs" },
  { code: "97012", desc: "Application of traction" },
  { code: "97014", desc: "Application of electrical stimulation" },
  { code: "97016", desc: "Application of vasopneumatic devices" },
  { code: "97018", desc: "Application of paraffin bath" },
  { code: "97022", desc: "Application of whirlpool" },
  { code: "97026", desc: "Application of infrared" },
  { code: "97028", desc: "Application of ultraviolet" },
  { code: "97032", desc: "Application of electrical stimulation, manual; each 15 minutes" },
  { code: "97033", desc: "Application of electrical current (iontophoresis); each 15 minutes" },
  { code: "97034", desc: "Application of contrast baths; each 15 minutes" },
  { code: "97035", desc: "Application of ultrasound; each 15 minutes" },
  { code: "97036", desc: "Application of Hubbard tank; each 15 minutes" },
  { code: "97110", desc: "Therapeutic exercises to develop strength, endurance; each 15 minutes" },
  { code: "97112", desc: "Neuromuscular reeducation; each 15 minutes" },
  { code: "97116", desc: "Gait training; each 15 minutes" },
  { code: "97140", desc: "Manual therapy techniques; each 15 minutes" },
  { code: "97150", desc: "Therapeutic procedure(s), group (2 or more individuals)" },
  { code: "97530", desc: "Therapeutic activities to improve function; each 15 minutes" },
  { code: "97535", desc: "Self-care/home management training; each 15 minutes" },
  { code: "97750", desc: "Physical performance test or measurement; each 15 minutes" },
  { code: "97760", desc: "Orthotic management and training; initial orthotic encounter; each 15 minutes" },
  { code: "97761", desc: "Prosthetic training; initial prosthetic encounter; each 15 minutes" },
  { code: "97763", desc: "Orthotic/prosthetic management, subsequent encounter; each 15 minutes" },
  { code: "95831", desc: "Muscle testing, manual, with report; extremity (excluding hand) or trunk" },
  { code: "95832", desc: "Muscle testing, manual, with report; hand" },
  { code: "95833", desc: "Muscle testing, manual, with report; total evaluation of body" },
  { code: "95851", desc: "Range of motion measurements and report; each extremity (excluding hand) or each trunk section" },
  { code: "95852", desc: "Range of motion measurements and report; hand, with or without comparison with normal side" },
  { code: "95905", desc: "Motor and/or sensory nerve conduction, using preconfigured electrode array(s)" },
  { code: "95907", desc: "Nerve conduction studies; 1-2 studies" },
  { code: "95908", desc: "Nerve conduction studies; 3-4 studies" },
  { code: "95909", desc: "Nerve conduction studies; 5-6 studies" },
  { code: "95910", desc: "Nerve conduction studies; 7-8 studies" },
  { code: "95911", desc: "Nerve conduction studies; 9-10 studies" },
  { code: "95912", desc: "Nerve conduction studies; 11-12 studies" },
  { code: "95913", desc: "Nerve conduction studies; 13 or more studies" },
  { code: "95925", desc: "Short-latency somatosensory evoked potential study, upper limbs" },
  { code: "95926", desc: "Short-latency somatosensory evoked potential study, lower limbs" },
  { code: "95927", desc: "Short-latency somatosensory evoked potential study, central nervous system processing" },
  { code: "95928", desc: "Central motor evoked potential study, upper limbs" },
  { code: "95929", desc: "Central motor evoked potential study, lower limbs" },
  { code: "96360", desc: "Intravenous infusion, hydration; initial, 31 minutes to 1 hour" },
  { code: "96365", desc: "Intravenous infusion, for therapy; initial, up to 1 hour" },
  { code: "96372", desc: "Therapeutic, prophylactic, or diagnostic injection; subcutaneous or intramuscular" },
  { code: "96374", desc: "Therapeutic, prophylactic, or diagnostic injection; intravenous push, single or initial substance" },
  { code: "J0702", desc: "Injection, betamethasone acetate, 3 mg" },
  { code: "J1020", desc: "Injection, methylprednisolone acetate, 20 mg" },
  { code: "J1030", desc: "Injection, methylprednisolone acetate, 40 mg" },
  { code: "J1040", desc: "Injection, methylprednisolone acetate, 80 mg" },
  { code: "J1094", desc: "Injection, dexamethasone acetate, 1 mg" },
  { code: "J3301", desc: "Injection, triamcinolone acetonide, per 10 mg" },
  { code: "J7320", desc: "Hyaluronan or derivative, Synvisc or Synvisc-One, 1 mg" },
  { code: "J7321", desc: "Hyaluronan or derivative, Hyalgan or Supartz, per dose" },
  { code: "J7323", desc: "Hyaluronan or derivative, Euflexxa, per dose" },
  { code: "J7324", desc: "Hyaluronan or derivative, Orthovisc, per dose" },
  { code: "J7325", desc: "Hyaluronan or derivative, Durolane, per dose" },
  { code: "J7326", desc: "Hyaluronan or derivative, Gel-One, per dose" },
  { code: "J7327", desc: "Hyaluronan or derivative, Monovisc, per dose" },
  { code: "J7328", desc: "Hyaluronan or derivative, Gelsyn-3, per dose" },
  { code: "J7329", desc: "Hyaluronan or derivative, Triluron, per dose" },
  { code: "J7332", desc: "Hyaluronan or derivative, Trivisc, per dose" },

  // ── Flexor Tendon Reconstruction — Hand ───────────────────────────────────
  { code: "26340", desc: "Manipulation, finger joint, under anesthesia, each joint" },
  { code: "26350", desc: "Repair or advancement, flexor tendon, not in zone 2; primary or secondary, without free graft, each tendon" },
  { code: "26390", desc: "Excision of flexor tendon, with implantation of synthetic rod for delayed tendon graft, hand or finger, each rod" },
  { code: "26392", desc: "Removal of synthetic rod and insertion of flexor tendon graft, hand or finger, each tendon" },
  { code: "26476", desc: "Lengthening of tendon, extensor, hand or finger, each tendon" },
  { code: "26478", desc: "Shortening of tendon, extensor, hand or finger, each tendon" },
  { code: "26480", desc: "Transfer or transplant of tendon, carpometacarpal area or dorsum of hand; without free graft, each tendon" },
  { code: "26483", desc: "Transfer or transplant of tendon, carpometacarpal area or dorsum of hand; with free tendon graft, each tendon" },
  { code: "26500", desc: "Reconstruction of tendon pulley, each pulley" },
  { code: "26596", desc: "Excision of constricting ring of finger, with multiple Z-plasties" },

  // ── Wrist — Additional Procedures ─────────────────────────────────────────
  { code: "25040", desc: "Arthrotomy, radiocarpal or midcarpal joint, with exploration, drainage, or removal of foreign body" },
  { code: "25041", desc: "Arthrotomy, radiocarpal or midcarpal joint, with synovectomy" },
  { code: "25085", desc: "Capsulotomy, wrist, open" },
  { code: "25118", desc: "Synovectomy, extensor tendon sheath, wrist, radical" },
  { code: "25119", desc: "Synovectomy, extensor tendon sheath, wrist, radical; with resection of distal ulna" },
  { code: "25120", desc: "Excision or curettage of bone cyst or benign tumor, radius or ulna" },
  { code: "25125", desc: "Excision or curettage of bone cyst or benign tumor, radius or ulna; with autograft" },
  { code: "25130", desc: "Excision or curettage of bone cyst or benign tumor, carpal bones" },
  { code: "25136", desc: "Excision or curettage of bone cyst or benign tumor, carpal bones; with autograft" },
  { code: "25145", desc: "Sequestrectomy, forearm and/or wrist" },
  { code: "25151", desc: "Incision and drainage, forearm and/or wrist area; deep abscess or hematoma, subfascial" },
  { code: "25170", desc: "Radical resection of tumor, radius or ulna" },
  { code: "25176", desc: "Radical resection of tumor, distal radius or ulna" },
  { code: "25210", desc: "Carpectomy; 1 bone" },
  { code: "25215", desc: "Carpectomy; all bones of proximal row" },
  { code: "25230", desc: "Radial styloidectomy; separate procedure" },
  { code: "25240", desc: "Excision, distal ulna partial (e.g., Darrach type)" },
  { code: "25246", desc: "Injection procedure for wrist arthrography" },
  { code: "25248", desc: "Exploration with removal of deep foreign body, forearm or wrist" },
  { code: "25250", desc: "Removal of wrist prosthesis; (separate procedure)" },
  { code: "25251", desc: "Removal of wrist prosthesis; complicated" },
  { code: "25252", desc: "Removal of wrist prosthesis; with insertion of spacer" },
  { code: "25260", desc: "Repair of tendon or muscle, flexor, forearm and/or wrist; primary, single, each tendon or muscle" },
  { code: "25263", desc: "Repair of tendon or muscle, flexor, forearm and/or wrist; secondary, single, each tendon or muscle" },
  { code: "25265", desc: "Repair of tendon or muscle, flexor, forearm and/or wrist; secondary, with free graft, each tendon or muscle" },
  { code: "25270", desc: "Repair of tendon or muscle, extensor, forearm and/or wrist; primary, single, each tendon or muscle" },
  { code: "25272", desc: "Repair of tendon or muscle, extensor, forearm and/or wrist; secondary, single, each tendon or muscle" },
  { code: "25274", desc: "Repair of tendon or muscle, extensor, forearm and/or wrist; secondary, with free graft, each tendon or muscle" },
  { code: "25275", desc: "Repair of tendon sheath, extensor, forearm and/or wrist, with free graft" },
  { code: "25280", desc: "Lengthening or shortening of flexor or extensor tendon, forearm and/or wrist, single" },
  { code: "25290", desc: "Tenotomy, open, flexor or extensor tendon, forearm and/or wrist, single" },
  { code: "25295", desc: "Tenolysis, flexor or extensor tendon, forearm and/or wrist, single, each tendon" },
  { code: "25300", desc: "Tenodesis at wrist; flexors of fingers" },
  { code: "25301", desc: "Tenodesis at wrist; extensors of fingers" },
  { code: "25310", desc: "Tendon transplantation or transfer, flexor or extensor, forearm and/or wrist, single; each tendon" },
  { code: "25312", desc: "Tendon transplantation or transfer, flexor or extensor, forearm and/or wrist, single; with tendon graft, each tendon" },
  { code: "25315", desc: "Flexor origin slide (e.g., for cerebral palsy, Volkmann contracture), forearm and/or wrist; single" },
  { code: "25316", desc: "Flexor origin slide; multiple" },
  { code: "25320", desc: "Capsulorrhaphy or reconstruction, wrist, open; any method" },
  { code: "25335", desc: "Centralization of wrist on ulna" },
  { code: "25337", desc: "Reconstruction for stabilization of unstable distal ulna or distal radioulnar joint, secondary; with tendon graft" },
  { code: "25350", desc: "Osteotomy, radius; distal third" },
  { code: "25355", desc: "Osteotomy, radius; middle or proximal third" },
  { code: "25360", desc: "Osteotomy, ulna" },
  { code: "25365", desc: "Osteotomy; radius AND ulna" },
  { code: "25370", desc: "Multiple osteotomies, with realignment on intramedullary rod, radius OR ulna" },
  { code: "25375", desc: "Multiple osteotomies, with realignment on intramedullary rod, radius AND ulna" },
  { code: "25390", desc: "Osteoplasty, radius OR ulna; shortening" },
  { code: "25391", desc: "Osteoplasty, radius OR ulna; lengthening with autograft" },
  { code: "25392", desc: "Osteoplasty, radius AND ulna; shortening" },
  { code: "25393", desc: "Osteoplasty, radius AND ulna; lengthening with autograft" },
  { code: "25394", desc: "Osteoplasty, carpal bone, shortening" },
  { code: "25395", desc: "Repair of nonunion or malunion, radius OR ulna; without graft" },
  { code: "25396", desc: "Repair of nonunion or malunion, radius OR ulna; with autograft" },
  { code: "25820", desc: "Arthrodesis, wrist; limited, without bone graft" },
  { code: "25825", desc: "Arthrodesis, wrist; with autograft" },
  { code: "25830", desc: "Arthrodesis, distal radioulnar joint with resection of distal ulna, with or without bone graft" },
  { code: "25900", desc: "Amputation, forearm, through radius and ulna" },
  { code: "25905", desc: "Amputation, forearm, through radius and ulna; open, circular" },
  { code: "25907", desc: "Amputation, forearm, through radius and ulna; secondary closure or scar revision" },
  { code: "25909", desc: "Amputation, forearm, through radius and ulna; re-amputation" },
  { code: "25920", desc: "Disarticulation through wrist" },
  { code: "25922", desc: "Disarticulation through wrist; secondary closure or scar revision" },
  { code: "25924", desc: "Disarticulation through wrist; re-amputation" },
  { code: "25927", desc: "Transmetacarpal amputation" },
  { code: "25929", desc: "Transmetacarpal amputation; secondary closure or scar revision" },
  { code: "25931", desc: "Transmetacarpal amputation; re-amputation" },
  { code: "25945", desc: "Unlisted procedure, surgery of the wrist" },
];
